/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDateTime: { input: Date; output: Date; }
  AWSJSON: { input: unknown; output: unknown; }
  Long: { input: number; output: number; }
};

export type AwsDateTimeFilterInput = {
  readonly _eq?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _gt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _gte?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['AWSDateTime']['input']>>;
  readonly _lt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _lte?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _neq?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['AWSDateTime']['input']>>;
};

export type AgentPostPassReport = {
  readonly __typename?: 'AgentPostPassReport';
  readonly agentId: Scalars['String']['output'];
  readonly markdownText: Scalars['String']['output'];
  readonly s3Key: Scalars['String']['output'];
  readonly taskDocumentId: Scalars['String']['output'];
};

export type Aggregation = {
  readonly __typename?: 'Aggregation';
  readonly _avg: Scalars['Float']['output'];
  readonly _max: Scalars['Float']['output'];
  readonly _min: Scalars['Float']['output'];
  readonly _p1: Scalars['Float']['output'];
  readonly _p5: Scalars['Float']['output'];
  readonly _p25: Scalars['Float']['output'];
  readonly _p50: Scalars['Float']['output'];
  readonly _p75: Scalars['Float']['output'];
  readonly _p95: Scalars['Float']['output'];
  readonly _p99: Scalars['Float']['output'];
  readonly _stdDev: Scalars['Float']['output'];
  readonly _sum: Scalars['Float']['output'];
};

export enum AngleUnits {
  DegreeAngle = 'DEGREE_ANGLE',
  Radian = 'RADIAN'
}

export type AntennaDownlinkConfigData = {
  readonly __typename?: 'AntennaDownlinkConfigData';
  readonly bandwidth: Frequency;
  readonly centerFrequency: Frequency;
  readonly polarity: Polarization;
};

export type AntennaDownlinkConfigDataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<AntennaDownlinkConfigDataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<AntennaDownlinkConfigDataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<AntennaDownlinkConfigDataFilterInput>>;
  readonly bandwidth?: InputMaybe<FrequencyFilterInput>;
  readonly centerFrequency?: InputMaybe<FrequencyFilterInput>;
  readonly polarity?: InputMaybe<PolarizationFilterInput>;
};

export type AntennaDownlinkConfigDataSortInput = {
  readonly bandwidth?: InputMaybe<FrequencySortInput>;
  readonly centerFrequency?: InputMaybe<FrequencySortInput>;
  readonly polarity?: InputMaybe<SortOrder>;
};

export type AntennaDownlinkDemodDecodeConfigData = {
  readonly __typename?: 'AntennaDownlinkDemodDecodeConfigData';
  readonly bandwidth: Frequency;
  readonly centerFrequency: Frequency;
  readonly decodeConfig?: Maybe<DecodeConfigData>;
  readonly demodulationConfig?: Maybe<DemodulationConfigData>;
  readonly polarity: Polarization;
};

export type AntennaDownlinkDemodDecodeConfigDataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<AntennaDownlinkDemodDecodeConfigDataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<AntennaDownlinkDemodDecodeConfigDataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<AntennaDownlinkDemodDecodeConfigDataFilterInput>>;
  readonly bandwidth?: InputMaybe<FrequencyFilterInput>;
  readonly centerFrequency?: InputMaybe<FrequencyFilterInput>;
  readonly decodeConfig?: InputMaybe<DecodeConfigDataFilterInput>;
  readonly demodulationConfig?: InputMaybe<DemodulationConfigDataFilterInput>;
  readonly polarity?: InputMaybe<PolarizationFilterInput>;
};

export type AntennaDownlinkDemodDecodeConfigDataSortInput = {
  readonly bandwidth?: InputMaybe<FrequencySortInput>;
  readonly centerFrequency?: InputMaybe<FrequencySortInput>;
  readonly decodeConfig?: InputMaybe<DecodeConfigDataSortInput>;
  readonly demodulationConfig?: InputMaybe<DemodulationConfigDataSortInput>;
  readonly polarity?: InputMaybe<SortOrder>;
};

export type AntennaUplinkConfigData = {
  readonly __typename?: 'AntennaUplinkConfigData';
  readonly centerFrequency: Frequency;
  readonly polarity: Polarization;
  readonly targetEirp: Measure;
  readonly transmitDisabled?: Maybe<Scalars['Boolean']['output']>;
};

export type AntennaUplinkConfigDataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<AntennaUplinkConfigDataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<AntennaUplinkConfigDataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<AntennaUplinkConfigDataFilterInput>>;
  readonly centerFrequency?: InputMaybe<FrequencyFilterInput>;
  readonly polarity?: InputMaybe<PolarizationFilterInput>;
  readonly targetEirp?: InputMaybe<MeasureFilterInput>;
  readonly transmitDisabled?: InputMaybe<BooleanFilterInput>;
};

export type AntennaUplinkConfigDataSortInput = {
  readonly centerFrequency?: InputMaybe<FrequencySortInput>;
  readonly polarity?: InputMaybe<SortOrder>;
  readonly targetEirp?: InputMaybe<MeasureSortInput>;
  readonly transmitDisabled?: InputMaybe<SortOrder>;
};

export type AutoTrack = {
  readonly __typename?: 'AutoTrack';
  readonly criticality?: Maybe<Criticality>;
};

export type AutoTrackFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<AutoTrackFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<AutoTrackFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<AutoTrackFilterInput>>;
  readonly criticality?: InputMaybe<CriticalityFilterInput>;
};

export type AutoTrackSettings = {
  readonly __typename?: 'AutoTrackSettings';
  readonly autoTrack?: Maybe<AutoTrack>;
};

export type AutoTrackSettingsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<AutoTrackSettingsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<AutoTrackSettingsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<AutoTrackSettingsFilterInput>>;
  readonly autoTrack?: InputMaybe<AutoTrackFilterInput>;
};

export type AutoTrackSettingsSortInput = {
  readonly autoTrack?: InputMaybe<AutoTrackSortInput>;
};

export type AutoTrackSortInput = {
  readonly criticality?: InputMaybe<SortOrder>;
};

export type AzElProgramTrackSettings = {
  readonly __typename?: 'AzElProgramTrackSettings';
  readonly ephemerisId: Scalars['String']['output'];
};

export type AzElProgramTrackSettingsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<AzElProgramTrackSettingsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<AzElProgramTrackSettingsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<AzElProgramTrackSettingsFilterInput>>;
  readonly ephemerisId?: InputMaybe<StringFilterInput>;
};

export type AzElProgramTrackSettingsSortInput = {
  readonly ephemerisId?: InputMaybe<SortOrder>;
};

export type BooleanFilterInput = {
  readonly _eq?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BucketData = {
  readonly __typename?: 'BucketData';
  readonly arn: Scalars['String']['output'];
  readonly region?: Maybe<Scalars['String']['output']>;
};

export type BucketDataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<BucketDataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<BucketDataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<BucketDataFilterInput>>;
  readonly arn?: InputMaybe<StringFilterInput>;
  readonly region?: InputMaybe<StringFilterInput>;
};

export type BucketDataSortInput = {
  readonly arn?: InputMaybe<SortOrder>;
  readonly region?: InputMaybe<SortOrder>;
};

export type BusinessInsightsContact = {
  readonly __typename?: 'BusinessInsightsContact';
  /** The name of the antenna involved in the contact. */
  readonly antennaName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the contact. Acts as a primary key for this structure. */
  readonly contactId: Scalars['String']['output'];
  /** This represents the status of a contact. */
  readonly contactStatus: ContactStatus;
  /** This represents the AWS Customer ID which owns the contact. */
  readonly customerId: Scalars['String']['output'];
  /** This field represents which region(s) that data was delivered to. */
  readonly dataDeliveryRegions?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** A list of abstractions for how data is transferred within the service on behalf of the customer. */
  readonly dataflowList?: Maybe<ReadonlyArray<Dataflow>>;
  /** The end-time epoch of the contact. This does not include any post-pass time. This field acts as a secondary field for recording. That is, it is used when a time-partition of contacts is needed. (e.g. search, expiration, etc)  */
  readonly endTime: Scalars['AWSDateTime']['output'];
  /** The airport code associated with the ground station region being used. */
  readonly groundStationAirportCode?: Maybe<Scalars['String']['output']>;
  /** An abstraction for what location was primarily targeted for utilization */
  readonly groundStationName?: Maybe<Scalars['String']['output']>;
  /** Maximum elevation (degrees) */
  readonly maximumElevation?: Maybe<Elevation>;
  /** An abstraction for the expectations of the contact including dataflows and tracking. */
  readonly missionProfileArn?: Maybe<Scalars['String']['output']>;
  /** Post-pass time of the contact epoch in seconds. */
  readonly postPassEndTime?: Maybe<Scalars['AWSDateTime']['output']>;
  /** Pre-pass start time of the contact epoch in seconds. */
  readonly prePassStartTime?: Maybe<Scalars['AWSDateTime']['output']>;
  /** An abstraction for what was utilized in this contact. e.g. antenna, recordings, sdrs. This allows us to extend what entities were involved in a contact. */
  readonly reservationArns?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** An abstraction for the vehicle involved in the contact. */
  readonly satelliteArn?: Maybe<Scalars['String']['output']>;
  readonly schedulingRegion?: Maybe<Scalars['String']['output']>;
  /** The start time epoch of the contact. This does not include any pre-pass time. */
  readonly startTime: Scalars['AWSDateTime']['output'];
};

export type Config = {
  readonly __typename?: 'Config';
  readonly accountId: Scalars['String']['output'];
  readonly data: ConfigData;
  readonly expirationTime?: Maybe<Scalars['AWSDateTime']['output']>;
  readonly id: Scalars['String']['output'];
  readonly internalCreatorAccountId?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly region: Scalars['String']['output'];
  readonly timestamp: Scalars['AWSDateTime']['output'];
  readonly type: ConfigType;
  readonly version: Scalars['Int']['output'];
};

export type ConfigAggregation = {
  readonly __typename?: 'ConfigAggregation';
  readonly version: Aggregation;
};

export enum ConfigCapabilityType {
  AntennaDownlink = 'ANTENNA_DOWNLINK',
  AntennaDownlinkDemodDecode = 'ANTENNA_DOWNLINK_DEMOD_DECODE',
  AntennaUplink = 'ANTENNA_UPLINK',
  ConnectionProxy = 'CONNECTION_PROXY',
  DataflowEndpoint = 'DATAFLOW_ENDPOINT',
  ManagedAntennaDownlinkDemodDecode = 'MANAGED_ANTENNA_DOWNLINK_DEMOD_DECODE',
  S3Playback = 'S3_PLAYBACK',
  S3Recording = 'S3_RECORDING',
  TelemetrySink = 'TELEMETRY_SINK',
  Tracking = 'TRACKING',
  UplinkEcho = 'UPLINK_ECHO'
}

export type ConfigData = {
  readonly __typename?: 'ConfigData';
  readonly antennaDownlink?: Maybe<AntennaDownlinkConfigData>;
  readonly antennaDownlinkDemodDecode?: Maybe<AntennaDownlinkDemodDecodeConfigData>;
  readonly antennaUplink?: Maybe<AntennaUplinkConfigData>;
  readonly dataflowEndpoint?: Maybe<DataflowEndpointConfigData>;
  readonly managedAntennaDownlinkDemodDecode?: Maybe<ManagedAntennaDownlinkDemodDecodeConfigData>;
  readonly s3Playback?: Maybe<S3PlaybackConfigData>;
  readonly s3Recording?: Maybe<S3RecordingConfigData>;
  readonly telemetrySink?: Maybe<TelemetrySinkData>;
  readonly tracking?: Maybe<TrackingConfigData>;
  readonly uplinkEcho?: Maybe<UplinkEchoConfigData>;
};

export type ConfigDataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<ConfigDataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<ConfigDataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<ConfigDataFilterInput>>;
  readonly antennaDownlink?: InputMaybe<AntennaDownlinkConfigDataFilterInput>;
  readonly antennaDownlinkDemodDecode?: InputMaybe<AntennaDownlinkDemodDecodeConfigDataFilterInput>;
  readonly antennaUplink?: InputMaybe<AntennaUplinkConfigDataFilterInput>;
  readonly dataflowEndpoint?: InputMaybe<DataflowEndpointConfigDataFilterInput>;
  readonly managedAntennaDownlinkDemodDecode?: InputMaybe<ManagedAntennaDownlinkDemodDecodeConfigDataFilterInput>;
  readonly s3Playback?: InputMaybe<S3PlaybackConfigDataFilterInput>;
  readonly s3Recording?: InputMaybe<S3RecordingConfigDataFilterInput>;
  readonly telemetrySink?: InputMaybe<TelemetrySinkDataFilterInput>;
  readonly tracking?: InputMaybe<TrackingConfigDataFilterInput>;
  readonly uplinkEcho?: InputMaybe<UplinkEchoConfigDataFilterInput>;
};

export type ConfigDataSortInput = {
  readonly antennaDownlink?: InputMaybe<AntennaDownlinkConfigDataSortInput>;
  readonly antennaDownlinkDemodDecode?: InputMaybe<AntennaDownlinkDemodDecodeConfigDataSortInput>;
  readonly antennaUplink?: InputMaybe<AntennaUplinkConfigDataSortInput>;
  readonly dataflowEndpoint?: InputMaybe<DataflowEndpointConfigDataSortInput>;
  readonly managedAntennaDownlinkDemodDecode?: InputMaybe<ManagedAntennaDownlinkDemodDecodeConfigDataSortInput>;
  readonly s3Playback?: InputMaybe<S3PlaybackConfigDataSortInput>;
  readonly s3Recording?: InputMaybe<S3RecordingConfigDataSortInput>;
  readonly telemetrySink?: InputMaybe<TelemetrySinkDataSortInput>;
  readonly tracking?: InputMaybe<TrackingConfigDataSortInput>;
  readonly uplinkEcho?: InputMaybe<UplinkEchoConfigDataSortInput>;
};

export type ConfigFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<ConfigFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<ConfigFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<ConfigFilterInput>>;
  readonly accountId?: InputMaybe<StringFilterInput>;
  readonly data?: InputMaybe<ConfigDataFilterInput>;
  readonly expirationTime?: InputMaybe<TimestampFilterInput>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly internalCreatorAccountId?: InputMaybe<StringFilterInput>;
  readonly name?: InputMaybe<StringFilterInput>;
  readonly region?: InputMaybe<StringFilterInput>;
  readonly timestamp?: InputMaybe<TimestampFilterInput>;
  readonly type?: InputMaybe<ConfigTypeFilterInput>;
  readonly version?: InputMaybe<IntegerFilterInput>;
};

export type ConfigIdToDagNodeMapEntry = {
  readonly __typename?: 'ConfigIdToDagNodeMapEntry';
  readonly key?: Maybe<Scalars['String']['output']>;
  readonly value?: Maybe<DagNode>;
};

export type ConfigSortInput = {
  readonly accountId?: InputMaybe<SortOrder>;
  readonly data?: InputMaybe<ConfigDataSortInput>;
  readonly expirationTime?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly internalCreatorAccountId?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
  readonly region?: InputMaybe<SortOrder>;
  readonly timestamp?: InputMaybe<SortOrder>;
  readonly type?: InputMaybe<SortOrder>;
  readonly version?: InputMaybe<SortOrder>;
};

export enum ConfigType {
  AntennaDownlink = 'ANTENNA_DOWNLINK',
  AntennaDownlinkDemodDecode = 'ANTENNA_DOWNLINK_DEMOD_DECODE',
  AntennaUplink = 'ANTENNA_UPLINK',
  DataflowEndpoint = 'DATAFLOW_ENDPOINT',
  ManagedAntennaDownlinkDemodDecode = 'MANAGED_ANTENNA_DOWNLINK_DEMOD_DECODE',
  S3Playback = 'S3_PLAYBACK',
  S3Recording = 'S3_RECORDING',
  TelemetrySink = 'TELEMETRY_SINK',
  Tracking = 'TRACKING',
  UplinkEcho = 'UPLINK_ECHO'
}

export type ConfigTypeFilterInput = {
  readonly _eq?: InputMaybe<ConfigType>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<ConfigType>>;
  readonly _neq?: InputMaybe<ConfigType>;
  readonly _nin?: InputMaybe<ReadonlyArray<ConfigType>>;
};

export type Contact = {
  readonly __typename?: 'Contact';
  readonly agentPostPassReports?: Maybe<ReadonlyArray<AgentPostPassReport>>;
  readonly dataplaneReport?: Maybe<DataplaneReport>;
  readonly id: Scalars['String']['output'];
  readonly images?: Maybe<ReadonlyArray<PostPassImage>>;
  readonly laminarFlowPlots?: Maybe<ReadonlyArray<LaminarFlowPlot>>;
  readonly tracerouteDetails?: Maybe<TracerouteDetails>;
  readonly visualization?: Maybe<ContactVisualization>;
};

export type ContactByIdInput = {
  readonly id: Scalars['String']['input'];
};

export enum ContactEphemerisUsageType {
  DailyEphemerisRefreshPointingAngle = 'DAILY_EPHEMERIS_REFRESH_POINTING_ANGLE',
  DailyEphemerisRefreshValidateVisibility = 'DAILY_EPHEMERIS_REFRESH_VALIDATE_VISIBILITY',
  FinalPointingAngle = 'FINAL_POINTING_ANGLE',
  FinalPointingAngleReference = 'FINAL_POINTING_ANGLE_REFERENCE',
  Scheduling = 'SCHEDULING'
}

export type ContactEphemerisUsageTypeFilterInput = {
  readonly _eq?: InputMaybe<ContactEphemerisUsageType>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<ContactEphemerisUsageType>>;
  readonly _neq?: InputMaybe<ContactEphemerisUsageType>;
  readonly _nin?: InputMaybe<ReadonlyArray<ContactEphemerisUsageType>>;
};

export type ContactGlobalDdbTableV2 = {
  readonly __typename?: 'ContactGlobalDDBTableV2';
  /** The customer-side AWS Account ID */
  readonly awsAccountId: Scalars['String']['output'];
  /** Reason for cancelling. */
  readonly cancellationReason?: Maybe<Scalars['String']['output']>;
  /** Cancellation timestamp of the record. Note originally in string format. */
  readonly cancellationTimestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  readonly capabilitiesToTest?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly configIdToDagNodeMap?: Maybe<ReadonlyArray<ConfigIdToDagNodeMapEntry>>;
  /** End time of the contact epoch in seconds. This does not include any postpass times. */
  readonly contactEndTimeEpochSeconds: Scalars['AWSDateTime']['output'];
  /** The contact identifier. */
  readonly contactId: Scalars['String']['output'];
  /** Start time of the contact epoch in seconds. This does not include any prepass times. */
  readonly contactStartTimeEpochSeconds: Scalars['AWSDateTime']['output'];
  /** Contact status */
  readonly contactStatus: ContactStatus;
  /** Contact type */
  readonly contactType: ContactType;
  /** Signature Map for the Contact */
  readonly createReservationForRegionSignatureMaps?: Maybe<Scalars['String']['output']>;
  /** Create timestamp of the record. Note originally in string format. */
  readonly createTimestamp: Scalars['AWSDateTime']['output'];
  /** AWS region of creation */
  readonly createdInRegion: Scalars['String']['output'];
  /** List storing EphemerisInfo objects storing info about the ephemeris used for scheduling, daily ephemeris refresh validate visibility or pointing angle, and final pointing angle calculations */
  readonly ephemerisInfoList?: Maybe<ReadonlyArray<EphemerisInfo>>;
  readonly failedToScheduleReasons?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The ground station ID */
  readonly groundStationId: Scalars['String']['output'];
  /** Maximum elevation (degrees) */
  readonly maxElevationDegrees: Scalars['Float']['output'];
  /** Metering Archive ID */
  readonly meteringArchiveId?: Maybe<Scalars['String']['output']>;
  /** Metering Status */
  readonly meteringStatus?: Maybe<MeteringStatus>;
  /** Metering Archive ID */
  readonly meteringUsage?: Maybe<MeteringUsage>;
  /** Migration version. */
  readonly migrationVersion?: Maybe<Scalars['Int']['output']>;
  /** Mission Profile AWS Resource Name */
  readonly missionProfileArn: Scalars['String']['output'];
  readonly obsoleteReservationArnList?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Payer Token */
  readonly payerToken?: Maybe<Scalars['String']['output']>;
  /** Post-pass time of the contact epoch in seconds. */
  readonly postPassEndTimeEpochSeconds: Scalars['AWSDateTime']['output'];
  /** Pre-pass start time of the contact epoch in seconds. */
  readonly prePassStartTimeEpochSeconds: Scalars['AWSDateTime']['output'];
  /** Rescheduling timestamp of the record. Note originally in string format. */
  readonly reschedulingTimestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  readonly reservationArnList?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Reserve Contact Step Function ID */
  readonly reserveContactStepFunctionId: Scalars['String']['output'];
  /** Satellite AWS Resource Name */
  readonly satelliteArn?: Maybe<Scalars['String']['output']>;
  /** Signature Map for the Contact */
  readonly signatureMap?: Maybe<Scalars['String']['output']>;
  /** AWS region of creation */
  readonly targetRegion: Scalars['String']['output'];
  /** List of RouteIds created in CapTel Routing Service for telemetry delivery */
  readonly telemetryRouteList?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Update timestamp of the record. Note originally in string format. */
  readonly updateTimestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  /** Version number of the record. */
  readonly versionNumber: Scalars['Int']['output'];
  /** Version timestamp of the record. */
  readonly versionTimestamp?: Maybe<Scalars['AWSDateTime']['output']>;
};

export enum ContactStatus {
  Available = 'AVAILABLE',
  AwsCancelled = 'AWS_CANCELLED',
  AwsFailed = 'AWS_FAILED',
  Cancelled = 'CANCELLED',
  Cancelling = 'CANCELLING',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  FailedToSchedule = 'FAILED_TO_SCHEDULE',
  Pass = 'PASS',
  Postpass = 'POSTPASS',
  Prepass = 'PREPASS',
  Scheduled = 'SCHEDULED',
  Scheduling = 'SCHEDULING'
}

export type ContactStatusFilterInput = {
  readonly _eq?: InputMaybe<ContactStatus>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<ContactStatus>>;
  readonly _neq?: InputMaybe<ContactStatus>;
  readonly _nin?: InputMaybe<ReadonlyArray<ContactStatus>>;
};

export type ContactTable = {
  readonly __typename?: 'ContactTable';
  /** Populated only when sk=CONSUMER-BUSINESS-INSIGHTS-CONTACT */
  readonly businessInsightsContact?: Maybe<BusinessInsightsContact>;
  /** Populated only when sk=SOURCE-KINESIS-CP-CONTACTGLOBALDDBTABLEV2 */
  readonly contactGlobalDDBTableV2Dto?: Maybe<ContactGlobalDdbTableV2>;
  /** time to live attribute */
  readonly datalakeTtl: Scalars['AWSDateTime']['output'];
  /** Populated only when sk=SOURCE_KINESIS_CP_INREGIONCONTACTDDBTABLE */
  readonly inRegionContactDdbTable?: Maybe<InRegionContactDdbTable>;
  /** pk = Primary Key = Contact ID */
  readonly pk: Scalars['String']['output'];
  /** sk = Sort Key = ContactTableSources Enum */
  readonly sk: Scalars['String']['output'];
  /** Version Attribute used for optimistic locking. */
  readonly version?: Maybe<Scalars['Int']['output']>;
};

export enum ContactType {
  AntennaSpecific = 'ANTENNA_SPECIFIC',
  GroundStationSpecific = 'GROUND_STATION_SPECIFIC'
}

export type ContactVersion = {
  readonly __typename?: 'ContactVersion';
  /** Timestamp when this version became active. */
  readonly activatedTimestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  /** AWS Account ID. */
  readonly awsAccountId: Scalars['String']['output'];
  readonly contactId: Scalars['String']['output'];
  readonly contactVersion: Scalars['Int']['output'];
  /** Timestamp when this version was created. */
  readonly createdTimestamp: Scalars['AWSDateTime']['output'];
  /** TTL expiration time in epoch seconds for automatic item deletion. */
  readonly expirationTime: Scalars['AWSDateTime']['output'];
  /** Failure code if the version failed to update. */
  readonly failureCode?: Maybe<Scalars['String']['output']>;
  /** Failure message if the version failed to update. */
  readonly failureMessage?: Maybe<Scalars['String']['output']>;
  /** Ground Station ID. */
  readonly groundStationId: Scalars['String']['output'];
  readonly id: Scalars['String']['output'];
  /** Satellite ARN. */
  readonly satelliteArn?: Maybe<Scalars['String']['output']>;
  /** Status of the contact version. */
  readonly status: ContactVersionStatus;
  /** Timestamp when this version was superseded by a newer version. */
  readonly supersededTimestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  /** Version timestamp indicating update time of this record. */
  readonly timestamp: Scalars['AWSDateTime']['output'];
  /** Tracking overrides for this contact version. */
  readonly trackingOverrides?: Maybe<TrackingOverrides>;
  /** ARN of the state machine that handles the update for this version. */
  readonly updateContactStateMachineArn?: Maybe<Scalars['String']['output']>;
  /** Version number indicating the number of updates made to this record. */
  readonly version: Scalars['Int']['output'];
};

export type ContactVersionAggregation = {
  readonly __typename?: 'ContactVersionAggregation';
  readonly contactVersion: Aggregation;
  readonly version: Aggregation;
};

export type ContactVersionFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<ContactVersionFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<ContactVersionFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<ContactVersionFilterInput>>;
  readonly activatedTimestamp?: InputMaybe<TimestampFilterInput>;
  readonly awsAccountId?: InputMaybe<StringFilterInput>;
  readonly contactId?: InputMaybe<StringFilterInput>;
  readonly contactVersion?: InputMaybe<IntegerFilterInput>;
  readonly createdTimestamp?: InputMaybe<TimestampFilterInput>;
  readonly expirationTime?: InputMaybe<TimestampFilterInput>;
  readonly failureCode?: InputMaybe<StringFilterInput>;
  readonly failureMessage?: InputMaybe<StringFilterInput>;
  readonly groundStationId?: InputMaybe<StringFilterInput>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly satelliteArn?: InputMaybe<StringFilterInput>;
  readonly status?: InputMaybe<ContactVersionStatusFilterInput>;
  readonly supersededTimestamp?: InputMaybe<TimestampFilterInput>;
  readonly timestamp?: InputMaybe<TimestampFilterInput>;
  readonly trackingOverrides?: InputMaybe<TrackingOverridesFilterInput>;
  readonly updateContactStateMachineArn?: InputMaybe<StringFilterInput>;
  readonly version?: InputMaybe<IntegerFilterInput>;
};

export type ContactVersionSortInput = {
  readonly activatedTimestamp?: InputMaybe<SortOrder>;
  readonly awsAccountId?: InputMaybe<SortOrder>;
  readonly contactId?: InputMaybe<SortOrder>;
  readonly contactVersion?: InputMaybe<SortOrder>;
  readonly createdTimestamp?: InputMaybe<SortOrder>;
  readonly expirationTime?: InputMaybe<SortOrder>;
  readonly failureCode?: InputMaybe<SortOrder>;
  readonly failureMessage?: InputMaybe<SortOrder>;
  readonly groundStationId?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly satelliteArn?: InputMaybe<SortOrder>;
  readonly status?: InputMaybe<SortOrder>;
  readonly supersededTimestamp?: InputMaybe<SortOrder>;
  readonly timestamp?: InputMaybe<SortOrder>;
  readonly trackingOverrides?: InputMaybe<TrackingOverridesSortInput>;
  readonly updateContactStateMachineArn?: InputMaybe<SortOrder>;
  readonly version?: InputMaybe<SortOrder>;
};

export enum ContactVersionStatus {
  Active = 'ACTIVE',
  FailedToUpdate = 'FAILED_TO_UPDATE',
  Superseded = 'SUPERSEDED',
  Updating = 'UPDATING'
}

export type ContactVersionStatusFilterInput = {
  readonly _eq?: InputMaybe<ContactVersionStatus>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<ContactVersionStatus>>;
  readonly _neq?: InputMaybe<ContactVersionStatus>;
  readonly _nin?: InputMaybe<ReadonlyArray<ContactVersionStatus>>;
};

export type ContactVisualization = {
  readonly __typename?: 'ContactVisualization';
  readonly dataplaneSvgUrlDark?: Maybe<Scalars['String']['output']>;
  readonly dataplaneSvgUrlLight?: Maybe<Scalars['String']['output']>;
  readonly s3Key?: Maybe<Scalars['String']['output']>;
};

export type CpContactEvent010 = {
  readonly __typename?: 'CpContactEvent010';
  /** The unique identifier associated with Contacts. This can be used to unambiguously fetch a Contact. */
  readonly contactId: Scalars['String']['output'];
  /** The status of the contact. Provided here to support improved event filtering. */
  readonly contactStatus: Scalars['String']['output'];
  /** The name part of the customer associated with the contact. Provided here to support improved event filtering. */
  readonly customerNamePart: Scalars['String']['output'];
};

export enum CpCriticality {
  Preferred = 'PREFERRED',
  Removed = 'REMOVED',
  Required = 'REQUIRED'
}

export enum CpDataflowType {
  Dds = 'DDS',
  DdsV2 = 'DDS_V2'
}

export enum Criticality {
  Preferred = 'PREFERRED',
  Removed = 'REMOVED',
  Required = 'REQUIRED'
}

export type CriticalityFilterInput = {
  readonly _eq?: InputMaybe<Criticality>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Criticality>>;
  readonly _neq?: InputMaybe<Criticality>;
  readonly _nin?: InputMaybe<ReadonlyArray<Criticality>>;
};

export type CursorPart = {
  readonly __typename?: 'CursorPart';
  readonly key: Scalars['String']['output'];
  readonly value: Scalars['String']['output'];
};

export type CursorPartInput = {
  readonly key: Scalars['String']['input'];
  readonly value: Scalars['String']['input'];
};

export type DdxStatistic = {
  readonly __typename?: 'DDXStatistic';
  readonly avg?: Maybe<Scalars['Float']['output']>;
  readonly median?: Maybe<Scalars['Float']['output']>;
  readonly p50?: Maybe<Scalars['Float']['output']>;
  readonly p75?: Maybe<Scalars['Float']['output']>;
  readonly p90?: Maybe<Scalars['Float']['output']>;
  readonly p95?: Maybe<Scalars['Float']['output']>;
  readonly p99?: Maybe<Scalars['Float']['output']>;
  readonly stdDev?: Maybe<Scalars['Float']['output']>;
};

export type DdxStatisticFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<DdxStatisticFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<DdxStatisticFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<DdxStatisticFilterInput>>;
  readonly avg?: InputMaybe<FloatFilterInput>;
  readonly median?: InputMaybe<FloatFilterInput>;
  readonly p50?: InputMaybe<FloatFilterInput>;
  readonly p75?: InputMaybe<FloatFilterInput>;
  readonly p90?: InputMaybe<FloatFilterInput>;
  readonly p95?: InputMaybe<FloatFilterInput>;
  readonly p99?: InputMaybe<FloatFilterInput>;
  readonly stdDev?: InputMaybe<FloatFilterInput>;
};

export type DdxStreamMetric = {
  readonly __typename?: 'DDXStreamMetric';
  readonly dataLatency?: Maybe<DdxStatistic>;
  readonly dataPacketsReceived?: Maybe<Scalars['Int']['output']>;
  readonly dataRate?: Maybe<DdxStatistic>;
  readonly streamDirection: Scalars['String']['output'];
  readonly streamId: Scalars['String']['output'];
  readonly streamName: Scalars['String']['output'];
  readonly wanLatency?: Maybe<DdxStatistic>;
  readonly wanOverhead?: Maybe<DdxStatistic>;
  readonly wanPacketsDropped?: Maybe<Scalars['Int']['output']>;
  readonly wanPacketsDuplicated?: Maybe<Scalars['Int']['output']>;
  readonly wanPacketsLost?: Maybe<Scalars['Int']['output']>;
  readonly wanPacketsReceived?: Maybe<Scalars['Int']['output']>;
  readonly wanPacketsReordered?: Maybe<Scalars['Int']['output']>;
  readonly wanPacketsRepaired?: Maybe<Scalars['Int']['output']>;
  readonly wanRate?: Maybe<DdxStatistic>;
  readonly wanRtt?: Maybe<DdxStatistic>;
};

export type DdxStreamMetricFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<DdxStreamMetricFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<DdxStreamMetricFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<DdxStreamMetricFilterInput>>;
  readonly dataLatency?: InputMaybe<DdxStatisticFilterInput>;
  readonly dataPacketsReceived?: InputMaybe<IntegerFilterInput>;
  readonly dataRate?: InputMaybe<DdxStatisticFilterInput>;
  readonly streamDirection?: InputMaybe<StringFilterInput>;
  readonly streamId?: InputMaybe<StringFilterInput>;
  readonly streamName?: InputMaybe<StringFilterInput>;
  readonly wanLatency?: InputMaybe<DdxStatisticFilterInput>;
  readonly wanOverhead?: InputMaybe<DdxStatisticFilterInput>;
  readonly wanPacketsDropped?: InputMaybe<IntegerFilterInput>;
  readonly wanPacketsDuplicated?: InputMaybe<IntegerFilterInput>;
  readonly wanPacketsLost?: InputMaybe<IntegerFilterInput>;
  readonly wanPacketsReceived?: InputMaybe<IntegerFilterInput>;
  readonly wanPacketsReordered?: InputMaybe<IntegerFilterInput>;
  readonly wanPacketsRepaired?: InputMaybe<IntegerFilterInput>;
  readonly wanRate?: InputMaybe<DdxStatisticFilterInput>;
  readonly wanRtt?: InputMaybe<DdxStatisticFilterInput>;
};

export type DagNode = {
  readonly __typename?: 'DagNode';
  /** ID of the config that this DAGNode is representing. */
  readonly configId: Scalars['String']['output'];
  /** Version to uniquely identify nodes as well as paths from source to end */
  readonly dagNodeSemanticVersion?: Maybe<Scalars['String']['output']>;
  /** If this config is a dataflow endpoint, this is endpoint details. If this config is not a dataflow endpoint this will be null. */
  readonly dataflowEndpointDetails?: Maybe<Scalars['String']['output']>;
  /** If this config is a dataflow endpoint, this is the config ID of the antenna resource for that dataflow. This is needed for generating the execution context and for executing dataflow endpoint reservations. If this config is not a dataflow endpoint this will be null. */
  readonly dataflowSourceConfigId?: Maybe<Scalars['String']['output']>;
  /** Dataflow UUID */
  readonly dataflowUuid?: Maybe<Scalars['String']['output']>;
  /** Id of the execution context for fulfilling this config */
  readonly executionContextId?: Maybe<Scalars['String']['output']>;
  /** matchedCapabilityArns */
  readonly matchedCapabilityArns?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** If this config is a dataflow endpoint, this is the config ID of the antenna resource for that dataflow. This is needed for generating the execution context and for executing dataflow endpoint reservations. If this config is not a dataflow endpoint this will be null. */
  readonly nodeConfigCapabilityType?: Maybe<ConfigCapabilityType>;
  /** A single config may be connected to multiple other configs if the config has multiple output types (for example, a demod decode mission profile will have output types in the dataflows). This maps an output type to the next config ID that it's connected to */
  readonly outputTypeToNextConfigIdsMap?: Maybe<ReadonlyArray<StringToStringMapEntry>>;
  /** A single config may be connected to multiple other configs if the config has multiple output types (for example, a demod decode mission profile will have output types in the dataflows) This maps an output type to the previous config ID that it's connected to */
  readonly outputTypeToPreviousConfigIdsMap?: Maybe<ReadonlyArray<StringToStringMapEntry>>;
  /** Region where this config needs to be reserved */
  readonly region?: Maybe<Scalars['String']['output']>;
  /** Id of the reservation for capability fulfilling this config */
  readonly reservationId?: Maybe<Scalars['String']['output']>;
  /** Status of the reservation for this Node. If no reservation has been created yet this will be null. */
  readonly reservationStatus?: Maybe<ReservationStatus>;
  /** Arn of the capability that is being reserved for this config */
  readonly reservedCapabilityArn?: Maybe<Scalars['String']['output']>;
  /** If this config is a S3 endpoint, this is endpoint details. If this config is not a S3 endpoint this will be null. */
  readonly s3RecordingDetails?: Maybe<Scalars['String']['output']>;
  /** Set of config IDs that must share the same reservation group as this config */
  readonly sameReservationGroupAsConfigIds?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** VITA 49.2 Stream ID - Id embedded in the vita 49 packet.  Stream ids flow from source to end without changing. */
  readonly vita49StreamId?: Maybe<Scalars['Int']['output']>;
};

export type DataPlaneDdxMetric = {
  readonly __typename?: 'DataPlaneDDXMetric';
  /** The account of the CPS account for the job */
  readonly accountId: Scalars['String']['output'];
  /** Unique identifier for the contact */
  readonly contactId: Scalars['String']['output'];
  readonly customerNamePart?: Maybe<Scalars['String']['output']>;
  /** The end of the contact time */
  readonly endTime: Scalars['String']['output'];
  /** Unique indentifier for the DDX job */
  readonly jobId: Scalars['String']['output'];
  /** The end of post-pass */
  readonly postPassEndTime: Scalars['String']['output'];
  /** The start time of pre-pass */
  readonly prePassStartTime: Scalars['String']['output'];
  /** The CPS region of the the account running the job */
  readonly region: Scalars['String']['output'];
  /** The start of the contact time */
  readonly startTime: Scalars['String']['output'];
  readonly streamMetrics: ReadonlyArray<DdxStreamMetric>;
};

export type DataPlaneDdxMetricFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<DataPlaneDdxMetricFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<DataPlaneDdxMetricFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<DataPlaneDdxMetricFilterInput>>;
  readonly accountId?: InputMaybe<StringFilterInput>;
  readonly contactId?: InputMaybe<StringFilterInput>;
  readonly customerNamePart?: InputMaybe<StringFilterInput>;
  readonly endTime?: InputMaybe<StringFilterInput>;
  readonly jobId?: InputMaybe<StringFilterInput>;
  readonly postPassEndTime?: InputMaybe<StringFilterInput>;
  readonly prePassStartTime?: InputMaybe<StringFilterInput>;
  readonly region?: InputMaybe<StringFilterInput>;
  readonly startTime?: InputMaybe<StringFilterInput>;
  readonly streamMetrics?: InputMaybe<DdxStreamMetricFilterInput>;
};

export type DataPlaneDdxMetricSortInput = {
  readonly accountId?: InputMaybe<SortOrder>;
  readonly contactId?: InputMaybe<SortOrder>;
  readonly customerNamePart?: InputMaybe<SortOrder>;
  readonly endTime?: InputMaybe<SortOrder>;
  readonly jobId?: InputMaybe<SortOrder>;
  readonly postPassEndTime?: InputMaybe<SortOrder>;
  readonly prePassStartTime?: InputMaybe<SortOrder>;
  readonly region?: InputMaybe<SortOrder>;
  readonly startTime?: InputMaybe<SortOrder>;
};

export type DataPlaneLfMetric = {
  readonly __typename?: 'DataPlaneLFMetric';
  readonly agentInformation?: Maybe<LaminarFlowAgentMetadata>;
  readonly agent_id: Scalars['String']['output'];
  readonly contactStatus?: Maybe<Scalars['String']['output']>;
  readonly contact_id: Scalars['String']['output'];
  readonly customerId?: Maybe<Scalars['String']['output']>;
  readonly customerNamePart?: Maybe<Scalars['String']['output']>;
  readonly dataflow_id: Scalars['String']['output'];
  readonly destinationRegion?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly lfDecryptStageMetricsV2?: Maybe<LfDecryptStageMetricsV2>;
  readonly lfEgressStageMetricsV2?: Maybe<LfEgressStageMetricsV2>;
  readonly lfEncryptStageMetricsV2?: Maybe<LfEncryptStageMetricsV2>;
  readonly lfIngressStageMetricsV2?: Maybe<LfIngressStageMetricsV2>;
  readonly lfStripeDecodeStageMetricsV2?: Maybe<LfStripeDecodeStageMetricsV2>;
  readonly lfStripeDecodeStageMetricsV3?: Maybe<LfStripeDecodeStageMetricsV3>;
  readonly lfStripeEncodeStageMetricsV2?: Maybe<LfStripeEncodeStageMetricsV2>;
  readonly lfTimeDecodeStageMetricsV2?: Maybe<LfTimeDecodeStageMetricsV2>;
  readonly lfTimeDecodeStageMetricsV3?: Maybe<LfTimeDecodeStageMetricsV3>;
  readonly lfTimeEncodeStageMetricsV2?: Maybe<LfTimeEncodeStageMetricsV2>;
  readonly lfTracerouteStageMetricsV2?: Maybe<ReadonlyArray<LfTracerouteStageMetricsV2>>;
  readonly lfWanRxStageMetricsV2?: Maybe<LfWanRxStageMetricsV2>;
  readonly lfWanTxStageMetricsV2?: Maybe<LfWanTxStageMetricsV2>;
  readonly missionProfileId?: Maybe<Scalars['String']['output']>;
  readonly rpm_version: Scalars['String']['output'];
  readonly sourceRegion?: Maybe<Scalars['String']['output']>;
  readonly task_id: Scalars['String']['output'];
  readonly timeStampEnd?: Maybe<Scalars['String']['output']>;
  readonly timeStampStart?: Maybe<Scalars['String']['output']>;
};

export type DataPlaneLfMetricAggregation = {
  readonly __typename?: 'DataPlaneLFMetricAggregation';
  readonly lfDecryptStageMetricsV2: LfDecryptStageMetricsV2Aggregation;
  readonly lfEgressStageMetricsV2: LfEgressStageMetricsV2Aggregation;
  readonly lfEncryptStageMetricsV2: LfEncryptStageMetricsV2Aggregation;
  readonly lfIngressStageMetricsV2: LfIngressStageMetricsV2Aggregation;
  readonly lfStripeDecodeStageMetricsV2: LfStripeDecodeStageMetricsV2Aggregation;
  readonly lfStripeDecodeStageMetricsV3: LfStripeDecodeStageMetricsV3Aggregation;
  readonly lfStripeEncodeStageMetricsV2: LfStripeEncodeStageMetricsV2Aggregation;
  readonly lfTimeDecodeStageMetricsV2: LfTimeDecodeStageMetricsV2Aggregation;
  readonly lfTimeDecodeStageMetricsV3: LfTimeDecodeStageMetricsV3Aggregation;
  readonly lfTimeEncodeStageMetricsV2: LfTimeEncodeStageMetricsV2Aggregation;
  readonly lfWanRxStageMetricsV2: LfWanRxStageMetricsV2Aggregation;
  readonly lfWanTxStageMetricsV2: LfWanTxStageMetricsV2Aggregation;
};

export type DataPlaneLfMetricFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<DataPlaneLfMetricFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<DataPlaneLfMetricFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<DataPlaneLfMetricFilterInput>>;
  readonly agentInformation?: InputMaybe<LaminarFlowAgentMetadataFilterInput>;
  readonly agent_id?: InputMaybe<StringFilterInput>;
  readonly contactStatus?: InputMaybe<StringFilterInput>;
  readonly contact_id?: InputMaybe<StringFilterInput>;
  readonly customerId?: InputMaybe<StringFilterInput>;
  readonly customerNamePart?: InputMaybe<StringFilterInput>;
  readonly dataflow_id?: InputMaybe<StringFilterInput>;
  readonly destinationRegion?: InputMaybe<StringFilterInput>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly lfDecryptStageMetricsV2?: InputMaybe<LfDecryptStageMetricsV2FilterInput>;
  readonly lfEgressStageMetricsV2?: InputMaybe<LfEgressStageMetricsV2FilterInput>;
  readonly lfEncryptStageMetricsV2?: InputMaybe<LfEncryptStageMetricsV2FilterInput>;
  readonly lfIngressStageMetricsV2?: InputMaybe<LfIngressStageMetricsV2FilterInput>;
  readonly lfStripeDecodeStageMetricsV2?: InputMaybe<LfStripeDecodeStageMetricsV2FilterInput>;
  readonly lfStripeDecodeStageMetricsV3?: InputMaybe<LfStripeDecodeStageMetricsV3FilterInput>;
  readonly lfStripeEncodeStageMetricsV2?: InputMaybe<LfStripeEncodeStageMetricsV2FilterInput>;
  readonly lfTimeDecodeStageMetricsV2?: InputMaybe<LfTimeDecodeStageMetricsV2FilterInput>;
  readonly lfTimeDecodeStageMetricsV3?: InputMaybe<LfTimeDecodeStageMetricsV3FilterInput>;
  readonly lfTimeEncodeStageMetricsV2?: InputMaybe<LfTimeEncodeStageMetricsV2FilterInput>;
  readonly lfTracerouteStageMetricsV2?: InputMaybe<LfTracerouteStageMetricsV2FilterInput>;
  readonly lfWanRxStageMetricsV2?: InputMaybe<LfWanRxStageMetricsV2FilterInput>;
  readonly lfWanTxStageMetricsV2?: InputMaybe<LfWanTxStageMetricsV2FilterInput>;
  readonly missionProfileId?: InputMaybe<StringFilterInput>;
  readonly rpm_version?: InputMaybe<StringFilterInput>;
  readonly sourceRegion?: InputMaybe<StringFilterInput>;
  readonly task_id?: InputMaybe<StringFilterInput>;
  readonly timeStampEnd?: InputMaybe<StringFilterInput>;
  readonly timeStampStart?: InputMaybe<StringFilterInput>;
};

export type DataPlaneLfMetricSortInput = {
  readonly agentInformation?: InputMaybe<LaminarFlowAgentMetadataSortInput>;
  readonly agent_id?: InputMaybe<SortOrder>;
  readonly contactStatus?: InputMaybe<SortOrder>;
  readonly contact_id?: InputMaybe<SortOrder>;
  readonly customerId?: InputMaybe<SortOrder>;
  readonly customerNamePart?: InputMaybe<SortOrder>;
  readonly dataflow_id?: InputMaybe<SortOrder>;
  readonly destinationRegion?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly lfDecryptStageMetricsV2?: InputMaybe<LfDecryptStageMetricsV2SortInput>;
  readonly lfEgressStageMetricsV2?: InputMaybe<LfEgressStageMetricsV2SortInput>;
  readonly lfEncryptStageMetricsV2?: InputMaybe<LfEncryptStageMetricsV2SortInput>;
  readonly lfIngressStageMetricsV2?: InputMaybe<LfIngressStageMetricsV2SortInput>;
  readonly lfStripeDecodeStageMetricsV2?: InputMaybe<LfStripeDecodeStageMetricsV2SortInput>;
  readonly lfStripeDecodeStageMetricsV3?: InputMaybe<LfStripeDecodeStageMetricsV3SortInput>;
  readonly lfStripeEncodeStageMetricsV2?: InputMaybe<LfStripeEncodeStageMetricsV2SortInput>;
  readonly lfTimeDecodeStageMetricsV2?: InputMaybe<LfTimeDecodeStageMetricsV2SortInput>;
  readonly lfTimeDecodeStageMetricsV3?: InputMaybe<LfTimeDecodeStageMetricsV3SortInput>;
  readonly lfTimeEncodeStageMetricsV2?: InputMaybe<LfTimeEncodeStageMetricsV2SortInput>;
  readonly lfWanRxStageMetricsV2?: InputMaybe<LfWanRxStageMetricsV2SortInput>;
  readonly lfWanTxStageMetricsV2?: InputMaybe<LfWanTxStageMetricsV2SortInput>;
  readonly missionProfileId?: InputMaybe<SortOrder>;
  readonly rpm_version?: InputMaybe<SortOrder>;
  readonly sourceRegion?: InputMaybe<SortOrder>;
  readonly task_id?: InputMaybe<SortOrder>;
  readonly timeStampEnd?: InputMaybe<SortOrder>;
  readonly timeStampStart?: InputMaybe<SortOrder>;
};

export type Dataflow = {
  readonly __typename?: 'Dataflow';
  readonly dataflowId?: Maybe<Scalars['String']['output']>;
  readonly dataflowMetrics?: Maybe<DataflowMetrics>;
  readonly destinationNode?: Maybe<DataflowNode>;
  readonly rfCharacteristics?: Maybe<RfCharacteristics>;
  readonly sourceNode?: Maybe<DataflowNode>;
  readonly tags?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly vita49StreamCharacteristics?: Maybe<Vita49StreamCharacteristics>;
};

export type DataflowEdge = {
  readonly __typename?: 'DataflowEdge';
  readonly fromConfig: Config;
  readonly fromConfigArn: Scalars['String']['output'];
  readonly fromConfigId: Scalars['String']['output'];
  readonly toConfig: Config;
  readonly toConfigArn: Scalars['String']['output'];
  readonly toConfigId: Scalars['String']['output'];
};

export type DataflowEdgeFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<DataflowEdgeFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<DataflowEdgeFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<DataflowEdgeFilterInput>>;
  readonly fromConfig?: InputMaybe<ConfigFilterInput>;
  readonly fromConfigArn?: InputMaybe<StringFilterInput>;
  readonly fromConfigId?: InputMaybe<StringFilterInput>;
  readonly toConfig?: InputMaybe<ConfigFilterInput>;
  readonly toConfigArn?: InputMaybe<StringFilterInput>;
  readonly toConfigId?: InputMaybe<StringFilterInput>;
};

export type DataflowEndpointConfigData = {
  readonly __typename?: 'DataflowEndpointConfigData';
  readonly name: Scalars['String']['output'];
  readonly region?: Maybe<Scalars['String']['output']>;
};

export type DataflowEndpointConfigDataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<DataflowEndpointConfigDataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<DataflowEndpointConfigDataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<DataflowEndpointConfigDataFilterInput>>;
  readonly name?: InputMaybe<StringFilterInput>;
  readonly region?: InputMaybe<StringFilterInput>;
};

export type DataflowEndpointConfigDataSortInput = {
  readonly name?: InputMaybe<SortOrder>;
  readonly region?: InputMaybe<SortOrder>;
};

export type DataflowMetrics = {
  readonly __typename?: 'DataflowMetrics';
  /** The number of encapsulated bytes that the destination node of the dataflow received. Compare with bytes transferred to gauge customer experience. */
  readonly bytesReceived?: Maybe<Scalars['Long']['output']>;
  /** The number of encapsulated bytes that the source node of the dataflow transferred. */
  readonly bytesTransferred?: Maybe<Scalars['Long']['output']>;
};

export type DataflowNode = {
  readonly __typename?: 'DataflowNode';
  /** This would be the capabilityArn */
  readonly nodeArn?: Maybe<Scalars['String']['output']>;
  readonly nodeRegion?: Maybe<Scalars['String']['output']>;
  readonly nodeType?: Maybe<ConfigCapabilityType>;
};

export type DataflowTranslation = {
  readonly __typename?: 'DataflowTranslation';
  readonly egress?: Maybe<TranslationDetail>;
  readonly ingress?: Maybe<TranslationDetail>;
};

export type DataflowTranslationFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<DataflowTranslationFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<DataflowTranslationFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<DataflowTranslationFilterInput>>;
  readonly egress?: InputMaybe<TranslationDetailFilterInput>;
  readonly ingress?: InputMaybe<TranslationDetailFilterInput>;
};

export type DataplaneReport = {
  readonly __typename?: 'DataplaneReport';
  readonly htmlText: Scalars['String']['output'];
};

export type DecodeConfigData = {
  readonly __typename?: 'DecodeConfigData';
  readonly unvalidatedJSON?: Maybe<Scalars['String']['output']>;
};

export type DecodeConfigDataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<DecodeConfigDataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<DecodeConfigDataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<DecodeConfigDataFilterInput>>;
  readonly unvalidatedJSON?: InputMaybe<StringFilterInput>;
};

export type DecodeConfigDataSortInput = {
  readonly unvalidatedJSON?: InputMaybe<SortOrder>;
};

export enum DeliveryMechanism {
  Ddx = 'DDX',
  LaminarFlow = 'LAMINAR_FLOW'
}

export type DeliveryMechanismFilterInput = {
  readonly _eq?: InputMaybe<DeliveryMechanism>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<DeliveryMechanism>>;
  readonly _neq?: InputMaybe<DeliveryMechanism>;
  readonly _nin?: InputMaybe<ReadonlyArray<DeliveryMechanism>>;
};

export type DemodulationConfigData = {
  readonly __typename?: 'DemodulationConfigData';
  readonly unvalidatedJSON?: Maybe<Scalars['String']['output']>;
};

export type DemodulationConfigDataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<DemodulationConfigDataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<DemodulationConfigDataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<DemodulationConfigDataFilterInput>>;
  readonly unvalidatedJSON?: InputMaybe<StringFilterInput>;
};

export type DemodulationConfigDataSortInput = {
  readonly unvalidatedJSON?: InputMaybe<SortOrder>;
};

export type DereferencedMissionProfileData = {
  readonly __typename?: 'DereferencedMissionProfileData';
  readonly createdInRegion?: Maybe<Scalars['String']['output']>;
  readonly customerAwsAccountId?: Maybe<Scalars['String']['output']>;
  readonly minimumViableContactSeconds?: Maybe<Scalars['Int']['output']>;
  readonly missionProfileArn?: Maybe<Scalars['String']['output']>;
  readonly missionProfileId?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly postPassDurationSeconds?: Maybe<Scalars['Int']['output']>;
  readonly prePassDurationSeconds?: Maybe<Scalars['Int']['output']>;
  readonly telemetrySinkConfigArn?: Maybe<Scalars['String']['output']>;
  readonly trackingConfigArn?: Maybe<Scalars['String']['output']>;
};

export type EchoInput = {
  readonly input: Scalars['String']['input'];
};

export type EchoOutput = {
  readonly __typename?: 'EchoOutput';
  readonly output: Scalars['String']['output'];
};

export type Elevation = {
  readonly __typename?: 'Elevation';
  readonly unit: AngleUnits;
  readonly value: Scalars['Float']['output'];
};

export type EphemerisInfo = {
  readonly __typename?: 'EphemerisInfo';
  /** Unique identifier for the ephemeris */
  readonly ephemerisId: Scalars['String']['output'];
  /** Type of ephemeris */
  readonly ephemerisSourceType?: Maybe<EphemerisSourceType>;
  /** Timestamp when the ephemeris was updated */
  readonly updateTime: Scalars['AWSDateTime']['output'];
  /** Type of ephemeris usage */
  readonly usageType: ContactEphemerisUsageType;
};

export type EphemerisInfoFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<EphemerisInfoFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<EphemerisInfoFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<EphemerisInfoFilterInput>>;
  readonly ephemerisId?: InputMaybe<StringFilterInput>;
  readonly ephemerisSourceType?: InputMaybe<EphemerisSourceTypeFilterInput>;
  readonly updateTime?: InputMaybe<TimestampFilterInput>;
  readonly usageType?: InputMaybe<ContactEphemerisUsageTypeFilterInput>;
};

export enum EphemerisSourceType {
  AzEl = 'AZ_EL',
  Oem = 'OEM',
  ServiceManaged = 'SERVICE_MANAGED',
  Tle = 'TLE'
}

export type EphemerisSourceTypeFilterInput = {
  readonly _eq?: InputMaybe<EphemerisSourceType>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<EphemerisSourceType>>;
  readonly _neq?: InputMaybe<EphemerisSourceType>;
  readonly _nin?: InputMaybe<ReadonlyArray<EphemerisSourceType>>;
};

export type FloatFilterInput = {
  readonly _eq?: InputMaybe<Scalars['Float']['input']>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _gt?: InputMaybe<Scalars['Float']['input']>;
  readonly _gte?: InputMaybe<Scalars['Float']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['Float']['input']>>;
  readonly _lt?: InputMaybe<Scalars['Float']['input']>;
  readonly _lte?: InputMaybe<Scalars['Float']['input']>;
  readonly _neq?: InputMaybe<Scalars['Float']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['Float']['input']>>;
};

export type Frequency = {
  readonly __typename?: 'Frequency';
  readonly unit: Scalars['String']['output'];
  readonly units?: Maybe<Scalars['String']['output']>;
  readonly value: Scalars['Float']['output'];
};

export enum FrequencyBand {
  KaBand = 'KA_BAND',
  None = 'NONE',
  SBand = 'S_BAND',
  XBand = 'X_BAND'
}

export type FrequencyFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<FrequencyFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<FrequencyFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<FrequencyFilterInput>>;
  readonly unit?: InputMaybe<StringFilterInput>;
  readonly value?: InputMaybe<FloatFilterInput>;
};

export type FrequencySortInput = {
  readonly unit?: InputMaybe<SortOrder>;
  readonly value?: InputMaybe<SortOrder>;
};

export type GetConfigInput = {
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type GetContactVersionInput = {
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type GetDataPlaneDdxMetricInput = {
  readonly jobId?: InputMaybe<Scalars['String']['input']>;
};

export type GetDataPlaneLfMetricInput = {
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type GetGsocContactV2Input = {
  readonly contactId?: InputMaybe<Scalars['String']['input']>;
};

export type GetMissionProfileInput = {
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type GsocAntennaDemodDecodeDetails = {
  readonly __typename?: 'GsocAntennaDemodDecodeDetails';
  readonly decodeConfigData: GsocDecodeConfigData;
  readonly demodulationConfigData: GsocDemodulationConfigData;
  readonly rfCharacteristics: GsocRfCharacteristics;
};

export type GsocAntennaDemodDecodeDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocAntennaDemodDecodeDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocAntennaDemodDecodeDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocAntennaDemodDecodeDetailsFilterInput>>;
  readonly decodeConfigData?: InputMaybe<GsocDecodeConfigDataFilterInput>;
  readonly demodulationConfigData?: InputMaybe<GsocDemodulationConfigDataFilterInput>;
  readonly rfCharacteristics?: InputMaybe<GsocRfCharacteristicsFilterInput>;
};

export type GsocAntennaDownlinkDetails = {
  readonly __typename?: 'GsocAntennaDownlinkDetails';
  readonly rfCharacteristics: GsocRfCharacteristics;
};

export type GsocAntennaDownlinkDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocAntennaDownlinkDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocAntennaDownlinkDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocAntennaDownlinkDetailsFilterInput>>;
  readonly rfCharacteristics?: InputMaybe<GsocRfCharacteristicsFilterInput>;
};

export type GsocAwsTemporaryCredentials = {
  readonly __typename?: 'GsocAwsTemporaryCredentials';
  readonly accessKeyId: Scalars['String']['output'];
  readonly expiration: Scalars['AWSDateTime']['output'];
  readonly secretAccessKey: Scalars['String']['output'];
  readonly sessionToken: Scalars['String']['output'];
};

export type GsocCapability = {
  readonly __typename?: 'GsocCapability';
  readonly arn?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly type: Scalars['String']['output'];
};

export type GsocCapabilityV2 = {
  readonly __typename?: 'GsocCapabilityV2';
  readonly arn?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly plots: ReadonlyArray<NamedImageV2>;
  readonly type: Scalars['String']['output'];
};

export type GsocCapabilityV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocCapabilityV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocCapabilityV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocCapabilityV2FilterInput>>;
  readonly arn?: InputMaybe<StringFilterInput>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly plots?: InputMaybe<NamedImageV2FilterInput>;
  readonly type?: InputMaybe<StringFilterInput>;
};

export type GsocConfig = {
  readonly __typename?: 'GsocConfig';
  readonly arn?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly type: Scalars['String']['output'];
};

export type GsocConfigFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocConfigFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocConfigFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocConfigFilterInput>>;
  readonly arn?: InputMaybe<StringFilterInput>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly type?: InputMaybe<StringFilterInput>;
};

export type GsocConnectionProxyDetails = {
  readonly __typename?: 'GsocConnectionProxyDetails';
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowTranslation?: Maybe<DataflowTranslation>;
};

export type GsocConnectionProxyDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocConnectionProxyDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocConnectionProxyDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocConnectionProxyDetailsFilterInput>>;
  readonly configArn?: InputMaybe<StringFilterInput>;
  readonly dataflowTranslation?: InputMaybe<DataflowTranslationFilterInput>;
};

export type GsocContactDetails = {
  readonly __typename?: 'GsocContactDetails';
  /** Active contact version id for the contact */
  readonly activeContactVersionId?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the contact */
  readonly contactId: Scalars['String']['output'];
  /** Current status of the contact. */
  readonly contactStatus: ContactStatus;
  /** Customer information for the contact. */
  readonly customer: GsocCustomer;
  /** List of dataflows and their detailed information */
  readonly dataflows?: Maybe<ReadonlyArray<GsocDataflow>>;
  /** time to live attribute */
  readonly datalakeTtl?: Maybe<Scalars['AWSDateTime']['output']>;
  /** List of regions where the contact data will land. */
  readonly destinationRegions: ReadonlyArray<Scalars['String']['output']>;
  /** Duration of the contact, in milliseconds */
  readonly durationMs: Scalars['Float']['output'];
  /** List storing EphemerisInfo objects storing info about the ephemeris used for scheduling, daily ephemeris refresh validate visibility or pointing angle, and reference/actual final pointing angle calculations */
  readonly ephemerisInfoList?: Maybe<ReadonlyArray<EphemerisInfo>>;
  /** Failed to schedule reason */
  readonly failedToScheduleReasons?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Ground Stations. */
  readonly groundStations?: Maybe<ReadonlyArray<GsocGroundStation>>;
  /** Configuration information from the Mission Profile at contact scheduling time. */
  readonly missionProfile: GsocMissionProfile;
  /** Unique identifier for the contact */
  readonly pk: Scalars['String']['output'];
  /** Satellite associated with the contact. */
  readonly satellite?: Maybe<GsocSatellite>;
  /** Region that the contact was scheduled from */
  readonly schedulingRegion: Scalars['String']['output'];
  /** Signature map containing troubleshooting information relevant to the contact. */
  readonly signatureMap?: Maybe<ReadonlyArray<SignatureMapEntry>>;
  /** List of tags for tagging contacts for search purposes */
  readonly tags?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** List of RouteIds created in CapTel Routing Service for telemetry delivery */
  readonly telemetryRouteList?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The time range of the contact */
  readonly timeRange: TimeRange;
};

export type GsocContactDynamoDbTable = {
  readonly __typename?: 'GsocContactDynamoDbTable';
  /** Active contact version id for the contact */
  readonly activeContactVersionId?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the contact */
  readonly contactId: Scalars['String']['output'];
  /** Current status of the contact. */
  readonly contactStatus: ContactStatus;
  /** Customer information for the contact. */
  readonly customer: GsocCustomer;
  /** List of dataflows and their detailed information */
  readonly dataflows?: Maybe<ReadonlyArray<GsocDataflow>>;
  /** time to live attribute */
  readonly datalakeTtl?: Maybe<Scalars['AWSDateTime']['output']>;
  /** List of regions where the contact data will land. */
  readonly destinationRegions: ReadonlyArray<Scalars['String']['output']>;
  /** Duration of the contact, in milliseconds */
  readonly durationMs: Scalars['Float']['output'];
  /** List storing EphemerisInfo objects storing info about the ephemeris used for scheduling, daily ephemeris refresh validate visibility or pointing angle, and reference/actual final pointing angle calculations */
  readonly ephemerisInfoList?: Maybe<ReadonlyArray<EphemerisInfo>>;
  /** Failed to schedule reason */
  readonly failedToScheduleReasons?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Ground Stations. */
  readonly groundStations?: Maybe<ReadonlyArray<GsocGroundStation>>;
  /** Configuration information from the Mission Profile at contact scheduling time. */
  readonly missionProfile: GsocMissionProfile;
  /** Unique identifier for the contact */
  readonly pk: Scalars['String']['output'];
  /** Satellite associated with the contact. */
  readonly satellite?: Maybe<GsocSatellite>;
  /** Region that the contact was scheduled from */
  readonly schedulingRegion: Scalars['String']['output'];
  /** Signature map containing troubleshooting information relevant to the contact. */
  readonly signatureMap?: Maybe<ReadonlyArray<SignatureMapEntry>>;
  /** List of tags for tagging contacts for search purposes */
  readonly tags?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** List of RouteIds created in CapTel Routing Service for telemetry delivery */
  readonly telemetryRouteList?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The time range of the contact */
  readonly timeRange: TimeRange;
};

export type GsocContactEvent010 = {
  readonly __typename?: 'GsocContactEvent010';
  /** The unique identifier associated with Contacts. This can be used to unambiguously fetch a Contact. */
  readonly contactId?: Maybe<Scalars['String']['output']>;
};

export type GsocContactIndexOpenSearch = {
  readonly __typename?: 'GsocContactIndexOpenSearch';
  /** Active contact version id for the contact */
  readonly activeContactVersionId?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the contact */
  readonly contactId: Scalars['String']['output'];
  /** Current status of the contact. */
  readonly contactStatus: ContactStatus;
  /** Customer information for the contact. */
  readonly customer: GsocCustomer;
  /** List of dataflows and their detailed information */
  readonly dataflows?: Maybe<ReadonlyArray<GsocDataflow>>;
  /** time to live attribute */
  readonly datalakeTtl?: Maybe<Scalars['AWSDateTime']['output']>;
  /** List of regions where the contact data will land. */
  readonly destinationRegions: ReadonlyArray<Scalars['String']['output']>;
  /** Duration of the contact, in milliseconds */
  readonly durationMs: Scalars['Float']['output'];
  /** List storing EphemerisInfo objects storing info about the ephemeris used for scheduling, daily ephemeris refresh validate visibility or pointing angle, and reference/actual final pointing angle calculations */
  readonly ephemerisInfoList?: Maybe<ReadonlyArray<EphemerisInfo>>;
  /** Failed to schedule reason */
  readonly failedToScheduleReasons?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Ground Stations. */
  readonly groundStations?: Maybe<ReadonlyArray<GsocGroundStation>>;
  /** Configuration information from the Mission Profile at contact scheduling time. */
  readonly missionProfile: GsocMissionProfile;
  /** Unique identifier for the contact */
  readonly pk: Scalars['String']['output'];
  /** Satellite associated with the contact. */
  readonly satellite?: Maybe<GsocSatellite>;
  /** Region that the contact was scheduled from */
  readonly schedulingRegion: Scalars['String']['output'];
  /** Signature map containing troubleshooting information relevant to the contact. */
  readonly signatureMap?: Maybe<ReadonlyArray<SignatureMapEntry>>;
  /** List of tags for tagging contacts for search purposes */
  readonly tags?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** List of RouteIds created in CapTel Routing Service for telemetry delivery */
  readonly telemetryRouteList?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The time range of the contact */
  readonly timeRange: TimeRange;
};

export type GsocContactStatusFilterInput = {
  readonly _eq?: InputMaybe<ContactStatus>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<ContactStatus>>;
  readonly _neq?: InputMaybe<ContactStatus>;
  readonly _nin?: InputMaybe<ReadonlyArray<ContactStatus>>;
};

export type GsocContactV2 = {
  readonly __typename?: 'GsocContactV2';
  /** Active contact version id for the contact */
  readonly activeContactVersionId?: Maybe<Scalars['Int']['output']>;
  /** ACU report */
  readonly acuPlots?: Maybe<S3Object>;
  /** Unique identifier for the contact */
  readonly contactId: Scalars['String']['output'];
  /** Current status of the contact. */
  readonly contactStatus: ContactStatus;
  /** Customer information for the contact. */
  readonly customer: GsocCustomer;
  /** List of dataflows and their detailed information */
  readonly dataflows?: Maybe<ReadonlyArray<GsocDataflowV2>>;
  /** time to live attribute */
  readonly datalakeTtl?: Maybe<Scalars['AWSDateTime']['output']>;
  /** List of regions where the contact data will land. */
  readonly destinationRegions: ReadonlyArray<Scalars['String']['output']>;
  /** Duration of the contact, in milliseconds */
  readonly durationMs: Scalars['Float']['output'];
  /** List storing EphemerisInfo objects storing info about the ephemeris used for scheduling, daily ephemeris refresh validate visibility or pointing angle, and reference/actual final pointing angle calculations */
  readonly ephemerisInfoList?: Maybe<ReadonlyArray<EphemerisInfo>>;
  /** Failed to schedule reason */
  readonly failedToScheduleReasons?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Ground Stations. */
  readonly groundStations?: Maybe<ReadonlyArray<GsocGroundStation>>;
  /** Configuration information from the Mission Profile at contact scheduling time. */
  readonly missionProfile: GsocMissionProfile;
  /** Unique identifier for the contact */
  readonly pk: Scalars['String']['output'];
  /** Satellite associated with the contact. */
  readonly satellite?: Maybe<GsocSatellite>;
  /** Region that the contact was scheduled from */
  readonly schedulingRegion: Scalars['String']['output'];
  /** Signature map containing troubleshooting information relevant to the contact. */
  readonly signatureMap?: Maybe<ReadonlyArray<SignatureMapEntry>>;
  /** List of tags for tagging contacts for search purposes */
  readonly tags?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** List of RouteIds created in CapTel Routing Service for telemetry delivery */
  readonly telemetryRouteList?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The time range of the contact */
  readonly timeRange: TimeRange;
};

export type GsocContactV2Aggregation = {
  readonly __typename?: 'GsocContactV2Aggregation';
  readonly activeContactVersionId: Aggregation;
  readonly durationMs: Aggregation;
  readonly satellite: GsocSatelliteAggregation;
};

export type GsocContactV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocContactV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocContactV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocContactV2FilterInput>>;
  readonly activeContactVersionId?: InputMaybe<IntegerFilterInput>;
  readonly acuPlots?: InputMaybe<S3ObjectFilterInput>;
  readonly contactId?: InputMaybe<StringFilterInput>;
  readonly contactStatus?: InputMaybe<ContactStatusFilterInput>;
  readonly customer?: InputMaybe<GsocCustomerFilterInput>;
  readonly dataflows?: InputMaybe<GsocDataflowV2FilterInput>;
  readonly datalakeTtl?: InputMaybe<TimestampFilterInput>;
  readonly destinationRegions?: InputMaybe<StringFilterInput>;
  readonly durationMs?: InputMaybe<FloatFilterInput>;
  readonly ephemerisInfoList?: InputMaybe<EphemerisInfoFilterInput>;
  readonly failedToScheduleReasons?: InputMaybe<StringFilterInput>;
  readonly groundStations?: InputMaybe<GsocGroundStationFilterInput>;
  readonly missionProfile?: InputMaybe<GsocMissionProfileFilterInput>;
  readonly pk?: InputMaybe<StringFilterInput>;
  readonly satellite?: InputMaybe<GsocSatelliteFilterInput>;
  readonly schedulingRegion?: InputMaybe<StringFilterInput>;
  readonly signatureMap?: InputMaybe<SignatureMapFilterInput>;
  readonly tags?: InputMaybe<StringFilterInput>;
  readonly telemetryRouteList?: InputMaybe<StringFilterInput>;
  readonly timeRange?: InputMaybe<TimeRangeFilterInput>;
};

export type GsocContactV2SortInput = {
  readonly activeContactVersionId?: InputMaybe<SortOrder>;
  readonly acuPlots?: InputMaybe<S3ObjectSortInput>;
  readonly contactId?: InputMaybe<SortOrder>;
  readonly contactStatus?: InputMaybe<SortOrder>;
  readonly customer?: InputMaybe<GsocCustomerSortInput>;
  readonly datalakeTtl?: InputMaybe<SortOrder>;
  readonly durationMs?: InputMaybe<SortOrder>;
  readonly missionProfile?: InputMaybe<GsocMissionProfileSortInput>;
  readonly pk?: InputMaybe<SortOrder>;
  readonly satellite?: InputMaybe<GsocSatelliteSortInput>;
  readonly schedulingRegion?: InputMaybe<SortOrder>;
  readonly timeRange?: InputMaybe<TimeRangeSortInput>;
};

export type GsocCustomer = {
  readonly __typename?: 'GsocCustomer';
  readonly awsAccountId?: Maybe<Scalars['String']['output']>;
  readonly awsGsaasAwsAccountNamePart: Scalars['String']['output'];
  readonly external: Scalars['Boolean']['output'];
};

export type GsocCustomerFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocCustomerFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocCustomerFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocCustomerFilterInput>>;
  readonly awsAccountId?: InputMaybe<GsocStringFilterInput>;
  readonly awsGsaasAwsAccountNamePart?: InputMaybe<GsocStringFilterInput>;
  readonly external?: InputMaybe<BooleanFilterInput>;
};

export type GsocCustomerSortInput = {
  readonly awsAccountId?: InputMaybe<SortOrder>;
  readonly awsGsaasAwsAccountNamePart?: InputMaybe<SortOrder>;
  readonly external?: InputMaybe<SortOrder>;
};

export type GsocDataflow = {
  readonly __typename?: 'GsocDataflow';
  readonly dataflowId: Scalars['String']['output'];
  readonly destination: GsocNode;
  readonly source: GsocNode;
  readonly tags: ReadonlyArray<Scalars['String']['output']>;
};

export type GsocDataflowV2 = {
  readonly __typename?: 'GsocDataflowV2';
  readonly dataflowId: Scalars['String']['output'];
  readonly destination: GsocNodeV2;
  readonly source: GsocNodeV2;
  readonly tags: ReadonlyArray<Scalars['String']['output']>;
};

export type GsocDataflowV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocDataflowV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocDataflowV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocDataflowV2FilterInput>>;
  readonly dataflowId?: InputMaybe<StringFilterInput>;
  readonly destination?: InputMaybe<GsocNodeV2FilterInput>;
  readonly source?: InputMaybe<GsocNodeV2FilterInput>;
  readonly tags?: InputMaybe<StringFilterInput>;
};

export enum GsocDataplaneType {
  DataDefender = 'DATA_DEFENDER',
  LaminarFlow = 'LAMINAR_FLOW'
}

export type GsocDataplaneTypeFilterInput = {
  readonly _eq?: InputMaybe<GsocDataplaneType>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<GsocDataplaneType>>;
  readonly _neq?: InputMaybe<GsocDataplaneType>;
  readonly _nin?: InputMaybe<ReadonlyArray<GsocDataplaneType>>;
};

export type GsocDecodeConfigData = {
  readonly __typename?: 'GsocDecodeConfigData';
  readonly unvalidatedJson: Scalars['String']['output'];
};

export type GsocDecodeConfigDataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocDecodeConfigDataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocDecodeConfigDataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocDecodeConfigDataFilterInput>>;
  readonly unvalidatedJson?: InputMaybe<StringFilterInput>;
};

export type GsocDemodulationConfigData = {
  readonly __typename?: 'GsocDemodulationConfigData';
  readonly unvalidatedJson: Scalars['String']['output'];
};

export type GsocDemodulationConfigDataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocDemodulationConfigDataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocDemodulationConfigDataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocDemodulationConfigDataFilterInput>>;
  readonly unvalidatedJson?: InputMaybe<StringFilterInput>;
};

export type GsocGetContactDetailsInput = {
  readonly date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly id: Scalars['String']['input'];
};

export type GsocGroundStation = {
  readonly __typename?: 'GsocGroundStation';
  readonly antennaName?: Maybe<Scalars['String']['output']>;
  readonly groundStationId: Scalars['String']['output'];
  readonly groundStationName: Scalars['String']['output'];
  readonly region: Scalars['String']['output'];
};

export type GsocGroundStationFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocGroundStationFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocGroundStationFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocGroundStationFilterInput>>;
  readonly antennaName?: InputMaybe<GsocStringFilterInput>;
  readonly groundStationId?: InputMaybe<GsocStringFilterInput>;
  readonly groundStationName?: InputMaybe<GsocStringFilterInput>;
  readonly region?: InputMaybe<GsocStringFilterInput>;
};

export type GsocIamRole = {
  readonly __typename?: 'GsocIamRole';
  readonly awsTemporaryCredentials?: Maybe<GsocAwsTemporaryCredentials>;
  readonly isAuthorized: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly roleArn: Scalars['String']['output'];
};

export type GsocIntegerRange = {
  readonly __typename?: 'GsocIntegerRange';
  readonly maximum: Scalars['Int']['output'];
  readonly minimum: Scalars['Int']['output'];
};

export type GsocIntegerRangeFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocIntegerRangeFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocIntegerRangeFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocIntegerRangeFilterInput>>;
  readonly maximum?: InputMaybe<IntegerFilterInput>;
  readonly minimum?: InputMaybe<IntegerFilterInput>;
};

export type GsocListContactsPaginatedInput = {
  readonly cursor?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly limit?: InputMaybe<Scalars['Int']['input']>;
  readonly sort?: InputMaybe<ReadonlyArray<ListGsocContactsSortInput>>;
  readonly where?: InputMaybe<ListGsocContactsFilterInput>;
};

export type GsocListContactsPaginatedOutput = {
  readonly __typename?: 'GsocListContactsPaginatedOutput';
  readonly contacts: ReadonlyArray<GsocContactDetails>;
  readonly pageInfo: GsocPageInfo;
};

export type GsocListIamRolesOutput = {
  readonly __typename?: 'GsocListIamRolesOutput';
  readonly roles: ReadonlyArray<GsocIamRole>;
};

export type GsocManagedAntennaDemodDecodeDetails = {
  readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails';
  readonly managedRadioConfigId: Scalars['String']['output'];
  readonly rfCharacteristics: GsocRfCharacteristics;
};

export type GsocManagedAntennaDemodDecodeDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocManagedAntennaDemodDecodeDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocManagedAntennaDemodDecodeDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocManagedAntennaDemodDecodeDetailsFilterInput>>;
  readonly managedRadioConfigId?: InputMaybe<StringFilterInput>;
  readonly rfCharacteristics?: InputMaybe<GsocRfCharacteristicsFilterInput>;
};

export type GsocMissionProfile = {
  readonly __typename?: 'GsocMissionProfile';
  readonly missionProfileArn?: Maybe<Scalars['String']['output']>;
  readonly missionProfileId: Scalars['String']['output'];
  readonly missionProfileName?: Maybe<Scalars['String']['output']>;
};

export type GsocMissionProfileFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocMissionProfileFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocMissionProfileFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocMissionProfileFilterInput>>;
  readonly missionProfileArn?: InputMaybe<GsocStringFilterInput>;
  readonly missionProfileId?: InputMaybe<GsocStringFilterInput>;
  readonly missionProfileName?: InputMaybe<GsocStringFilterInput>;
};

export type GsocMissionProfileSortInput = {
  readonly missionProfileArn?: InputMaybe<SortOrder>;
  readonly missionProfileId?: InputMaybe<SortOrder>;
  readonly missionProfileName?: InputMaybe<SortOrder>;
};

export type GsocNode = {
  readonly __typename?: 'GsocNode';
  readonly capability: GsocCapability;
  readonly config: GsocConfig;
  readonly nodeDetails: GsocNodeDetails;
  readonly region: Scalars['String']['output'];
  readonly telemetryInfo?: Maybe<GsocTelemetryInformation>;
};

export type GsocNodeAgentDetails = {
  readonly __typename?: 'GsocNodeAgentDetails';
  readonly version?: Maybe<Scalars['String']['output']>;
};

export type GsocNodeAgentDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocNodeAgentDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocNodeAgentDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocNodeAgentDetailsFilterInput>>;
  readonly version?: InputMaybe<StringFilterInput>;
};

export type GsocNodeDataplaneDataDefenderDetails = {
  readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails';
  readonly dataDeliveryServiceDestinationArn?: Maybe<Scalars['String']['output']>;
  readonly dataDeliveryServiceSourceArn?: Maybe<Scalars['String']['output']>;
  readonly securityDetails?: Maybe<GsocSecurityDetails>;
  readonly vita49StreamId?: Maybe<Scalars['Int']['output']>;
};

export type GsocNodeDataplaneDataDefenderDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocNodeDataplaneDataDefenderDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocNodeDataplaneDataDefenderDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocNodeDataplaneDataDefenderDetailsFilterInput>>;
  readonly dataDeliveryServiceDestinationArn?: InputMaybe<StringFilterInput>;
  readonly dataDeliveryServiceSourceArn?: InputMaybe<StringFilterInput>;
  readonly securityDetails?: InputMaybe<GsocSecurityDetailsFilterInput>;
  readonly vita49StreamId?: InputMaybe<IntegerFilterInput>;
};

export type GsocNodeDataplaneDetails = {
  readonly __typename?: 'GsocNodeDataplaneDetails';
  readonly dataDefender?: Maybe<GsocNodeDataplaneDataDefenderDetails>;
  readonly dataflowType?: Maybe<GsocDataplaneType>;
  readonly laminarFlow?: Maybe<GsocNodeDataplaneLaminarFlowDetails>;
};

export type GsocNodeDataplaneDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocNodeDataplaneDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocNodeDataplaneDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocNodeDataplaneDetailsFilterInput>>;
  readonly dataDefender?: InputMaybe<GsocNodeDataplaneDataDefenderDetailsFilterInput>;
  readonly dataflowType?: InputMaybe<GsocDataplaneTypeFilterInput>;
  readonly laminarFlow?: InputMaybe<GsocNodeDataplaneLaminarFlowDetailsFilterInput>;
};

export type GsocNodeDataplaneLaminarFlowDetails = {
  readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails';
  readonly agent?: Maybe<GsocNodeAgentDetails>;
  readonly egressAddress?: Maybe<GsocRangedConnectionDetails>;
  readonly ingressAddress?: Maybe<GsocRangedConnectionDetails>;
  readonly laminarflowConfig?: Maybe<Scalars['String']['output']>;
  readonly vita49StreamId?: Maybe<Scalars['Int']['output']>;
};

export type GsocNodeDataplaneLaminarFlowDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocNodeDataplaneLaminarFlowDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocNodeDataplaneLaminarFlowDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocNodeDataplaneLaminarFlowDetailsFilterInput>>;
  readonly agent?: InputMaybe<GsocNodeAgentDetailsFilterInput>;
  readonly egressAddress?: InputMaybe<GsocRangedConnectionDetailsFilterInput>;
  readonly ingressAddress?: InputMaybe<GsocRangedConnectionDetailsFilterInput>;
  readonly laminarflowConfig?: InputMaybe<StringFilterInput>;
  readonly vita49StreamId?: InputMaybe<IntegerFilterInput>;
};

export type GsocNodeDetails = {
  readonly __typename?: 'GsocNodeDetails';
  readonly dataplane?: Maybe<GsocNodeDataplaneDetails>;
  readonly orchestration?: Maybe<GsocNodeOrchestrationDetails>;
};

export type GsocNodeDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocNodeDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocNodeDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocNodeDetailsFilterInput>>;
  readonly dataplane?: InputMaybe<GsocNodeDataplaneDetailsFilterInput>;
  readonly orchestration?: InputMaybe<GsocNodeOrchestrationDetailsFilterInput>;
};

export type GsocNodeOrchestrationDetails = {
  readonly __typename?: 'GsocNodeOrchestrationDetails';
  readonly antennaDemodDecodeDetails?: Maybe<GsocAntennaDemodDecodeDetails>;
  readonly antennaDownlinkDetails?: Maybe<GsocAntennaDownlinkDetails>;
  readonly connectionProxyDetails?: Maybe<GsocConnectionProxyDetails>;
  readonly managedAntennaDemodDecodeDetails?: Maybe<GsocManagedAntennaDemodDecodeDetails>;
  readonly s3PlaybackDetails?: Maybe<GsocS3PlaybackDetails>;
  readonly s3RecordingDetails?: Maybe<GsocS3RecordingDetails>;
  readonly uplinkDetails?: Maybe<GsocUplinkDetails>;
  readonly uplinkEchoDetails?: Maybe<GsocUplinkEchoDetails>;
};

export type GsocNodeOrchestrationDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocNodeOrchestrationDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocNodeOrchestrationDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocNodeOrchestrationDetailsFilterInput>>;
  readonly antennaDemodDecodeDetails?: InputMaybe<GsocAntennaDemodDecodeDetailsFilterInput>;
  readonly antennaDownlinkDetails?: InputMaybe<GsocAntennaDownlinkDetailsFilterInput>;
  readonly connectionProxyDetails?: InputMaybe<GsocConnectionProxyDetailsFilterInput>;
  readonly managedAntennaDemodDecodeDetails?: InputMaybe<GsocManagedAntennaDemodDecodeDetailsFilterInput>;
  readonly s3PlaybackDetails?: InputMaybe<GsocS3PlaybackDetailsFilterInput>;
  readonly s3RecordingDetails?: InputMaybe<GsocS3RecordingDetailsFilterInput>;
  readonly uplinkDetails?: InputMaybe<GsocUplinkDetailsFilterInput>;
  readonly uplinkEchoDetails?: InputMaybe<GsocUplinkEchoDetailsFilterInput>;
};

export type GsocNodeV2 = {
  readonly __typename?: 'GsocNodeV2';
  readonly capability: GsocCapabilityV2;
  readonly config: GsocConfig;
  readonly nodeDetails: GsocNodeDetails;
  readonly region: Scalars['String']['output'];
  readonly telemetryInfo?: Maybe<GsocTelemetryInformation>;
};

export type GsocNodeV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocNodeV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocNodeV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocNodeV2FilterInput>>;
  readonly capability?: InputMaybe<GsocCapabilityV2FilterInput>;
  readonly config?: InputMaybe<GsocConfigFilterInput>;
  readonly nodeDetails?: InputMaybe<GsocNodeDetailsFilterInput>;
  readonly region?: InputMaybe<StringFilterInput>;
  readonly telemetryInfo?: InputMaybe<GsocTelemetryInformationFilterInput>;
};

export type GsocPageInfo = {
  readonly __typename?: 'GsocPageInfo';
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly lastCursor?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly total?: Maybe<GsocPageInfoTotal>;
};

export type GsocPageInfoTotal = {
  readonly __typename?: 'GsocPageInfoTotal';
  readonly relation?: Maybe<GsocPageInfoTotalRelation>;
  readonly value?: Maybe<Scalars['Int']['output']>;
};

export enum GsocPageInfoTotalRelation {
  Eq = 'eq',
  Gte = 'gte'
}

export type GsocRangedConnectionDetails = {
  readonly __typename?: 'GsocRangedConnectionDetails';
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly portRange: GsocIntegerRange;
};

export type GsocRangedConnectionDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocRangedConnectionDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocRangedConnectionDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocRangedConnectionDetailsFilterInput>>;
  readonly name?: InputMaybe<StringFilterInput>;
  readonly portRange?: InputMaybe<GsocIntegerRangeFilterInput>;
};

export type GsocRfCharacteristics = {
  readonly __typename?: 'GsocRfCharacteristics';
  /** Bandwidth is not present during uplink or uplink echo. */
  readonly bandwidth?: Maybe<Measurement>;
  readonly centerFrequency: Measurement;
  readonly polarization: Polarization;
};

export type GsocRfCharacteristicsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocRfCharacteristicsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocRfCharacteristicsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocRfCharacteristicsFilterInput>>;
  readonly bandwidth?: InputMaybe<MeasurementFilterInput>;
  readonly centerFrequency?: InputMaybe<MeasurementFilterInput>;
  readonly polarization?: InputMaybe<PolarizationFilterInput>;
};

export type GsocS3PlaybackDetails = {
  readonly __typename?: 'GsocS3PlaybackDetails';
  readonly bucketArn?: Maybe<Scalars['String']['output']>;
  readonly bucketRegion: Scalars['String']['output'];
  readonly keys?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly roleArn?: Maybe<Scalars['String']['output']>;
};

export type GsocS3PlaybackDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocS3PlaybackDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocS3PlaybackDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocS3PlaybackDetailsFilterInput>>;
  readonly bucketArn?: InputMaybe<StringFilterInput>;
  readonly bucketRegion?: InputMaybe<StringFilterInput>;
  readonly keys?: InputMaybe<StringFilterInput>;
  readonly roleArn?: InputMaybe<StringFilterInput>;
};

export type GsocS3RecordingDetails = {
  readonly __typename?: 'GsocS3RecordingDetails';
  readonly bucketArn?: Maybe<Scalars['String']['output']>;
  readonly bucketRegion: Scalars['String']['output'];
  readonly keyTemplate?: Maybe<Scalars['String']['output']>;
  readonly roleArn?: Maybe<Scalars['String']['output']>;
};

export type GsocS3RecordingDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocS3RecordingDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocS3RecordingDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocS3RecordingDetailsFilterInput>>;
  readonly bucketArn?: InputMaybe<StringFilterInput>;
  readonly bucketRegion?: InputMaybe<StringFilterInput>;
  readonly keyTemplate?: InputMaybe<StringFilterInput>;
  readonly roleArn?: InputMaybe<StringFilterInput>;
};

export type GsocSatellite = {
  readonly __typename?: 'GsocSatellite';
  /** Customer owning this satellite */
  readonly customer: GsocCustomer;
  /** AWS Satellite Resource ID */
  readonly id?: Maybe<Scalars['String']['output']>;
  /** Satellite Arn */
  readonly satelliteArn?: Maybe<Scalars['String']['output']>;
  /** Satellite Catalog Number */
  readonly satelliteCatalogNumber?: Maybe<Scalars['Int']['output']>;
  /** Satellite Name */
  readonly satelliteName?: Maybe<Scalars['String']['output']>;
  /** List of tags for tagging satellites for search purposes */
  readonly tags?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

export type GsocSatelliteAggregation = {
  readonly __typename?: 'GsocSatelliteAggregation';
  readonly satelliteCatalogNumber: Aggregation;
};

export type GsocSatelliteFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocSatelliteFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocSatelliteFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocSatelliteFilterInput>>;
  readonly customer?: InputMaybe<GsocCustomerFilterInput>;
  readonly satelliteArn?: InputMaybe<GsocStringFilterInput>;
  readonly satelliteCatalogNumber?: InputMaybe<IntegerFilterInput>;
  readonly satelliteName?: InputMaybe<GsocStringFilterInput>;
  readonly tags?: InputMaybe<GsocStringFilterInput>;
};

export type GsocSatelliteSortInput = {
  readonly satelliteArn?: InputMaybe<SortOrder>;
  readonly satelliteCatalogNumber?: InputMaybe<SortOrder>;
  readonly satelliteName?: InputMaybe<SortOrder>;
};

export type GsocSecurityDetails = {
  readonly __typename?: 'GsocSecurityDetails';
  readonly roleArn?: Maybe<Scalars['String']['output']>;
  readonly securityGroupIds: ReadonlyArray<Scalars['String']['output']>;
  readonly subnetIds: ReadonlyArray<Scalars['String']['output']>;
};

export type GsocSecurityDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocSecurityDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocSecurityDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocSecurityDetailsFilterInput>>;
  readonly roleArn?: InputMaybe<StringFilterInput>;
  readonly securityGroupIds?: InputMaybe<StringFilterInput>;
  readonly subnetIds?: InputMaybe<StringFilterInput>;
};

export type GsocStringFilterInput = {
  readonly _eq?: InputMaybe<Scalars['String']['input']>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _gt?: InputMaybe<Scalars['String']['input']>;
  readonly _gte?: InputMaybe<Scalars['String']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly _lt?: InputMaybe<Scalars['String']['input']>;
  readonly _lte?: InputMaybe<Scalars['String']['input']>;
  readonly _neq?: InputMaybe<Scalars['String']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly _startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type GsocTelemetryInformation = {
  readonly __typename?: 'GsocTelemetryInformation';
  readonly telemetryScopeId: Scalars['String']['output'];
  readonly telemetrySourceArn: Scalars['String']['output'];
};

export type GsocTelemetryInformationFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocTelemetryInformationFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocTelemetryInformationFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocTelemetryInformationFilterInput>>;
  readonly telemetryScopeId?: InputMaybe<StringFilterInput>;
  readonly telemetrySourceArn?: InputMaybe<StringFilterInput>;
};

export type GsocTimeRangeFilterInput = {
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly endTime?: InputMaybe<AwsDateTimeFilterInput>;
  readonly startTime?: InputMaybe<AwsDateTimeFilterInput>;
};

export type GsocUplinkDetails = {
  readonly __typename?: 'GsocUplinkDetails';
  readonly rfCharacteristics: GsocRfCharacteristics;
  readonly targetEirp: Measurement;
  readonly transmitDisabled: Scalars['Boolean']['output'];
};

export type GsocUplinkDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocUplinkDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocUplinkDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocUplinkDetailsFilterInput>>;
  readonly rfCharacteristics?: InputMaybe<GsocRfCharacteristicsFilterInput>;
  readonly targetEirp?: InputMaybe<MeasurementFilterInput>;
  readonly transmitDisabled?: InputMaybe<BooleanFilterInput>;
};

export type GsocUplinkEchoDetails = {
  readonly __typename?: 'GsocUplinkEchoDetails';
  readonly enabled: Scalars['Boolean']['output'];
  readonly rfCharacteristics: GsocRfCharacteristics;
};

export type GsocUplinkEchoDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocUplinkEchoDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocUplinkEchoDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocUplinkEchoDetailsFilterInput>>;
  readonly enabled?: InputMaybe<BooleanFilterInput>;
  readonly rfCharacteristics?: InputMaybe<GsocRfCharacteristicsFilterInput>;
};

export type InRegionAntennaDownlinkConfigData = {
  readonly __typename?: 'InRegionAntennaDownlinkConfigData';
  readonly bandwidth?: Maybe<Frequency>;
  readonly centerFrequency?: Maybe<Frequency>;
  readonly polarity?: Maybe<Polarization>;
};

export type InRegionAntennaDownlinkDemodDecodeConfigData = {
  readonly __typename?: 'InRegionAntennaDownlinkDemodDecodeConfigData';
  readonly bandwidthValue?: Maybe<Frequency>;
  readonly centerFrequency?: Maybe<Frequency>;
  readonly decodeConfigData?: Maybe<InRegionDecodeConfigData>;
  readonly demodulationConfigData?: Maybe<InRegionDemodulationConfigData>;
  readonly polarity?: Maybe<Polarization>;
};

export type InRegionAntennaDownlinkDemodDecodeExecutionContextData = {
  readonly __typename?: 'InRegionAntennaDownlinkDemodDecodeExecutionContextData';
  readonly antennaDownlinkDemodDecodeConfigData?: Maybe<InRegionAntennaDownlinkDemodDecodeConfigData>;
  readonly antennaDownlinkDemodDecodeConfigId?: Maybe<Scalars['String']['output']>;
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowType?: Maybe<CpDataflowType>;
  readonly executionContextDataflows?: Maybe<ReadonlyArray<InRegionExecutionContextDataflowData>>;
  readonly outputToDataDeliveryServiceSourceArnMap?: Maybe<ReadonlyArray<StringToStringMapEntry>>;
  readonly outputToDestinationMtuMap?: Maybe<ReadonlyArray<StringToIntegerMapEntry>>;
};

export type InRegionAntennaDownlinkExecutionContextData = {
  readonly __typename?: 'InRegionAntennaDownlinkExecutionContextData';
  readonly antennaDownlinkConfigData?: Maybe<InRegionAntennaDownlinkConfigData>;
  readonly antennaDownlinkConfigId?: Maybe<Scalars['String']['output']>;
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly dataDeliveryServiceSourceArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowType?: Maybe<CpDataflowType>;
  readonly executionContextDataflowData?: Maybe<InRegionExecutionContextDataflowData>;
};

export type InRegionAntennaUplinkConfigData = {
  readonly __typename?: 'InRegionAntennaUplinkConfigData';
  readonly centerFrequency?: Maybe<Frequency>;
  readonly polarity?: Maybe<Polarization>;
  readonly targetEirpUnit?: Maybe<Scalars['String']['output']>;
  readonly targetEirpValue?: Maybe<Scalars['Float']['output']>;
  readonly transmitDisabled?: Maybe<Scalars['Boolean']['output']>;
};

export type InRegionAntennaUplinkExecutionContextData = {
  readonly __typename?: 'InRegionAntennaUplinkExecutionContextData';
  readonly antennaUplinkConfigData?: Maybe<InRegionAntennaUplinkConfigData>;
  readonly antennaUplinkConfigId?: Maybe<Scalars['String']['output']>;
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly dataDeliveryServiceSourceArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowType?: Maybe<CpDataflowType>;
  readonly executionContextDataflowData?: Maybe<InRegionExecutionContextDataflowData>;
};

export type InRegionConnectionProxyExecutionContextData = {
  readonly __typename?: 'InRegionConnectionProxyExecutionContextData';
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowTranslation?: Maybe<DataflowTranslation>;
  readonly executionContextDataflowData?: Maybe<InRegionExecutionContextDataflowData>;
};

export enum InRegionContactDataType {
  ContactRequest = 'CONTACT_REQUEST',
  ExecutionContext = 'EXECUTION_CONTEXT'
}

export type InRegionContactDdbTable = {
  readonly __typename?: 'InRegionContactDdbTable';
  /** The contact identifier. */
  readonly contactId: Scalars['String']['output'];
  /** Present when CONTACT_REQUEST data type. */
  readonly contactRequestData?: Maybe<InRegionContactRequestData>;
  /** The data identifier for this record. */
  readonly dataUuid: Scalars['String']['output'];
  /** Present when EXECUTION_CONTEXT data type */
  readonly executionContext?: Maybe<Scalars['String']['output']>;
  /** Present when EXECUTION_CONTEXT data type, after parsing. */
  readonly executionContextStruct?: Maybe<InRegionExecutionContextData>;
  /** Enumeration to determine the record type. */
  readonly inRegionContactDataType: InRegionContactDataType;
  /** Version number of the record. */
  readonly versionNumber: Scalars['Int']['output'];
};

export type InRegionContactRequestData = {
  readonly __typename?: 'InRegionContactRequestData';
  readonly antennaSystemId?: Maybe<Scalars['String']['output']>;
  readonly awsAccountId?: Maybe<Scalars['String']['output']>;
  readonly capabilitiesToTest?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly contactArn?: Maybe<Scalars['String']['output']>;
  readonly contactId?: Maybe<Scalars['String']['output']>;
  readonly contactType?: Maybe<ContactType>;
  readonly createdInRegion?: Maybe<Scalars['String']['output']>;
  readonly dereferenceMissionProfileData?: Maybe<DereferencedMissionProfileData>;
  readonly groundstationId?: Maybe<Scalars['String']['output']>;
  readonly requestedNodes?: Maybe<ReadonlyArray<RequestedNodesMapEntry>>;
  readonly satelliteArn?: Maybe<Scalars['String']['output']>;
  readonly targetRegion?: Maybe<Scalars['String']['output']>;
};

export type InRegionDataflowEndpointExecutionContextData = {
  readonly __typename?: 'InRegionDataflowEndpointExecutionContextData';
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly dataDeliveryServiceDestinationArn?: Maybe<Scalars['String']['output']>;
  readonly dataDeliveryServiceSourceArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowEndpointGroupArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowType?: Maybe<CpDataflowType>;
  readonly executionContextDataflowData?: Maybe<InRegionExecutionContextDataflowData>;
};

export type InRegionDecodeConfigData = {
  readonly __typename?: 'InRegionDecodeConfigData';
  readonly unvalidatedJSON?: Maybe<Scalars['String']['output']>;
};

export type InRegionDemodulationConfigData = {
  readonly __typename?: 'InRegionDemodulationConfigData';
  readonly unvalidatedJSON?: Maybe<Scalars['String']['output']>;
};

export type InRegionExecutionContextData = {
  readonly __typename?: 'InRegionExecutionContextData';
  readonly antennaDownlinkDemodDecodeExecutionContextData?: Maybe<InRegionAntennaDownlinkDemodDecodeExecutionContextData>;
  readonly antennaDownlinkExecutionContextData?: Maybe<InRegionAntennaDownlinkExecutionContextData>;
  readonly antennaUplinkExecutionContextData?: Maybe<InRegionAntennaUplinkExecutionContextData>;
  readonly capabilityArn?: Maybe<Scalars['String']['output']>;
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly connectionProxyExecutionContextData?: Maybe<InRegionConnectionProxyExecutionContextData>;
  readonly dataflowEndpointExecutionContextData?: Maybe<InRegionDataflowEndpointExecutionContextData>;
  readonly dataflowType?: Maybe<CpDataflowType>;
  readonly executionContextId?: Maybe<Scalars['String']['output']>;
  readonly executionContextType?: Maybe<ConfigCapabilityType>;
  readonly laminarFlowConfigString?: Maybe<Scalars['String']['output']>;
  readonly managedAntennaDownlinkDemodDecodeExecutionContextData?: Maybe<InRegionManagedAntennaDownlinkDemodDecodeExecutionContextData>;
  readonly s3PlaybackExecutionContextData?: Maybe<InRegionS3PlaybackExecutionContextData>;
  readonly s3RecordingExecutionContextData?: Maybe<InRegionS3RecordingExecutionContextData>;
  readonly telemetryScopeId?: Maybe<Scalars['String']['output']>;
  readonly telemetrySourceArn?: Maybe<Scalars['String']['output']>;
  readonly trackingExecutionContextData?: Maybe<InRegionTrackingExecutionContextData>;
  readonly type?: Maybe<ConfigCapabilityType>;
  readonly uplinkEchoExecutionContextData?: Maybe<InRegionUplinkEchoExecutionContextData>;
};

export type InRegionExecutionContextDataflowData = {
  readonly __typename?: 'InRegionExecutionContextDataflowData';
  readonly dataflowId?: Maybe<Scalars['String']['output']>;
  readonly dataflowRate?: Maybe<Measurement>;
  readonly destinationIngressAddress?: Maybe<InRegionRangedSocketAddressInfo>;
  readonly egressAddress?: Maybe<InRegionRangedSocketAddressInfo>;
  readonly ingressAddress?: Maybe<InRegionRangedSocketAddressInfo>;
  readonly isMultiChannel?: Maybe<Scalars['Boolean']['output']>;
  readonly sourceAccount?: Maybe<Scalars['String']['output']>;
  readonly sourceArn?: Maybe<Scalars['String']['output']>;
  readonly sourceEgressAddress?: Maybe<InRegionRangedSocketAddressInfo>;
  readonly vita49StreamId?: Maybe<Scalars['Int']['output']>;
};

export type InRegionManagedAntennaDownlinkDemodDecodeConfigData = {
  readonly __typename?: 'InRegionManagedAntennaDownlinkDemodDecodeConfigData';
  readonly managedRadioConfigId?: Maybe<Scalars['String']['output']>;
  readonly spectrumConfig?: Maybe<InRegionManagedAntennaDownlinkDemodDecodeSpectrumConfig>;
  readonly supportedOutputTypes?: Maybe<ReadonlyArray<InRegionManagedAntennaDownlinkDemodDecodeSupportedOutputType>>;
};

export type InRegionManagedAntennaDownlinkDemodDecodeExecutionContextData = {
  readonly __typename?: 'InRegionManagedAntennaDownlinkDemodDecodeExecutionContextData';
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowType?: Maybe<CpDataflowType>;
  readonly executionContextDataflows?: Maybe<ReadonlyArray<InRegionExecutionContextDataflowData>>;
  readonly managedAntennaDownlinkDemodDecodeConfigData?: Maybe<InRegionManagedAntennaDownlinkDemodDecodeConfigData>;
  readonly managedAntennaDownlinkDemodDecodeConfigId?: Maybe<Scalars['String']['output']>;
};

export type InRegionManagedAntennaDownlinkDemodDecodeSpectrumConfig = {
  readonly __typename?: 'InRegionManagedAntennaDownlinkDemodDecodeSpectrumConfig';
  readonly bandwidth?: Maybe<Frequency>;
  readonly centerFrequency?: Maybe<Frequency>;
  readonly polarization?: Maybe<Polarization>;
};

export type InRegionManagedAntennaDownlinkDemodDecodeSupportedOutputType = {
  readonly __typename?: 'InRegionManagedAntennaDownlinkDemodDecodeSupportedOutputType';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type InRegionRangedSocketAddressInfo = {
  readonly __typename?: 'InRegionRangedSocketAddressInfo';
  readonly maximumPort?: Maybe<Scalars['Int']['output']>;
  readonly minimumPort?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type InRegionS3PlaybackConfigData = {
  readonly __typename?: 'InRegionS3PlaybackConfigData';
  readonly bucketArn?: Maybe<Scalars['String']['output']>;
  readonly bucketRegion?: Maybe<Scalars['String']['output']>;
  readonly playbackFrequency?: Maybe<Frequency>;
  readonly roleArn?: Maybe<Scalars['String']['output']>;
};

export type InRegionS3PlaybackConfigDto = {
  readonly __typename?: 'InRegionS3PlaybackConfigDto';
  readonly awsAccountId?: Maybe<Scalars['String']['output']>;
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly configId?: Maybe<Scalars['String']['output']>;
  readonly s3PlaybackConfigData?: Maybe<InRegionS3PlaybackConfigData>;
  readonly type?: Maybe<ConfigCapabilityType>;
};

export type InRegionS3PlaybackExecutionContextData = {
  readonly __typename?: 'InRegionS3PlaybackExecutionContextData';
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowType?: Maybe<CpDataflowType>;
  readonly executionContextDataflowData?: Maybe<InRegionExecutionContextDataflowData>;
  readonly s3PlaybackConfigDto?: Maybe<InRegionS3PlaybackConfigDto>;
};

export type InRegionS3RecordingConfigData = {
  readonly __typename?: 'InRegionS3RecordingConfigData';
  readonly bucketArn?: Maybe<Scalars['String']['output']>;
  readonly bucketRegion?: Maybe<Scalars['String']['output']>;
  readonly prefix?: Maybe<Scalars['String']['output']>;
  readonly roleArn?: Maybe<Scalars['String']['output']>;
};

export type InRegionS3RecordingConfigDto = {
  readonly __typename?: 'InRegionS3RecordingConfigDto';
  readonly awsAccountId?: Maybe<Scalars['String']['output']>;
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly configId?: Maybe<Scalars['String']['output']>;
  readonly createdInRegion?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly region?: Maybe<Scalars['String']['output']>;
  readonly s3RecordingConfigData?: Maybe<InRegionS3RecordingConfigData>;
  readonly type?: Maybe<ConfigCapabilityType>;
};

export type InRegionS3RecordingExecutionContextData = {
  readonly __typename?: 'InRegionS3RecordingExecutionContextData';
  readonly dataDeliveryServiceDestinationArn?: Maybe<Scalars['String']['output']>;
  readonly dataDeliveryServiceSourceArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowType?: Maybe<CpDataflowType>;
  readonly executionContextDataflowData?: Maybe<InRegionExecutionContextDataflowData>;
  readonly s3RecordingConfigDto?: Maybe<InRegionS3RecordingConfigDto>;
};

export type InRegionTrackingExecutionContextData = {
  readonly __typename?: 'InRegionTrackingExecutionContextData';
  readonly autotrackCriticality?: Maybe<CpCriticality>;
};

export type InRegionUplinkEchoConfigData = {
  readonly __typename?: 'InRegionUplinkEchoConfigData';
  readonly antennaUplinkArn?: Maybe<Scalars['String']['output']>;
  readonly centerFrequency?: Maybe<Frequency>;
  readonly enabled?: Maybe<Scalars['Boolean']['output']>;
  readonly polarity?: Maybe<Polarization>;
};

export type InRegionUplinkEchoExecutionContextData = {
  readonly __typename?: 'InRegionUplinkEchoExecutionContextData';
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly dataDeliveryServiceSourceArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowType?: Maybe<CpDataflowType>;
  readonly executionContextDataflowData?: Maybe<InRegionExecutionContextDataflowData>;
  readonly uplinkEchoConfigData?: Maybe<InRegionUplinkEchoConfigData>;
  readonly uplinkEchoConfigId?: Maybe<Scalars['String']['output']>;
};

export type IntegerFilterInput = {
  readonly _eq?: InputMaybe<Scalars['Int']['input']>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _gt?: InputMaybe<Scalars['Int']['input']>;
  readonly _gte?: InputMaybe<Scalars['Int']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly _lt?: InputMaybe<Scalars['Int']['input']>;
  readonly _lte?: InputMaybe<Scalars['Int']['input']>;
  readonly _neq?: InputMaybe<Scalars['Int']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
};

export type KinesisDataStreamData = {
  readonly __typename?: 'KinesisDataStreamData';
  readonly arn: Scalars['String']['output'];
  readonly roleArn: Scalars['String']['output'];
};

export type KinesisDataStreamDataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<KinesisDataStreamDataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<KinesisDataStreamDataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<KinesisDataStreamDataFilterInput>>;
  readonly arn?: InputMaybe<StringFilterInput>;
  readonly roleArn?: InputMaybe<StringFilterInput>;
};

export type KinesisDataStreamDataSortInput = {
  readonly arn?: InputMaybe<SortOrder>;
  readonly roleArn?: InputMaybe<SortOrder>;
};

export type LaminarFlowAgentMetadata = {
  readonly __typename?: 'LaminarFlowAgentMetadata';
  readonly agentAccountId?: Maybe<Scalars['String']['output']>;
  readonly agentDestinationInstanceId?: Maybe<Scalars['String']['output']>;
  readonly agentInstanceId?: Maybe<Scalars['String']['output']>;
  readonly agentInstanceType?: Maybe<Scalars['String']['output']>;
};

export type LaminarFlowAgentMetadataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LaminarFlowAgentMetadataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LaminarFlowAgentMetadataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LaminarFlowAgentMetadataFilterInput>>;
  readonly agentAccountId?: InputMaybe<StringFilterInput>;
  readonly agentDestinationInstanceId?: InputMaybe<StringFilterInput>;
  readonly agentInstanceId?: InputMaybe<StringFilterInput>;
  readonly agentInstanceType?: InputMaybe<StringFilterInput>;
};

export type LaminarFlowAgentMetadataSortInput = {
  readonly agentAccountId?: InputMaybe<SortOrder>;
  readonly agentDestinationInstanceId?: InputMaybe<SortOrder>;
  readonly agentInstanceId?: InputMaybe<SortOrder>;
  readonly agentInstanceType?: InputMaybe<SortOrder>;
};

export type LaminarFlowLossReportInput = {
  readonly endTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly excludeInternalContacts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly startTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type LaminarFlowLossReportOutput = {
  readonly __typename?: 'LaminarFlowLossReportOutput';
  readonly markdownText: Scalars['String']['output'];
};

export type LaminarFlowMetric = {
  readonly __typename?: 'LaminarFlowMetric';
  readonly avg?: Maybe<Scalars['Float']['output']>;
  readonly max?: Maybe<Scalars['Float']['output']>;
  readonly median?: Maybe<Scalars['Float']['output']>;
  readonly min?: Maybe<Scalars['Float']['output']>;
  readonly p50?: Maybe<Scalars['Float']['output']>;
  readonly p75?: Maybe<Scalars['Float']['output']>;
  readonly p90?: Maybe<Scalars['Float']['output']>;
  readonly p95?: Maybe<Scalars['Float']['output']>;
  readonly p99?: Maybe<Scalars['Float']['output']>;
  readonly stdDev?: Maybe<Scalars['Float']['output']>;
  readonly total?: Maybe<Scalars['Float']['output']>;
};

export type LaminarFlowMetricAggregation = {
  readonly __typename?: 'LaminarFlowMetricAggregation';
  readonly avg: Aggregation;
  readonly max: Aggregation;
  readonly median: Aggregation;
  readonly min: Aggregation;
  readonly p50: Aggregation;
  readonly p75: Aggregation;
  readonly p90: Aggregation;
  readonly p95: Aggregation;
  readonly p99: Aggregation;
  readonly stdDev: Aggregation;
  readonly total: Aggregation;
};

export type LaminarFlowMetricFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LaminarFlowMetricFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LaminarFlowMetricFilterInput>>;
  readonly avg?: InputMaybe<FloatFilterInput>;
  readonly max?: InputMaybe<FloatFilterInput>;
  readonly median?: InputMaybe<FloatFilterInput>;
  readonly min?: InputMaybe<FloatFilterInput>;
  readonly p50?: InputMaybe<FloatFilterInput>;
  readonly p75?: InputMaybe<FloatFilterInput>;
  readonly p90?: InputMaybe<FloatFilterInput>;
  readonly p95?: InputMaybe<FloatFilterInput>;
  readonly p99?: InputMaybe<FloatFilterInput>;
  readonly stdDev?: InputMaybe<FloatFilterInput>;
  readonly total?: InputMaybe<FloatFilterInput>;
};

export type LaminarFlowMetricSortInput = {
  readonly avg?: InputMaybe<SortOrder>;
  readonly max?: InputMaybe<SortOrder>;
  readonly median?: InputMaybe<SortOrder>;
  readonly min?: InputMaybe<SortOrder>;
  readonly p50?: InputMaybe<SortOrder>;
  readonly p75?: InputMaybe<SortOrder>;
  readonly p90?: InputMaybe<SortOrder>;
  readonly p95?: InputMaybe<SortOrder>;
  readonly p99?: InputMaybe<SortOrder>;
  readonly stdDev?: InputMaybe<SortOrder>;
  readonly total?: InputMaybe<SortOrder>;
};

export type LaminarFlowPlot = {
  readonly __typename?: 'LaminarFlowPlot';
  readonly agentId?: Maybe<Scalars['String']['output']>;
  readonly dataflowId?: Maybe<Scalars['String']['output']>;
  readonly imageBase64?: Maybe<Scalars['String']['output']>;
  readonly plotName?: Maybe<Scalars['String']['output']>;
  readonly presignedGetUrl?: Maybe<Scalars['String']['output']>;
  readonly s3Key: Scalars['String']['output'];
};

export type LfDecryptStageMetricsV2 = {
  readonly __typename?: 'LfDecryptStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decryption_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__input_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__output_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: Maybe<LaminarFlowMetric>;
  readonly metric__total_decryption_errors?: Maybe<LaminarFlowMetric>;
};

export type LfDecryptStageMetricsV2Aggregation = {
  readonly __typename?: 'LfDecryptStageMetricsV2Aggregation';
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__decryption_error_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__input_queue_underflow_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__total_input_queue_underflows: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__input_message_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__output_message_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__output_queue_overflow_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__total_output_queue_overflows: LaminarFlowMetricAggregation;
  readonly metric__total_decryption_errors: LaminarFlowMetricAggregation;
};

export type LfDecryptStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfDecryptStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfDecryptStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfDecryptStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decryption_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_decryption_errors?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfDecryptStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decryption_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_decryption_errors?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfEgressStageMetricsV2 = {
  readonly __typename?: 'LfEgressStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__average_bytes_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__average_datagrams_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__average_max_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__average_min_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__average_width_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__connection_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__connection_refused_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__initial_input_sequence_count?: Maybe<LaminarFlowMetric>;
  readonly metric__input_bit_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: Maybe<LaminarFlowMetric>;
  readonly metric__last_input_sequence_count?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__input_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__output_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__network_unreachable_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_bit_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__overall_timestamp_delta_sec_max?: Maybe<LaminarFlowMetric>;
  readonly metric__overall_timestamp_delta_sec_min?: Maybe<LaminarFlowMetric>;
  readonly metric__packets_lost_sequence_count?: Maybe<LaminarFlowMetric>;
  readonly metric__packets_out_of_order_sequence_count?: Maybe<LaminarFlowMetric>;
  readonly metric__socket_overflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__timestamp_delta_sec_max?: Maybe<LaminarFlowMetric>;
  readonly metric__timestamp_delta_sec_min?: Maybe<LaminarFlowMetric>;
  readonly metric__total_input_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__total_output_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__total_packets_lost_sequence_count?: Maybe<LaminarFlowMetric>;
  readonly metric__total_packets_out_of_order_sequence_count?: Maybe<LaminarFlowMetric>;
  readonly metric__total_retransmitted_messages?: Maybe<LaminarFlowMetric>;
  readonly metric__total_socket_overflows?: Maybe<LaminarFlowMetric>;
};

export type LfEgressStageMetricsV2Aggregation = {
  readonly __typename?: 'LfEgressStageMetricsV2Aggregation';
  readonly metric__average_bytes_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__average_datagrams_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__average_max_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__average_min_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__average_width_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__connection_error_rate: LaminarFlowMetricAggregation;
  readonly metric__connection_refused_error_rate: LaminarFlowMetricAggregation;
  readonly metric__initial_input_sequence_count: LaminarFlowMetricAggregation;
  readonly metric__input_bit_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__input_queue_underflow_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__total_input_queue_underflows: LaminarFlowMetricAggregation;
  readonly metric__last_input_sequence_count: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__input_message_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__output_message_rate: LaminarFlowMetricAggregation;
  readonly metric__network_unreachable_error_rate: LaminarFlowMetricAggregation;
  readonly metric__output_bit_rate: LaminarFlowMetricAggregation;
  readonly metric__overall_timestamp_delta_sec_max: LaminarFlowMetricAggregation;
  readonly metric__overall_timestamp_delta_sec_min: LaminarFlowMetricAggregation;
  readonly metric__packets_lost_sequence_count: LaminarFlowMetricAggregation;
  readonly metric__packets_out_of_order_sequence_count: LaminarFlowMetricAggregation;
  readonly metric__socket_overflow_rate: LaminarFlowMetricAggregation;
  readonly metric__timestamp_delta_sec_max: LaminarFlowMetricAggregation;
  readonly metric__timestamp_delta_sec_min: LaminarFlowMetricAggregation;
  readonly metric__total_input_bytes: LaminarFlowMetricAggregation;
  readonly metric__total_output_bytes: LaminarFlowMetricAggregation;
  readonly metric__total_packets_lost_sequence_count: LaminarFlowMetricAggregation;
  readonly metric__total_packets_out_of_order_sequence_count: LaminarFlowMetricAggregation;
  readonly metric__total_retransmitted_messages: LaminarFlowMetricAggregation;
  readonly metric__total_socket_overflows: LaminarFlowMetricAggregation;
};

export type LfEgressStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfEgressStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfEgressStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfEgressStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__average_bytes_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__average_datagrams_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__average_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__average_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__average_width_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__connection_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__connection_refused_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__initial_input_sequence_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_bit_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__last_input_sequence_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__network_unreachable_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_bit_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__overall_timestamp_delta_sec_max?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__overall_timestamp_delta_sec_min?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__packets_lost_sequence_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__packets_out_of_order_sequence_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__socket_overflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__timestamp_delta_sec_max?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__timestamp_delta_sec_min?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_input_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_output_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_packets_lost_sequence_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_packets_out_of_order_sequence_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_retransmitted_messages?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_socket_overflows?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfEgressStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__average_bytes_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__average_datagrams_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__average_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__average_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__average_width_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__connection_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__connection_refused_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__initial_input_sequence_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_bit_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__last_input_sequence_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__network_unreachable_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_bit_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__overall_timestamp_delta_sec_max?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__overall_timestamp_delta_sec_min?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__packets_lost_sequence_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__packets_out_of_order_sequence_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__socket_overflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__timestamp_delta_sec_max?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__timestamp_delta_sec_min?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_input_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_output_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_packets_lost_sequence_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_packets_out_of_order_sequence_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_retransmitted_messages?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_socket_overflows?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfEncryptStageMetricsV2 = {
  readonly __typename?: 'LfEncryptStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__encryption_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__input_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__output_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: Maybe<LaminarFlowMetric>;
  readonly metric__total_encryption_errors?: Maybe<LaminarFlowMetric>;
};

export type LfEncryptStageMetricsV2Aggregation = {
  readonly __typename?: 'LfEncryptStageMetricsV2Aggregation';
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__encryption_error_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__input_queue_underflow_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__total_input_queue_underflows: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__input_message_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__output_message_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__output_queue_overflow_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__total_output_queue_overflows: LaminarFlowMetricAggregation;
  readonly metric__total_encryption_errors: LaminarFlowMetricAggregation;
};

export type LfEncryptStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfEncryptStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfEncryptStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfEncryptStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__encryption_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_encryption_errors?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfEncryptStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__encryption_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_encryption_errors?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfIngressStageMetricsV2 = {
  readonly __typename?: 'LfIngressStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_bit_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_drop_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: Maybe<LaminarFlowMetric>;
  readonly metric__last_output_sequence_count?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__input_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__output_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_bit_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: Maybe<LaminarFlowMetric>;
  readonly metric__socket_back_off_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__socket_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__total_early_input_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__total_input_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__total_input_drops?: Maybe<LaminarFlowMetric>;
  readonly metric__total_late_input_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__total_output_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__total_socket_back_offs?: Maybe<LaminarFlowMetric>;
  readonly metric__total_socket_errors?: Maybe<LaminarFlowMetric>;
  readonly metric__total_timely_input_bytes?: Maybe<LaminarFlowMetric>;
};

export type LfIngressStageMetricsV2Aggregation = {
  readonly __typename?: 'LfIngressStageMetricsV2Aggregation';
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__input_bit_rate: LaminarFlowMetricAggregation;
  readonly metric__input_drop_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__input_queue_underflow_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__total_input_queue_underflows: LaminarFlowMetricAggregation;
  readonly metric__last_output_sequence_count: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__input_message_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__output_message_rate: LaminarFlowMetricAggregation;
  readonly metric__output_bit_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__output_queue_overflow_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__total_output_queue_overflows: LaminarFlowMetricAggregation;
  readonly metric__socket_back_off_rate: LaminarFlowMetricAggregation;
  readonly metric__socket_error_rate: LaminarFlowMetricAggregation;
  readonly metric__total_early_input_bytes: LaminarFlowMetricAggregation;
  readonly metric__total_input_bytes: LaminarFlowMetricAggregation;
  readonly metric__total_input_drops: LaminarFlowMetricAggregation;
  readonly metric__total_late_input_bytes: LaminarFlowMetricAggregation;
  readonly metric__total_output_bytes: LaminarFlowMetricAggregation;
  readonly metric__total_socket_back_offs: LaminarFlowMetricAggregation;
  readonly metric__total_socket_errors: LaminarFlowMetricAggregation;
  readonly metric__total_timely_input_bytes: LaminarFlowMetricAggregation;
};

export type LfIngressStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfIngressStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfIngressStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfIngressStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_bit_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_drop_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__last_output_sequence_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_bit_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__socket_back_off_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__socket_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_early_input_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_input_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_input_drops?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_late_input_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_output_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_socket_back_offs?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_socket_errors?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_timely_input_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfIngressStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_bit_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_drop_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__last_output_sequence_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_bit_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__socket_back_off_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__socket_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_early_input_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_input_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_input_drops?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_late_input_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_output_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_socket_back_offs?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_socket_errors?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_timely_input_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfStripeDecodeStageMetricsV2 = {
  readonly __typename?: 'LfStripeDecodeStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_block_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_missing_history?: Maybe<ReadonlyArray<Scalars['Float']['output']>>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__head_block_set_number?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: Maybe<LaminarFlowMetric>;
  readonly metric__last_processed_stripe_index?: Maybe<LaminarFlowMetric>;
  readonly metric__output_block_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: Maybe<LaminarFlowMetric>;
  readonly metric__tail_block_set_number?: Maybe<LaminarFlowMetric>;
};

export type LfStripeDecodeStageMetricsV2Aggregation = {
  readonly __typename?: 'LfStripeDecodeStageMetricsV2Aggregation';
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_block_error_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_block_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_duplicated: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_missing: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_orphaned: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_recovered: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_stale: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate: LaminarFlowMetricAggregation;
  readonly metric__head_block_set_number: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__input_queue_underflow_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__total_input_queue_underflows: LaminarFlowMetricAggregation;
  readonly metric__last_processed_stripe_index: LaminarFlowMetricAggregation;
  readonly metric__output_block_error_rate: LaminarFlowMetricAggregation;
  readonly metric__output_message_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__output_queue_overflow_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__total_output_queue_overflows: LaminarFlowMetricAggregation;
  readonly metric__tail_block_set_number: LaminarFlowMetricAggregation;
};

export type LfStripeDecodeStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfStripeDecodeStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfStripeDecodeStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfStripeDecodeStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_block_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing_history?: InputMaybe<FloatFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__head_block_set_number?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__last_processed_stripe_index?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_block_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__tail_block_set_number?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfStripeDecodeStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_block_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__head_block_set_number?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__last_processed_stripe_index?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_block_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__tail_block_set_number?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfStripeDecodeStageMetricsV3 = {
  readonly __typename?: 'LfStripeDecodeStageMetricsV3';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_block_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_missing_history?: Maybe<ReadonlyArray<Scalars['Float']['output']>>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__head_block_set_number?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: Maybe<LaminarFlowMetric>;
  readonly metric__last_processed_stripe_index?: Maybe<LaminarFlowMetric>;
  readonly metric__output_block_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: Maybe<LaminarFlowMetric>;
  readonly metric__tail_block_set_number?: Maybe<LaminarFlowMetric>;
};

export type LfStripeDecodeStageMetricsV3Aggregation = {
  readonly __typename?: 'LfStripeDecodeStageMetricsV3Aggregation';
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_block_error_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_block_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_duplicated: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_missing: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_orphaned: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_recovered: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_stale: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate: LaminarFlowMetricAggregation;
  readonly metric__head_block_set_number: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__input_queue_underflow_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__total_input_queue_underflows: LaminarFlowMetricAggregation;
  readonly metric__last_processed_stripe_index: LaminarFlowMetricAggregation;
  readonly metric__output_block_error_rate: LaminarFlowMetricAggregation;
  readonly metric__output_message_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__output_queue_overflow_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__total_output_queue_overflows: LaminarFlowMetricAggregation;
  readonly metric__tail_block_set_number: LaminarFlowMetricAggregation;
};

export type LfStripeDecodeStageMetricsV3FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfStripeDecodeStageMetricsV3FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfStripeDecodeStageMetricsV3FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfStripeDecodeStageMetricsV3FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_block_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing_history?: InputMaybe<FloatFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__head_block_set_number?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__last_processed_stripe_index?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_block_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__tail_block_set_number?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfStripeDecodeStageMetricsV3SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_block_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__head_block_set_number?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__last_processed_stripe_index?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_block_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__tail_block_set_number?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfStripeEncodeStageMetricsV2 = {
  readonly __typename?: 'LfStripeEncodeStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__input_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__output_message_rate?: Maybe<LaminarFlowMetric>;
};

export type LfStripeEncodeStageMetricsV2Aggregation = {
  readonly __typename?: 'LfStripeEncodeStageMetricsV2Aggregation';
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__input_message_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__output_message_rate: LaminarFlowMetricAggregation;
};

export type LfStripeEncodeStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfStripeEncodeStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfStripeEncodeStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfStripeEncodeStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfStripeEncodeStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfTimeDecodeStageMetricsV2 = {
  readonly __typename?: 'LfTimeDecodeStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_block_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_missing_history?: Maybe<ReadonlyArray<Scalars['Float']['output']>>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: Maybe<LaminarFlowMetric>;
  readonly metric__output_block_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: Maybe<LaminarFlowMetric>;
};

export type LfTimeDecodeStageMetricsV2Aggregation = {
  readonly __typename?: 'LfTimeDecodeStageMetricsV2Aggregation';
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_block_error_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_block_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_duplicated: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_missing: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_orphaned: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_recovered: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_stale: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__input_queue_underflow_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__total_input_queue_underflows: LaminarFlowMetricAggregation;
  readonly metric__output_block_error_rate: LaminarFlowMetricAggregation;
  readonly metric__output_message_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__output_queue_overflow_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__total_output_queue_overflows: LaminarFlowMetricAggregation;
};

export type LfTimeDecodeStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfTimeDecodeStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfTimeDecodeStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfTimeDecodeStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_block_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing_history?: InputMaybe<FloatFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_block_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfTimeDecodeStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_block_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_block_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfTimeDecodeStageMetricsV3 = {
  readonly __typename?: 'LfTimeDecodeStageMetricsV3';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_block_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_missing_history?: Maybe<ReadonlyArray<Scalars['Float']['output']>>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: Maybe<LaminarFlowMetric>;
  readonly metric__output_block_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: Maybe<LaminarFlowMetric>;
};

export type LfTimeDecodeStageMetricsV3Aggregation = {
  readonly __typename?: 'LfTimeDecodeStageMetricsV3Aggregation';
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_block_error_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_block_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_duplicated: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_missing: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_orphaned: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_recovered: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_stale: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__input_queue_underflow_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__total_input_queue_underflows: LaminarFlowMetricAggregation;
  readonly metric__output_block_error_rate: LaminarFlowMetricAggregation;
  readonly metric__output_message_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__output_queue_overflow_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__total_output_queue_overflows: LaminarFlowMetricAggregation;
};

export type LfTimeDecodeStageMetricsV3FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfTimeDecodeStageMetricsV3FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfTimeDecodeStageMetricsV3FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfTimeDecodeStageMetricsV3FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_block_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing_history?: InputMaybe<FloatFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_block_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfTimeDecodeStageMetricsV3SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_block_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_block_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfTimeEncodeStageMetricsV2 = {
  readonly __typename?: 'LfTimeEncodeStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__input_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__output_message_rate?: Maybe<LaminarFlowMetric>;
};

export type LfTimeEncodeStageMetricsV2Aggregation = {
  readonly __typename?: 'LfTimeEncodeStageMetricsV2Aggregation';
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__input_message_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__output_message_rate: LaminarFlowMetricAggregation;
};

export type LfTimeEncodeStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfTimeEncodeStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfTimeEncodeStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfTimeEncodeStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfTimeEncodeStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfTracerouteStageMetricsV2 = {
  readonly __typename?: 'LfTracerouteStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__dest?: Maybe<Scalars['String']['output']>;
  readonly metric__hop_count?: Maybe<Scalars['Int']['output']>;
  readonly metric__hops__addr?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly metric__hops__est_rtt?: Maybe<ReadonlyArray<Scalars['Float']['output']>>;
  readonly metric__hops__ttl?: Maybe<ReadonlyArray<Scalars['Float']['output']>>;
  readonly metric__id?: Maybe<Scalars['String']['output']>;
  readonly metric__source?: Maybe<Scalars['String']['output']>;
  readonly metric__status?: Maybe<Scalars['String']['output']>;
  readonly timestamp?: Maybe<Scalars['String']['output']>;
};

export type LfTracerouteStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfTracerouteStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfTracerouteStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfTracerouteStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__dest?: InputMaybe<StringFilterInput>;
  readonly metric__hop_count?: InputMaybe<IntegerFilterInput>;
  readonly metric__hops__addr?: InputMaybe<StringFilterInput>;
  readonly metric__hops__est_rtt?: InputMaybe<FloatFilterInput>;
  readonly metric__hops__ttl?: InputMaybe<FloatFilterInput>;
  readonly metric__id?: InputMaybe<StringFilterInput>;
  readonly metric__source?: InputMaybe<StringFilterInput>;
  readonly metric__status?: InputMaybe<StringFilterInput>;
  readonly timestamp?: InputMaybe<StringFilterInput>;
};

export type LfWanRxStageMetricsV2 = {
  readonly __typename?: 'LfWanRxStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__bytes_metrics__input_bit_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__bytes_metrics__output_bit_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__bytes_metrics__total_input_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__bytes_metrics__total_output_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__selected_lessor?: Maybe<Scalars['String']['output']>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__received_heartbeat_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__selected_lessee?: Maybe<Scalars['String']['output']>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__transmitted_heartbeat_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__transmitted_lease_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_success_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__input_control_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__output_control_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_input_control_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_output_control_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__input_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__output_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: Maybe<LaminarFlowMetric>;
};

export type LfWanRxStageMetricsV2Aggregation = {
  readonly __typename?: 'LfWanRxStageMetricsV2Aggregation';
  readonly metric__bytes_metrics__input_bit_rate: LaminarFlowMetricAggregation;
  readonly metric__bytes_metrics__output_bit_rate: LaminarFlowMetricAggregation;
  readonly metric__bytes_metrics__total_input_bytes: LaminarFlowMetricAggregation;
  readonly metric__bytes_metrics__total_output_bytes: LaminarFlowMetricAggregation;
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__received_heartbeat_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__transmitted_heartbeat_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__transmitted_lease_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_error_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_success_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__input_control_message_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__output_control_message_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_input_control_message_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_output_control_message_rate: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_error_count: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_rate: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_error_count: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_rate: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_error_count: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_rate: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_error_count: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__input_message_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__output_message_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__output_queue_overflow_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__total_output_queue_overflows: LaminarFlowMetricAggregation;
};

export type LfWanRxStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfWanRxStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfWanRxStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfWanRxStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__bytes_metrics__input_bit_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__bytes_metrics__output_bit_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__bytes_metrics__total_input_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__bytes_metrics__total_output_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__selected_lessor?: InputMaybe<StringFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__received_heartbeat_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__selected_lessee?: InputMaybe<StringFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__transmitted_heartbeat_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__transmitted_lease_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_success_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__input_control_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__output_control_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_input_control_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_output_control_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfWanRxStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__bytes_metrics__input_bit_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__bytes_metrics__output_bit_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__bytes_metrics__total_input_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__bytes_metrics__total_output_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__selected_lessor?: InputMaybe<SortOrder>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__received_heartbeat_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__selected_lessee?: InputMaybe<SortOrder>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__transmitted_heartbeat_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__transmitted_lease_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_success_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__input_control_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__output_control_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_input_control_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_output_control_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfWanTxStageMetricsV2 = {
  readonly __typename?: 'LfWanTxStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__bytes_metrics__input_bit_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__bytes_metrics__output_bit_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__bytes_metrics__total_input_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__bytes_metrics__total_output_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__received_heartbeat_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__received_lease_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__selected_lessor?: Maybe<Scalars['String']['output']>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__transmitted_heartbeat_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__selected_lessee?: Maybe<Scalars['String']['output']>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_success_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__input_control_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__output_control_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_input_control_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_output_control_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__dropped_message_count?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__input_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__output_message_rate?: Maybe<LaminarFlowMetric>;
};

export type LfWanTxStageMetricsV2Aggregation = {
  readonly __typename?: 'LfWanTxStageMetricsV2Aggregation';
  readonly metric__bytes_metrics__input_bit_rate: LaminarFlowMetricAggregation;
  readonly metric__bytes_metrics__output_bit_rate: LaminarFlowMetricAggregation;
  readonly metric__bytes_metrics__total_input_bytes: LaminarFlowMetricAggregation;
  readonly metric__bytes_metrics__total_output_bytes: LaminarFlowMetricAggregation;
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__received_heartbeat_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__received_lease_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__transmitted_heartbeat_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_error_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_success_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__input_control_message_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__output_control_message_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_input_control_message_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_output_control_message_rate: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_error_count: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_rate: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_error_count: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_rate: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_error_count: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_rate: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_error_count: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_rate: LaminarFlowMetricAggregation;
  readonly metric__dropped_message_count: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__input_queue_underflow_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__total_input_queue_underflows: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__input_message_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__output_message_rate: LaminarFlowMetricAggregation;
};

export type LfWanTxStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfWanTxStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfWanTxStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfWanTxStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__bytes_metrics__input_bit_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__bytes_metrics__output_bit_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__bytes_metrics__total_input_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__bytes_metrics__total_output_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__received_heartbeat_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__received_lease_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__selected_lessor?: InputMaybe<StringFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__transmitted_heartbeat_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__selected_lessee?: InputMaybe<StringFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_success_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__input_control_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__output_control_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_input_control_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_output_control_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__dropped_message_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfWanTxStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__bytes_metrics__input_bit_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__bytes_metrics__output_bit_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__bytes_metrics__total_input_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__bytes_metrics__total_output_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__received_heartbeat_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__received_lease_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__selected_lessor?: InputMaybe<SortOrder>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__transmitted_heartbeat_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__selected_lessee?: InputMaybe<SortOrder>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_success_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__input_control_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__output_control_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_input_control_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_output_control_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__dropped_message_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type ListConfigInput = {
  readonly cursor?: InputMaybe<ReadonlyArray<CursorPartInput>>;
  readonly limit?: InputMaybe<Scalars['Int']['input']>;
  readonly sort?: InputMaybe<ReadonlyArray<ConfigSortInput>>;
  readonly where?: InputMaybe<ConfigFilterInput>;
};

export type ListConfigOutput = {
  readonly __typename?: 'ListConfigOutput';
  readonly aggregations: ConfigAggregation;
  readonly pageInfo: PageInfo;
  readonly results: ReadonlyArray<Config>;
};

export type ListContactVersionInput = {
  readonly cursor?: InputMaybe<ReadonlyArray<CursorPartInput>>;
  readonly limit?: InputMaybe<Scalars['Int']['input']>;
  readonly sort?: InputMaybe<ReadonlyArray<ContactVersionSortInput>>;
  readonly where?: InputMaybe<ContactVersionFilterInput>;
};

export type ListContactVersionOutput = {
  readonly __typename?: 'ListContactVersionOutput';
  readonly aggregations: ContactVersionAggregation;
  readonly pageInfo: PageInfo;
  readonly results: ReadonlyArray<ContactVersion>;
};

export type ListDataPlaneDdxMetricInput = {
  readonly cursor?: InputMaybe<ReadonlyArray<CursorPartInput>>;
  readonly limit?: InputMaybe<Scalars['Int']['input']>;
  readonly sort?: InputMaybe<ReadonlyArray<DataPlaneDdxMetricSortInput>>;
  readonly where?: InputMaybe<DataPlaneDdxMetricFilterInput>;
};

export type ListDataPlaneDdxMetricOutput = {
  readonly __typename?: 'ListDataPlaneDDXMetricOutput';
  readonly pageInfo: PageInfo;
  readonly results: ReadonlyArray<DataPlaneDdxMetric>;
};

export type ListDataPlaneLfMetricInput = {
  readonly cursor?: InputMaybe<ReadonlyArray<CursorPartInput>>;
  readonly limit?: InputMaybe<Scalars['Int']['input']>;
  readonly sort?: InputMaybe<ReadonlyArray<DataPlaneLfMetricSortInput>>;
  readonly where?: InputMaybe<DataPlaneLfMetricFilterInput>;
};

export type ListDataPlaneLfMetricOutput = {
  readonly __typename?: 'ListDataPlaneLFMetricOutput';
  readonly aggregations: DataPlaneLfMetricAggregation;
  readonly pageInfo: PageInfo;
  readonly results: ReadonlyArray<DataPlaneLfMetric>;
};

export type ListGsocContactV2Input = {
  readonly cursor?: InputMaybe<ReadonlyArray<CursorPartInput>>;
  readonly limit?: InputMaybe<Scalars['Int']['input']>;
  readonly sort?: InputMaybe<ReadonlyArray<GsocContactV2SortInput>>;
  readonly where?: InputMaybe<GsocContactV2FilterInput>;
};

export type ListGsocContactV2Output = {
  readonly __typename?: 'ListGsocContactV2Output';
  readonly aggregations: GsocContactV2Aggregation;
  readonly pageInfo: PageInfo;
  readonly results: ReadonlyArray<GsocContactV2>;
};

export type ListGsocContactsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<ListGsocContactsFilterInput>>;
  readonly _not?: InputMaybe<ListGsocContactsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<ListGsocContactsFilterInput>>;
  readonly contactId?: InputMaybe<GsocStringFilterInput>;
  readonly contactStatus?: InputMaybe<GsocContactStatusFilterInput>;
  readonly customer?: InputMaybe<GsocCustomerFilterInput>;
  readonly destinationRegions?: InputMaybe<GsocStringFilterInput>;
  readonly groundStations?: InputMaybe<GsocGroundStationFilterInput>;
  readonly missionProfile?: InputMaybe<GsocMissionProfileFilterInput>;
  readonly satellite?: InputMaybe<GsocSatelliteFilterInput>;
  readonly schedulingRegion?: InputMaybe<GsocStringFilterInput>;
  readonly tags?: InputMaybe<GsocStringFilterInput>;
  readonly telemetryRouteList?: InputMaybe<GsocStringFilterInput>;
  readonly timeRange?: InputMaybe<GsocTimeRangeFilterInput>;
};

export type ListGsocContactsSortInput = {
  readonly contactId?: InputMaybe<SortOrder>;
  readonly contactStatus?: InputMaybe<SortOrder>;
  readonly customer?: InputMaybe<GsocCustomerSortInput>;
  readonly missionProfile?: InputMaybe<GsocMissionProfileSortInput>;
  readonly satellite?: InputMaybe<GsocSatelliteSortInput>;
  readonly schedulingRegion?: InputMaybe<SortOrder>;
  readonly timeRange?: InputMaybe<TimeRangeSortInput>;
};

export type ListMissionProfileInput = {
  readonly cursor?: InputMaybe<ReadonlyArray<CursorPartInput>>;
  readonly limit?: InputMaybe<Scalars['Int']['input']>;
  readonly sort?: InputMaybe<ReadonlyArray<MissionProfileSortInput>>;
  readonly where?: InputMaybe<MissionProfileFilterInput>;
};

export type ListMissionProfileOutput = {
  readonly __typename?: 'ListMissionProfileOutput';
  readonly aggregations: MissionProfileAggregation;
  readonly pageInfo: PageInfo;
  readonly results: ReadonlyArray<MissionProfile>;
};

export type ManagedAntennaDownlinkDemodDecodeConfigData = {
  readonly __typename?: 'ManagedAntennaDownlinkDemodDecodeConfigData';
  readonly managedRadioConfigId: Scalars['String']['output'];
  readonly spectrumConfig: SpectrumConfig;
  readonly supportedOutputTypes: ReadonlyArray<SupportedOutputType>;
};

export type ManagedAntennaDownlinkDemodDecodeConfigDataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<ManagedAntennaDownlinkDemodDecodeConfigDataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<ManagedAntennaDownlinkDemodDecodeConfigDataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<ManagedAntennaDownlinkDemodDecodeConfigDataFilterInput>>;
  readonly managedRadioConfigId?: InputMaybe<StringFilterInput>;
  readonly spectrumConfig?: InputMaybe<SpectrumConfigFilterInput>;
  readonly supportedOutputTypes?: InputMaybe<SupportedOutputTypeFilterInput>;
};

export type ManagedAntennaDownlinkDemodDecodeConfigDataSortInput = {
  readonly managedRadioConfigId?: InputMaybe<SortOrder>;
  readonly spectrumConfig?: InputMaybe<SpectrumConfigSortInput>;
};

export type Measure = {
  readonly __typename?: 'Measure';
  readonly unit: Scalars['String']['output'];
  readonly value: Scalars['Float']['output'];
};

export type MeasureFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<MeasureFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<MeasureFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<MeasureFilterInput>>;
  readonly unit?: InputMaybe<StringFilterInput>;
  readonly value?: InputMaybe<FloatFilterInput>;
};

export type MeasureSortInput = {
  readonly unit?: InputMaybe<SortOrder>;
  readonly value?: InputMaybe<SortOrder>;
};

export type Measurement = {
  readonly __typename?: 'Measurement';
  readonly unit: Scalars['String']['output'];
  readonly value: Scalars['Float']['output'];
};

export type MeasurementFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<MeasurementFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<MeasurementFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<MeasurementFilterInput>>;
  readonly unit?: InputMaybe<StringFilterInput>;
  readonly value?: InputMaybe<FloatFilterInput>;
};

export enum MeteringStatus {
  MeteringFailed = 'METERING_FAILED',
  MeteringQueued = 'METERING_QUEUED',
  MeteringRequiredCancelled = 'METERING_REQUIRED_CANCELLED',
  MeteringRequiredCompleted = 'METERING_REQUIRED_COMPLETED',
  MeteringRequiredNegative = 'METERING_REQUIRED_NEGATIVE'
}

export enum MeteringUsage {
  Midband = 'MIDBAND',
  Narrowband = 'NARROWBAND',
  Wideband = 'WIDEBAND'
}

export type MissionProfile = {
  readonly __typename?: 'MissionProfile';
  readonly awsAccountId: Scalars['String']['output'];
  readonly contactPostPassDurationSeconds: Scalars['Int']['output'];
  readonly contactPrePassDurationSeconds: Scalars['Int']['output'];
  readonly dataflowEdges: ReadonlyArray<DataflowEdge>;
  readonly expirationTime?: Maybe<Scalars['AWSDateTime']['output']>;
  readonly id: Scalars['String']['output'];
  readonly kmsDataKeyGenerationKeyGrantId?: Maybe<Scalars['String']['output']>;
  readonly kmsDecryptKeyGrantId?: Maybe<Scalars['String']['output']>;
  readonly kmsKeyGrantId?: Maybe<Scalars['String']['output']>;
  readonly minViableContactDurationSeconds: Scalars['Int']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly region: Scalars['String']['output'];
  readonly streamsKmsKey?: Maybe<StreamsKmsKeyInfo>;
  readonly streamsKmsRole?: Maybe<Scalars['String']['output']>;
  readonly telemetrySinkConfig?: Maybe<Config>;
  readonly telemetrySinkConfigArn?: Maybe<Scalars['String']['output']>;
  readonly telemetrySinkConfigId?: Maybe<Scalars['String']['output']>;
  readonly timestamp: Scalars['AWSDateTime']['output'];
  readonly trackingConfig?: Maybe<Config>;
  readonly trackingConfigArn?: Maybe<Scalars['String']['output']>;
  readonly trackingConfigId?: Maybe<Scalars['String']['output']>;
  readonly version: Scalars['Int']['output'];
};

export type MissionProfileAggregation = {
  readonly __typename?: 'MissionProfileAggregation';
  readonly contactPostPassDurationSeconds: Aggregation;
  readonly contactPrePassDurationSeconds: Aggregation;
  readonly minViableContactDurationSeconds: Aggregation;
  readonly telemetrySinkConfig: ConfigAggregation;
  readonly trackingConfig: ConfigAggregation;
  readonly version: Aggregation;
};

export type MissionProfileFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<MissionProfileFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<MissionProfileFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<MissionProfileFilterInput>>;
  readonly awsAccountId?: InputMaybe<StringFilterInput>;
  readonly contactPostPassDurationSeconds?: InputMaybe<IntegerFilterInput>;
  readonly contactPrePassDurationSeconds?: InputMaybe<IntegerFilterInput>;
  readonly dataflowEdges?: InputMaybe<DataflowEdgeFilterInput>;
  readonly expirationTime?: InputMaybe<TimestampFilterInput>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly kmsDataKeyGenerationKeyGrantId?: InputMaybe<StringFilterInput>;
  readonly kmsDecryptKeyGrantId?: InputMaybe<StringFilterInput>;
  readonly kmsKeyGrantId?: InputMaybe<StringFilterInput>;
  readonly minViableContactDurationSeconds?: InputMaybe<IntegerFilterInput>;
  readonly name?: InputMaybe<StringFilterInput>;
  readonly region?: InputMaybe<StringFilterInput>;
  readonly streamsKmsKey?: InputMaybe<StreamsKmsKeyInfoFilterInput>;
  readonly streamsKmsRole?: InputMaybe<StringFilterInput>;
  readonly telemetrySinkConfig?: InputMaybe<ConfigFilterInput>;
  readonly telemetrySinkConfigArn?: InputMaybe<StringFilterInput>;
  readonly telemetrySinkConfigId?: InputMaybe<StringFilterInput>;
  readonly timestamp?: InputMaybe<TimestampFilterInput>;
  readonly trackingConfig?: InputMaybe<ConfigFilterInput>;
  readonly trackingConfigArn?: InputMaybe<StringFilterInput>;
  readonly trackingConfigId?: InputMaybe<StringFilterInput>;
  readonly version?: InputMaybe<IntegerFilterInput>;
};

export type MissionProfileSortInput = {
  readonly awsAccountId?: InputMaybe<SortOrder>;
  readonly contactPostPassDurationSeconds?: InputMaybe<SortOrder>;
  readonly contactPrePassDurationSeconds?: InputMaybe<SortOrder>;
  readonly expirationTime?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly kmsDataKeyGenerationKeyGrantId?: InputMaybe<SortOrder>;
  readonly kmsDecryptKeyGrantId?: InputMaybe<SortOrder>;
  readonly kmsKeyGrantId?: InputMaybe<SortOrder>;
  readonly minViableContactDurationSeconds?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
  readonly region?: InputMaybe<SortOrder>;
  readonly streamsKmsKey?: InputMaybe<StreamsKmsKeyInfoSortInput>;
  readonly streamsKmsRole?: InputMaybe<SortOrder>;
  readonly telemetrySinkConfig?: InputMaybe<ConfigSortInput>;
  readonly telemetrySinkConfigArn?: InputMaybe<SortOrder>;
  readonly telemetrySinkConfigId?: InputMaybe<SortOrder>;
  readonly timestamp?: InputMaybe<SortOrder>;
  readonly trackingConfig?: InputMaybe<ConfigSortInput>;
  readonly trackingConfigArn?: InputMaybe<SortOrder>;
  readonly trackingConfigId?: InputMaybe<SortOrder>;
  readonly version?: InputMaybe<SortOrder>;
};

export type NamedImage = {
  readonly __typename?: 'NamedImage';
  readonly imageBase64: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
};

export type NamedImageV2 = {
  readonly __typename?: 'NamedImageV2';
  readonly image: S3Object;
  readonly name: Scalars['String']['output'];
};

export type NamedImageV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<NamedImageV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<NamedImageV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<NamedImageV2FilterInput>>;
  readonly image?: InputMaybe<S3ObjectFilterInput>;
  readonly name?: InputMaybe<StringFilterInput>;
};

export type OemProgramTrackSettings = {
  readonly __typename?: 'OemProgramTrackSettings';
  readonly ephemerisId: Scalars['String']['output'];
};

export type OemProgramTrackSettingsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<OemProgramTrackSettingsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<OemProgramTrackSettingsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<OemProgramTrackSettingsFilterInput>>;
  readonly ephemerisId?: InputMaybe<StringFilterInput>;
};

export type OemProgramTrackSettingsSortInput = {
  readonly ephemerisId?: InputMaybe<SortOrder>;
};

export type PageInfo = {
  readonly __typename?: 'PageInfo';
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly lastCursor?: Maybe<ReadonlyArray<CursorPart>>;
  readonly total: Total;
};

export enum Polarization {
  Both = 'BOTH',
  LeftHand = 'LEFT_HAND',
  None = 'NONE',
  RightHand = 'RIGHT_HAND'
}

export type PolarizationFilterInput = {
  readonly _eq?: InputMaybe<Polarization>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Polarization>>;
  readonly _neq?: InputMaybe<Polarization>;
  readonly _nin?: InputMaybe<ReadonlyArray<Polarization>>;
};

export type PostPassImage = {
  readonly __typename?: 'PostPassImage';
  readonly dataflowId?: Maybe<Scalars['String']['output']>;
  readonly imageBase64?: Maybe<Scalars['String']['output']>;
  readonly jobId?: Maybe<Scalars['String']['output']>;
  readonly presignedGetUrl?: Maybe<Scalars['String']['output']>;
  readonly s3Key: Scalars['String']['output'];
};

export type PresignedDeviceDetail = {
  readonly __typename?: 'PresignedDeviceDetail';
  readonly url?: Maybe<Scalars['String']['output']>;
};

export type PresignedS3Metric = {
  readonly __typename?: 'PresignedS3Metric';
  readonly agentId?: Maybe<Scalars['String']['output']>;
  readonly dataflowId?: Maybe<Scalars['String']['output']>;
  readonly taskId?: Maybe<Scalars['String']['output']>;
  readonly url?: Maybe<Scalars['String']['output']>;
};

export type ProgramTrackSettings = {
  readonly __typename?: 'ProgramTrackSettings';
  readonly azEl?: Maybe<AzElProgramTrackSettings>;
  readonly oem?: Maybe<OemProgramTrackSettings>;
  readonly tle?: Maybe<TleProgramTrackSettings>;
};

export type ProgramTrackSettingsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<ProgramTrackSettingsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<ProgramTrackSettingsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<ProgramTrackSettingsFilterInput>>;
  readonly azEl?: InputMaybe<AzElProgramTrackSettingsFilterInput>;
  readonly oem?: InputMaybe<OemProgramTrackSettingsFilterInput>;
  readonly tle?: InputMaybe<TleProgramTrackSettingsFilterInput>;
};

export type ProgramTrackSettingsSortInput = {
  readonly azEl?: InputMaybe<AzElProgramTrackSettingsSortInput>;
  readonly oem?: InputMaybe<OemProgramTrackSettingsSortInput>;
  readonly tle?: InputMaybe<TleProgramTrackSettingsSortInput>;
};

export type Query = {
  readonly __typename?: 'Query';
  readonly echo?: Maybe<EchoOutput>;
  readonly getConfig?: Maybe<Config>;
  readonly getContactById?: Maybe<Contact>;
  readonly getContactVersion?: Maybe<ContactVersion>;
  readonly getDataPlaneDDXMetric?: Maybe<DataPlaneDdxMetric>;
  readonly getDataPlaneLFMetric?: Maybe<DataPlaneLfMetric>;
  readonly getGsocContactV2?: Maybe<GsocContactV2>;
  readonly getLaminarFlowLossReport?: Maybe<LaminarFlowLossReportOutput>;
  readonly getMissionProfile?: Maybe<MissionProfile>;
  readonly getUserPermissionClaims: ReadonlyArray<Scalars['String']['output']>;
  readonly gsocGetContactDetails?: Maybe<GsocContactDetails>;
  readonly gsocListContactsPaginated?: Maybe<GsocListContactsPaginatedOutput>;
  readonly gsocListIamRoles?: Maybe<GsocListIamRolesOutput>;
  readonly listConfig?: Maybe<ListConfigOutput>;
  readonly listContactVersion?: Maybe<ListContactVersionOutput>;
  readonly listDataPlaneDDXMetric?: Maybe<ListDataPlaneDdxMetricOutput>;
  readonly listDataPlaneLFMetric?: Maybe<ListDataPlaneLfMetricOutput>;
  readonly listGsocContactV2?: Maybe<ListGsocContactV2Output>;
  readonly listMissionProfile?: Maybe<ListMissionProfileOutput>;
};


export type QueryEchoArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: EchoInput;
};


export type QueryGetConfigArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: GetConfigInput;
};


export type QueryGetContactByIdArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: ContactByIdInput;
};


export type QueryGetContactVersionArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: GetContactVersionInput;
};


export type QueryGetDataPlaneDdxMetricArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: GetDataPlaneDdxMetricInput;
};


export type QueryGetDataPlaneLfMetricArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: GetDataPlaneLfMetricInput;
};


export type QueryGetGsocContactV2Args = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: GetGsocContactV2Input;
};


export type QueryGetLaminarFlowLossReportArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: LaminarFlowLossReportInput;
};


export type QueryGetMissionProfileArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: GetMissionProfileInput;
};


export type QueryGsocGetContactDetailsArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: GsocGetContactDetailsInput;
};


export type QueryGsocListContactsPaginatedArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: GsocListContactsPaginatedInput;
};


export type QueryGsocListIamRolesArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListConfigArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: ListConfigInput;
};


export type QueryListContactVersionArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: ListContactVersionInput;
};


export type QueryListDataPlaneDdxMetricArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: ListDataPlaneDdxMetricInput;
};


export type QueryListDataPlaneLfMetricArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: ListDataPlaneLfMetricInput;
};


export type QueryListGsocContactV2Args = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: ListGsocContactV2Input;
};


export type QueryListMissionProfileArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: ListMissionProfileInput;
};

export enum Relation {
  Eq = 'eq',
  Gte = 'gte'
}

export type RequestedDagNodeInfo = {
  readonly __typename?: 'RequestedDagNodeInfo';
  readonly dataflowUuid?: Maybe<Scalars['String']['output']>;
  readonly region?: Maybe<Scalars['String']['output']>;
  readonly versionedConfigId?: Maybe<Scalars['String']['output']>;
  readonly vita49StreamId?: Maybe<Scalars['String']['output']>;
};

export type RequestedNodesMapEntry = {
  readonly __typename?: 'RequestedNodesMapEntry';
  readonly key?: Maybe<Scalars['String']['output']>;
  readonly value?: Maybe<RequestedDagNodeInfo>;
};

export enum ReservationStatus {
  AwsFailed = 'AWS_FAILED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Deleted = 'DELETED',
  Failed = 'FAILED',
  Pass = 'PASS',
  Postpass = 'POSTPASS',
  Prepass = 'PREPASS',
  Scheduled = 'SCHEDULED',
  Scheduling = 'SCHEDULING'
}

export type RfCharacteristics = {
  readonly __typename?: 'RfCharacteristics';
  readonly frequencyBand?: Maybe<FrequencyBand>;
  readonly polarization?: Maybe<Polarization>;
};

export type S3Object = {
  readonly __typename?: 'S3Object';
  readonly presignedUrl: Scalars['String']['output'];
  readonly s3Uri: Scalars['String']['output'];
};

export type S3ObjectFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<S3ObjectFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<S3ObjectFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<S3ObjectFilterInput>>;
  readonly s3Uri?: InputMaybe<StringFilterInput>;
};

export type S3ObjectSortInput = {
  readonly s3Uri?: InputMaybe<SortOrder>;
};

export type S3PlaybackConfigData = {
  readonly __typename?: 'S3PlaybackConfigData';
  readonly bandwidth?: Maybe<Measure>;
  readonly bucket: BucketData;
  readonly keys: ReadonlyArray<Scalars['String']['output']>;
  readonly roleArn: Scalars['String']['output'];
};

export type S3PlaybackConfigDataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<S3PlaybackConfigDataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<S3PlaybackConfigDataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<S3PlaybackConfigDataFilterInput>>;
  readonly bandwidth?: InputMaybe<MeasureFilterInput>;
  readonly bucket?: InputMaybe<BucketDataFilterInput>;
  readonly keys?: InputMaybe<StringFilterInput>;
  readonly roleArn?: InputMaybe<StringFilterInput>;
};

export type S3PlaybackConfigDataSortInput = {
  readonly bandwidth?: InputMaybe<MeasureSortInput>;
  readonly bucket?: InputMaybe<BucketDataSortInput>;
  readonly roleArn?: InputMaybe<SortOrder>;
};

export type S3RecordingConfigData = {
  readonly __typename?: 'S3RecordingConfigData';
  readonly bucket: BucketData;
  readonly prefix?: Maybe<Scalars['String']['output']>;
  readonly roleArn: Scalars['String']['output'];
};

export type S3RecordingConfigDataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<S3RecordingConfigDataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<S3RecordingConfigDataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<S3RecordingConfigDataFilterInput>>;
  readonly bucket?: InputMaybe<BucketDataFilterInput>;
  readonly prefix?: InputMaybe<StringFilterInput>;
  readonly roleArn?: InputMaybe<StringFilterInput>;
};

export type S3RecordingConfigDataSortInput = {
  readonly bucket?: InputMaybe<BucketDataSortInput>;
  readonly prefix?: InputMaybe<SortOrder>;
  readonly roleArn?: InputMaybe<SortOrder>;
};

export type SignatureMapEntry = {
  readonly __typename?: 'SignatureMapEntry';
  readonly key?: Maybe<Scalars['String']['output']>;
  readonly value?: Maybe<Scalars['Boolean']['output']>;
};

export type SignatureMapFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<SignatureMapFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<SignatureMapFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<SignatureMapFilterInput>>;
  readonly key?: InputMaybe<StringFilterInput>;
  readonly value?: InputMaybe<BooleanFilterInput>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SpectrumConfig = {
  readonly __typename?: 'SpectrumConfig';
  readonly bandwidth: Frequency;
  readonly centerFrequency: Frequency;
  readonly polarization: Polarization;
};

export type SpectrumConfigFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<SpectrumConfigFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<SpectrumConfigFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<SpectrumConfigFilterInput>>;
  readonly bandwidth?: InputMaybe<FrequencyFilterInput>;
  readonly centerFrequency?: InputMaybe<FrequencyFilterInput>;
  readonly polarization?: InputMaybe<PolarizationFilterInput>;
};

export type SpectrumConfigSortInput = {
  readonly bandwidth?: InputMaybe<FrequencySortInput>;
  readonly centerFrequency?: InputMaybe<FrequencySortInput>;
  readonly polarization?: InputMaybe<SortOrder>;
};

export type StreamsKmsKeyInfo = {
  readonly __typename?: 'StreamsKmsKeyInfo';
  readonly keyArnUsedInGrant?: Maybe<Scalars['String']['output']>;
  readonly kmsAliasArn?: Maybe<Scalars['String']['output']>;
  readonly kmsAliasName?: Maybe<Scalars['String']['output']>;
  readonly kmsKeyArn?: Maybe<Scalars['String']['output']>;
};

export type StreamsKmsKeyInfoFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<StreamsKmsKeyInfoFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<StreamsKmsKeyInfoFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<StreamsKmsKeyInfoFilterInput>>;
  readonly keyArnUsedInGrant?: InputMaybe<StringFilterInput>;
  readonly kmsAliasArn?: InputMaybe<StringFilterInput>;
  readonly kmsAliasName?: InputMaybe<StringFilterInput>;
  readonly kmsKeyArn?: InputMaybe<StringFilterInput>;
};

export type StreamsKmsKeyInfoSortInput = {
  readonly keyArnUsedInGrant?: InputMaybe<SortOrder>;
  readonly kmsAliasArn?: InputMaybe<SortOrder>;
  readonly kmsAliasName?: InputMaybe<SortOrder>;
  readonly kmsKeyArn?: InputMaybe<SortOrder>;
};

export type StringFilterInput = {
  readonly _eq?: InputMaybe<Scalars['String']['input']>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _gt?: InputMaybe<Scalars['String']['input']>;
  readonly _gte?: InputMaybe<Scalars['String']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly _lt?: InputMaybe<Scalars['String']['input']>;
  readonly _lte?: InputMaybe<Scalars['String']['input']>;
  readonly _neq?: InputMaybe<Scalars['String']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly _startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringToIntegerMapEntry = {
  readonly __typename?: 'StringToIntegerMapEntry';
  readonly key?: Maybe<Scalars['String']['output']>;
  readonly value?: Maybe<Scalars['Int']['output']>;
};

export type StringToStringMapEntry = {
  readonly __typename?: 'StringToStringMapEntry';
  readonly key?: Maybe<Scalars['String']['output']>;
  readonly value?: Maybe<Scalars['String']['output']>;
};

export type SupportedOutputType = {
  readonly __typename?: 'SupportedOutputType';
  readonly description: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
};

export type SupportedOutputTypeFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<SupportedOutputTypeFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<SupportedOutputTypeFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<SupportedOutputTypeFilterInput>>;
  readonly description?: InputMaybe<StringFilterInput>;
  readonly name?: InputMaybe<StringFilterInput>;
};

export type TelemetrySinkData = {
  readonly __typename?: 'TelemetrySinkData';
  readonly kinesisDataStream: KinesisDataStreamData;
};

export type TelemetrySinkDataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<TelemetrySinkDataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<TelemetrySinkDataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<TelemetrySinkDataFilterInput>>;
  readonly kinesisDataStream?: InputMaybe<KinesisDataStreamDataFilterInput>;
};

export type TelemetrySinkDataSortInput = {
  readonly kinesisDataStream?: InputMaybe<KinesisDataStreamDataSortInput>;
};

export type TimeRange = {
  readonly __typename?: 'TimeRange';
  readonly endTime: Scalars['AWSDateTime']['output'];
  readonly startTime: Scalars['AWSDateTime']['output'];
};

export type TimeRangeFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<TimeRangeFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<TimeRangeFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<TimeRangeFilterInput>>;
  readonly endTime?: InputMaybe<TimestampFilterInput>;
  readonly startTime?: InputMaybe<TimestampFilterInput>;
};

export type TimeRangeSortInput = {
  readonly endTime?: InputMaybe<SortOrder>;
  readonly startTime?: InputMaybe<SortOrder>;
};

export type TimestampFilterInput = {
  readonly _eq?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _gt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _gte?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['AWSDateTime']['input']>>;
  readonly _lt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _lte?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _neq?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['AWSDateTime']['input']>>;
};

export type TleProgramTrackSettings = {
  readonly __typename?: 'TleProgramTrackSettings';
  readonly ephemerisId: Scalars['String']['output'];
};

export type TleProgramTrackSettingsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<TleProgramTrackSettingsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<TleProgramTrackSettingsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<TleProgramTrackSettingsFilterInput>>;
  readonly ephemerisId?: InputMaybe<StringFilterInput>;
};

export type TleProgramTrackSettingsSortInput = {
  readonly ephemerisId?: InputMaybe<SortOrder>;
};

export type Total = {
  readonly __typename?: 'Total';
  readonly relation?: Maybe<Relation>;
  readonly value?: Maybe<Scalars['Int']['output']>;
};

export type TracerouteDetails = {
  readonly __typename?: 'TracerouteDetails';
  readonly deviceDetails?: Maybe<ReadonlyArray<PresignedDeviceDetail>>;
  readonly egressStageLossPresignedS3Url?: Maybe<ReadonlyArray<PresignedS3Metric>>;
  readonly rawTracerouteMetricsPresignedS3Url?: Maybe<ReadonlyArray<PresignedS3Metric>>;
  readonly timeDecodeLoss?: Maybe<ReadonlyArray<PresignedS3Metric>>;
};

export type TrackingConfigData = {
  readonly __typename?: 'TrackingConfigData';
  readonly autotrackCriticality: Criticality;
};

export type TrackingConfigDataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<TrackingConfigDataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<TrackingConfigDataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<TrackingConfigDataFilterInput>>;
  readonly autotrackCriticality?: InputMaybe<CriticalityFilterInput>;
};

export type TrackingConfigDataSortInput = {
  readonly autotrackCriticality?: InputMaybe<SortOrder>;
};

export type TrackingOverrides = {
  readonly __typename?: 'TrackingOverrides';
  readonly autoTrackSettings?: Maybe<AutoTrackSettings>;
  readonly programTrackSettings?: Maybe<ProgramTrackSettings>;
};

export type TrackingOverridesFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<TrackingOverridesFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<TrackingOverridesFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<TrackingOverridesFilterInput>>;
  readonly autoTrackSettings?: InputMaybe<AutoTrackSettingsFilterInput>;
  readonly programTrackSettings?: InputMaybe<ProgramTrackSettingsFilterInput>;
};

export type TrackingOverridesSortInput = {
  readonly autoTrackSettings?: InputMaybe<AutoTrackSettingsSortInput>;
  readonly programTrackSettings?: InputMaybe<ProgramTrackSettingsSortInput>;
};

export type TranslationConfiguration = {
  readonly __typename?: 'TranslationConfiguration';
  readonly laminarFlowConfig?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<DeliveryMechanism>;
  readonly vpcAttachmentDetails?: Maybe<VpcAttachmentDetails>;
};

export type TranslationConfigurationFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<TranslationConfigurationFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<TranslationConfigurationFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<TranslationConfigurationFilterInput>>;
  readonly laminarFlowConfig?: InputMaybe<StringFilterInput>;
  readonly type?: InputMaybe<DeliveryMechanismFilterInput>;
  readonly vpcAttachmentDetails?: InputMaybe<VpcAttachmentDetailsFilterInput>;
};

export type TranslationDetail = {
  readonly __typename?: 'TranslationDetail';
  readonly deliveryMechanism?: Maybe<DeliveryMechanism>;
  readonly translationConfiguration?: Maybe<TranslationConfiguration>;
};

export type TranslationDetailFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<TranslationDetailFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<TranslationDetailFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<TranslationDetailFilterInput>>;
  readonly deliveryMechanism?: InputMaybe<DeliveryMechanismFilterInput>;
  readonly translationConfiguration?: InputMaybe<TranslationConfigurationFilterInput>;
};

export type UplinkEchoConfigData = {
  readonly __typename?: 'UplinkEchoConfigData';
  readonly antennaUplinkArn: Scalars['String']['output'];
  readonly centerFrequency: Frequency;
  readonly enabled: Scalars['Boolean']['output'];
  readonly polarity: Polarization;
};

export type UplinkEchoConfigDataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<UplinkEchoConfigDataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<UplinkEchoConfigDataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<UplinkEchoConfigDataFilterInput>>;
  readonly antennaUplinkArn?: InputMaybe<StringFilterInput>;
  readonly centerFrequency?: InputMaybe<FrequencyFilterInput>;
  readonly enabled?: InputMaybe<BooleanFilterInput>;
  readonly polarity?: InputMaybe<PolarizationFilterInput>;
};

export type UplinkEchoConfigDataSortInput = {
  readonly antennaUplinkArn?: InputMaybe<SortOrder>;
  readonly centerFrequency?: InputMaybe<FrequencySortInput>;
  readonly enabled?: InputMaybe<SortOrder>;
  readonly polarity?: InputMaybe<SortOrder>;
};

export type Vita49StreamCharacteristics = {
  readonly __typename?: 'Vita49StreamCharacteristics';
  readonly vitaInterfaceType?: Maybe<Vita492SchemaType>;
  readonly vitaStreamId?: Maybe<Scalars['Int']['output']>;
};

export enum Vita492SchemaType {
  AwsGsType_1 = 'AWS_GS_TYPE_1',
  AwsGsType_2 = 'AWS_GS_TYPE_2'
}

export type VpcAttachmentDetails = {
  readonly __typename?: 'VpcAttachmentDetails';
  readonly customerRoleArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowEndpointGroupArn?: Maybe<Scalars['String']['output']>;
  readonly securityGroupIdList?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly subnetIdList?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

export type VpcAttachmentDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<VpcAttachmentDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<VpcAttachmentDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<VpcAttachmentDetailsFilterInput>>;
  readonly customerRoleArn?: InputMaybe<StringFilterInput>;
  readonly dataflowEndpointGroupArn?: InputMaybe<StringFilterInput>;
  readonly securityGroupIdList?: InputMaybe<StringFilterInput>;
  readonly subnetIdList?: InputMaybe<StringFilterInput>;
};

/**
 * A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.
 *
 * In some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.
 */
export type __Directive = {
  readonly __typename?: '__Directive';
  readonly name: Scalars['String']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly isRepeatable: Scalars['Boolean']['output'];
  readonly locations: ReadonlyArray<__DirectiveLocation>;
  readonly args: ReadonlyArray<__InputValue>;
};


/**
 * A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.
 *
 * In some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.
 */
export type __DirectiveArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies. */
export enum __DirectiveLocation {
  /** Location adjacent to a query operation. */
  Query = 'QUERY',
  /** Location adjacent to a mutation operation. */
  Mutation = 'MUTATION',
  /** Location adjacent to a subscription operation. */
  Subscription = 'SUBSCRIPTION',
  /** Location adjacent to a field. */
  Field = 'FIELD',
  /** Location adjacent to a fragment definition. */
  FragmentDefinition = 'FRAGMENT_DEFINITION',
  /** Location adjacent to a fragment spread. */
  FragmentSpread = 'FRAGMENT_SPREAD',
  /** Location adjacent to an inline fragment. */
  InlineFragment = 'INLINE_FRAGMENT',
  /** Location adjacent to a variable definition. */
  VariableDefinition = 'VARIABLE_DEFINITION',
  /** Location adjacent to a schema definition. */
  Schema = 'SCHEMA',
  /** Location adjacent to a scalar definition. */
  Scalar = 'SCALAR',
  /** Location adjacent to an object type definition. */
  Object = 'OBJECT',
  /** Location adjacent to a field definition. */
  FieldDefinition = 'FIELD_DEFINITION',
  /** Location adjacent to an argument definition. */
  ArgumentDefinition = 'ARGUMENT_DEFINITION',
  /** Location adjacent to an interface definition. */
  Interface = 'INTERFACE',
  /** Location adjacent to a union definition. */
  Union = 'UNION',
  /** Location adjacent to an enum definition. */
  Enum = 'ENUM',
  /** Location adjacent to an enum value definition. */
  EnumValue = 'ENUM_VALUE',
  /** Location adjacent to an input object type definition. */
  InputObject = 'INPUT_OBJECT',
  /** Location adjacent to an input object field definition. */
  InputFieldDefinition = 'INPUT_FIELD_DEFINITION'
}

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  readonly __typename?: '__EnumValue';
  readonly name: Scalars['String']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly isDeprecated: Scalars['Boolean']['output'];
  readonly deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  readonly __typename?: '__Field';
  readonly name: Scalars['String']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly args: ReadonlyArray<__InputValue>;
  readonly type: __Type;
  readonly isDeprecated: Scalars['Boolean']['output'];
  readonly deprecationReason?: Maybe<Scalars['String']['output']>;
};


/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  readonly __typename?: '__InputValue';
  readonly name: Scalars['String']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  readonly defaultValue?: Maybe<Scalars['String']['output']>;
  readonly isDeprecated: Scalars['Boolean']['output'];
  readonly deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations. */
export type __Schema = {
  readonly __typename?: '__Schema';
  readonly description?: Maybe<Scalars['String']['output']>;
  /** A list of all types supported by this server. */
  readonly types: ReadonlyArray<__Type>;
  /** The type that query operations will be rooted at. */
  readonly queryType: __Type;
  /** If this server supports mutation, the type that mutation operations will be rooted at. */
  readonly mutationType?: Maybe<__Type>;
  /** If this server support subscription, the type that subscription operations will be rooted at. */
  readonly subscriptionType?: Maybe<__Type>;
  /** A list of all directives supported by this server. */
  readonly directives: ReadonlyArray<__Directive>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  readonly __typename?: '__Type';
  readonly kind: __TypeKind;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly specifiedByURL?: Maybe<Scalars['String']['output']>;
  readonly fields?: Maybe<ReadonlyArray<__Field>>;
  readonly interfaces?: Maybe<ReadonlyArray<__Type>>;
  readonly possibleTypes?: Maybe<ReadonlyArray<__Type>>;
  readonly enumValues?: Maybe<ReadonlyArray<__EnumValue>>;
  readonly inputFields?: Maybe<ReadonlyArray<__InputValue>>;
  readonly ofType?: Maybe<__Type>;
  readonly isOneOf?: Maybe<Scalars['Boolean']['output']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  Scalar = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  Interface = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull = 'NON_NULL'
}

export type ListContactsQueryVariables = Exact<{
  input: ListGsocContactV2Input;
}>;


export type ListContactsQuery = { readonly __typename?: 'Query', readonly listContacts?: { readonly __typename?: 'ListGsocContactV2Output', readonly results: ReadonlyArray<{ readonly __typename?: 'GsocContactV2', readonly contactId: string, readonly contactStatus: ContactStatus, readonly failedToScheduleReasons?: ReadonlyArray<string> | null, readonly telemetryRouteList?: ReadonlyArray<string> | null, readonly schedulingRegion: string, readonly destinationRegions: ReadonlyArray<string>, readonly customer: { readonly __typename?: 'GsocCustomer', readonly awsAccountId?: string | null, readonly awsGsaasAwsAccountNamePart: string, readonly external: boolean }, readonly groundStations?: ReadonlyArray<{ readonly __typename?: 'GsocGroundStation', readonly groundStationName: string, readonly antennaName?: string | null }> | null, readonly missionProfile: { readonly __typename?: 'GsocMissionProfile', readonly missionProfileArn?: string | null, readonly missionProfileId: string }, readonly satellite?: { readonly __typename?: 'GsocSatellite', readonly satelliteCatalogNumber?: number | null, readonly satelliteName?: string | null, readonly satelliteArn?: string | null } | null, readonly timeRange: { readonly __typename?: 'TimeRange', readonly startTime: Date, readonly endTime: Date } }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null };

export type GetStatisticInformationForContactQueryVariables = Exact<{
  awsAccountId: Scalars['String']['input'];
  satelliteId?: InputMaybe<Scalars['String']['input']>;
  missionProfileArn: Scalars['String']['input'];
  groundStationName: Scalars['String']['input'];
  startTime: Scalars['AWSDateTime']['input'];
  endTime: Scalars['AWSDateTime']['input'];
}>;


export type GetStatisticInformationForContactQuery = { readonly __typename?: 'Query', readonly missionProfileCompleted?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly missionProfileFailed?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly missionProfileAwsFailed?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly missionProfileCancelled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly missionProfileAwsCancelled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly missionProfileScheduled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly missionProfileFailedToSchedule?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly satelliteCompleted?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly satelliteFailed?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly satelliteAwsFailed?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly satelliteCancelled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly satelliteAwsCancelled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly satelliteScheduled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly satelliteFailedToSchedule?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly accountCompleted?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly accountFailed?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly accountAwsFailed?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly accountCancelled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly accountAwsCancelled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly accountScheduled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly accountFailedToSchedule?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly groundStationCompleted?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly groundStationFailed?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly groundStationAwsFailed?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly groundStationCancelled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly groundStationAwsCancelled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly groundStationScheduled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly groundStationFailedToSchedule?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null };

export type GetContactQueryVariables = Exact<{
  input: GetGsocContactV2Input;
}>;


export type GetContactQuery = { readonly __typename?: 'Query', readonly getContact?: { readonly __typename?: 'GsocContactV2', readonly contactId: string, readonly contactStatus: ContactStatus, readonly failedToScheduleReasons?: ReadonlyArray<string> | null, readonly telemetryRouteList?: ReadonlyArray<string> | null, readonly schedulingRegion: string, readonly destinationRegions: ReadonlyArray<string>, readonly customer: { readonly __typename?: 'GsocCustomer', readonly awsAccountId?: string | null, readonly awsGsaasAwsAccountNamePart: string, readonly external: boolean }, readonly dataflows?: ReadonlyArray<{ readonly __typename?: 'GsocDataflowV2', readonly dataflowId: string, readonly destination: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } }> }, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null } }, readonly source: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } }> }, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null } } }> | null, readonly groundStations?: ReadonlyArray<{ readonly __typename?: 'GsocGroundStation', readonly groundStationName: string, readonly antennaName?: string | null }> | null, readonly missionProfile: { readonly __typename?: 'GsocMissionProfile', readonly missionProfileArn?: string | null, readonly missionProfileId: string }, readonly satellite?: { readonly __typename?: 'GsocSatellite', readonly satelliteCatalogNumber?: number | null, readonly satelliteName?: string | null, readonly satelliteArn?: string | null } | null, readonly timeRange: { readonly __typename?: 'TimeRange', readonly startTime: Date, readonly endTime: Date }, readonly acuPlots?: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } | null } | null };

export type GetEphemerisInfoListQueryVariables = Exact<{
  contactId: Scalars['String']['input'];
}>;


export type GetEphemerisInfoListQuery = { readonly __typename?: 'Query', readonly getGsocContactV2?: { readonly __typename?: 'GsocContactV2', readonly contactId: string, readonly ephemerisInfoList?: ReadonlyArray<{ readonly __typename?: 'EphemerisInfo', readonly ephemerisSourceType?: EphemerisSourceType | null, readonly ephemerisId: string, readonly updateTime: Date, readonly usageType: ContactEphemerisUsageType }> | null } | null };

export type GetSignatureMapQueryVariables = Exact<{
  contactId: Scalars['String']['input'];
}>;


export type GetSignatureMapQuery = { readonly __typename?: 'Query', readonly getGsocContactV2?: { readonly __typename?: 'GsocContactV2', readonly contactId: string, readonly signatureMap?: ReadonlyArray<{ readonly __typename?: 'SignatureMapEntry', readonly key?: string | null, readonly value?: boolean | null }> | null } | null };

export type ContactImagesFragment = { readonly __typename?: 'GsocContactV2', readonly dataflows?: ReadonlyArray<{ readonly __typename?: 'GsocDataflowV2', readonly dataflowId: string, readonly destination: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } }> }, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null } }, readonly source: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } }> }, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null } } }> | null, readonly acuPlots?: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } | null };

export type DataflowImagesFragment = { readonly __typename?: 'GsocDataflowV2', readonly destination: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } }> }, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly value: number, readonly unit: string } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null } }, readonly source: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } }> }, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly value: number, readonly unit: string } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null } } };

export type MinimalContactFragment = { readonly __typename?: 'GsocContactV2', readonly contactId: string, readonly contactStatus: ContactStatus, readonly failedToScheduleReasons?: ReadonlyArray<string> | null, readonly telemetryRouteList?: ReadonlyArray<string> | null, readonly schedulingRegion: string, readonly destinationRegions: ReadonlyArray<string>, readonly customer: { readonly __typename?: 'GsocCustomer', readonly awsAccountId?: string | null, readonly awsGsaasAwsAccountNamePart: string, readonly external: boolean }, readonly groundStations?: ReadonlyArray<{ readonly __typename?: 'GsocGroundStation', readonly groundStationName: string, readonly antennaName?: string | null }> | null, readonly missionProfile: { readonly __typename?: 'GsocMissionProfile', readonly missionProfileArn?: string | null, readonly missionProfileId: string }, readonly satellite?: { readonly __typename?: 'GsocSatellite', readonly satelliteCatalogNumber?: number | null, readonly satelliteName?: string | null, readonly satelliteArn?: string | null } | null, readonly timeRange: { readonly __typename?: 'TimeRange', readonly startTime: Date, readonly endTime: Date } };

export type ContactFragment = { readonly __typename?: 'GsocContactV2', readonly contactId: string, readonly contactStatus: ContactStatus, readonly failedToScheduleReasons?: ReadonlyArray<string> | null, readonly telemetryRouteList?: ReadonlyArray<string> | null, readonly schedulingRegion: string, readonly destinationRegions: ReadonlyArray<string>, readonly customer: { readonly __typename?: 'GsocCustomer', readonly awsAccountId?: string | null, readonly awsGsaasAwsAccountNamePart: string, readonly external: boolean }, readonly dataflows?: ReadonlyArray<{ readonly __typename?: 'GsocDataflowV2', readonly dataflowId: string, readonly destination: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly value: number, readonly unit: string } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null }, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } }> } }, readonly source: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly value: number, readonly unit: string } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null }, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } }> } } }> | null, readonly groundStations?: ReadonlyArray<{ readonly __typename?: 'GsocGroundStation', readonly groundStationName: string, readonly antennaName?: string | null }> | null, readonly missionProfile: { readonly __typename?: 'GsocMissionProfile', readonly missionProfileArn?: string | null, readonly missionProfileId: string }, readonly satellite?: { readonly __typename?: 'GsocSatellite', readonly satelliteCatalogNumber?: number | null, readonly satelliteName?: string | null, readonly satelliteArn?: string | null } | null, readonly timeRange: { readonly __typename?: 'TimeRange', readonly startTime: Date, readonly endTime: Date } };

export type DataflowFragment = { readonly __typename?: 'GsocDataflowV2', readonly dataflowId: string, readonly destination: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly value: number, readonly unit: string } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null }, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } }> } }, readonly source: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly value: number, readonly unit: string } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null }, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } }> } } };

export type NodeFragment = { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly value: number, readonly unit: string } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null }, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } }> } };

export type TranslationDetailFragment = { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null };

export type RfCharacteristicsFragment = { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } };

export type DataDefenderDetailsFragment = { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null };

export type SecurityDetailsFragment = { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> };

export type LaminarFlowDetailsFragment = { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null };

export type PageInfoFragment = { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } };

export type RangedConnectionDetailsFragment = { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } };

export type S3RecordingDetailsFragment = { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null };

export type S3PlaybackDetailsFragment = { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null };

export type CapabilityFragment = { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } }> };

export type NamedImageV2Fragment = { readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } };

export type S3ObjectFragment = { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string };

export type AntennaDownlinkDetailsFragment = { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } };

export type UplinkDetailsFragment = { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly value: number, readonly unit: string } };

export type UplinkEchoDetailsFragment = { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } };

export type ConnectionProxyDetailsFragment = { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null };

export type AntennaDemodDecodeDetailsFragment = { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } };

export type ManagedAntennaDemodDecodeDetailsFragment = { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } };

export type AgentDataProductContactReportsQueryVariables = Exact<{
  input: ContactByIdInput;
}>;


export type AgentDataProductContactReportsQuery = { readonly __typename?: 'Query', readonly getContactById?: { readonly __typename?: 'Contact', readonly id: string, readonly agentPostPassReports?: ReadonlyArray<{ readonly __typename?: 'AgentPostPassReport', readonly agentId: string, readonly taskDocumentId: string, readonly s3Key: string, readonly markdownText: string }> | null, readonly dataplaneReport?: { readonly __typename?: 'DataplaneReport', readonly htmlText: string } | null } | null };

export type CpsImagesQueryVariables = Exact<{
  input: ContactByIdInput;
}>;


export type CpsImagesQuery = { readonly __typename?: 'Query', readonly getContactById?: { readonly __typename?: 'Contact', readonly id: string, readonly images?: ReadonlyArray<{ readonly __typename?: 'PostPassImage', readonly dataflowId?: string | null, readonly s3Key: string, readonly jobId?: string | null, readonly presignedGetUrl?: string | null }> | null, readonly laminarFlowPlots?: ReadonlyArray<{ readonly __typename?: 'LaminarFlowPlot', readonly agentId?: string | null, readonly dataflowId?: string | null, readonly presignedGetUrl?: string | null, readonly plotName?: string | null, readonly s3Key: string }> | null } | null };

export type DataplaneVisualizationQueryVariables = Exact<{
  input: ContactByIdInput;
}>;


export type DataplaneVisualizationQuery = { readonly __typename?: 'Query', readonly getContactById?: { readonly __typename?: 'Contact', readonly id: string, readonly visualization?: { readonly __typename?: 'ContactVisualization', readonly dataplaneSvgUrlDark?: string | null, readonly dataplaneSvgUrlLight?: string | null, readonly s3Key?: string | null } | null } | null };

export type DdxMetricsResultFragment = { readonly __typename?: 'DataPlaneDDXMetric', readonly endTime: string, readonly contactId: string, readonly region: string, readonly startTime: string, readonly jobId: string, readonly streamMetrics: ReadonlyArray<{ readonly __typename?: 'DDXStreamMetric', readonly wanPacketsLost?: number | null, readonly wanPacketsReordered?: number | null, readonly wanPacketsRepaired?: number | null, readonly dataLatency?: { readonly __typename?: 'DDXStatistic', readonly avg?: number | null, readonly p99?: number | null, readonly p95?: number | null, readonly p50?: number | null } | null, readonly wanLatency?: { readonly __typename?: 'DDXStatistic', readonly avg?: number | null, readonly p99?: number | null, readonly p95?: number | null, readonly p50?: number | null } | null, readonly wanRtt?: { readonly __typename?: 'DDXStatistic', readonly avg?: number | null, readonly p99?: number | null, readonly p95?: number | null, readonly p50?: number | null } | null }> };

export type ListDdxMetricsQueryVariables = Exact<{
  where: DataPlaneDdxMetricFilterInput;
  cursor?: InputMaybe<ReadonlyArray<CursorPartInput> | CursorPartInput>;
  sort?: InputMaybe<ReadonlyArray<DataPlaneDdxMetricSortInput> | DataPlaneDdxMetricSortInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListDdxMetricsQuery = { readonly __typename?: 'Query', readonly listDataPlaneDDXMetric?: { readonly __typename?: 'ListDataPlaneDDXMetricOutput', readonly results: ReadonlyArray<{ readonly __typename?: 'DataPlaneDDXMetric', readonly endTime: string, readonly contactId: string, readonly region: string, readonly startTime: string, readonly jobId: string, readonly streamMetrics: ReadonlyArray<{ readonly __typename?: 'DDXStreamMetric', readonly wanPacketsLost?: number | null, readonly wanPacketsReordered?: number | null, readonly wanPacketsRepaired?: number | null, readonly dataLatency?: { readonly __typename?: 'DDXStatistic', readonly avg?: number | null, readonly p99?: number | null, readonly p95?: number | null, readonly p50?: number | null } | null, readonly wanLatency?: { readonly __typename?: 'DDXStatistic', readonly avg?: number | null, readonly p99?: number | null, readonly p95?: number | null, readonly p50?: number | null } | null, readonly wanRtt?: { readonly __typename?: 'DDXStatistic', readonly avg?: number | null, readonly p99?: number | null, readonly p95?: number | null, readonly p50?: number | null } | null }> }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly relation?: Relation | null, readonly value?: number | null } } } | null };

export type LfMetricsResultFragment = { readonly __typename?: 'DataPlaneLFMetric', readonly id: string, readonly contact_id: string, readonly timeStampStart?: string | null, readonly timeStampEnd?: string | null, readonly sourceRegion?: string | null, readonly destinationRegion?: string | null, readonly lfEgressStageMetricsV2?: { readonly __typename?: 'LfEgressStageMetricsV2', readonly metric__packets_lost_sequence_count?: { readonly __typename?: 'LaminarFlowMetric', readonly max?: number | null, readonly total?: number | null } | null, readonly metric__last_input_sequence_count?: { readonly __typename?: 'LaminarFlowMetric', readonly max?: number | null, readonly total?: number | null } | null, readonly metric__timestamp_delta_sec_min?: { readonly __typename?: 'LaminarFlowMetric', readonly avg?: number | null } | null, readonly metric__timestamp_delta_sec_max?: { readonly __typename?: 'LaminarFlowMetric', readonly avg?: number | null } | null } | null };

export type ListLfMetricsQueryVariables = Exact<{
  where: DataPlaneLfMetricFilterInput;
  cursor?: InputMaybe<ReadonlyArray<CursorPartInput> | CursorPartInput>;
  sort?: InputMaybe<ReadonlyArray<DataPlaneLfMetricSortInput> | DataPlaneLfMetricSortInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListLfMetricsQuery = { readonly __typename?: 'Query', readonly listDataPlaneLFMetric?: { readonly __typename?: 'ListDataPlaneLFMetricOutput', readonly results: ReadonlyArray<{ readonly __typename?: 'DataPlaneLFMetric', readonly id: string, readonly contact_id: string, readonly timeStampStart?: string | null, readonly timeStampEnd?: string | null, readonly sourceRegion?: string | null, readonly destinationRegion?: string | null, readonly lfEgressStageMetricsV2?: { readonly __typename?: 'LfEgressStageMetricsV2', readonly metric__packets_lost_sequence_count?: { readonly __typename?: 'LaminarFlowMetric', readonly max?: number | null, readonly total?: number | null } | null, readonly metric__last_input_sequence_count?: { readonly __typename?: 'LaminarFlowMetric', readonly max?: number | null, readonly total?: number | null } | null, readonly metric__timestamp_delta_sec_min?: { readonly __typename?: 'LaminarFlowMetric', readonly avg?: number | null } | null, readonly metric__timestamp_delta_sec_max?: { readonly __typename?: 'LaminarFlowMetric', readonly avg?: number | null } | null } | null }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly relation?: Relation | null, readonly value?: number | null } } } | null };

export type GsocListIamRolesQueryVariables = Exact<{
  cazJustification?: InputMaybe<Scalars['String']['input']>;
}>;


export type GsocListIamRolesQuery = { readonly __typename?: 'Query', readonly gsocListIamRoles?: { readonly __typename?: 'GsocListIamRolesOutput', readonly roles: ReadonlyArray<{ readonly __typename?: 'GsocIamRole', readonly isAuthorized: boolean, readonly name: string, readonly roleArn: string, readonly awsTemporaryCredentials?: { readonly __typename?: 'GsocAwsTemporaryCredentials', readonly accessKeyId: string, readonly expiration: Date, readonly secretAccessKey: string, readonly sessionToken: string } | null }> } | null };

export type GsocListIamRolesOutputFragment = { readonly __typename?: 'GsocListIamRolesOutput', readonly roles: ReadonlyArray<{ readonly __typename?: 'GsocIamRole', readonly isAuthorized: boolean, readonly name: string, readonly roleArn: string, readonly awsTemporaryCredentials?: { readonly __typename?: 'GsocAwsTemporaryCredentials', readonly accessKeyId: string, readonly expiration: Date, readonly secretAccessKey: string, readonly sessionToken: string } | null }> };

export type GsocIamRoleFragment = { readonly __typename?: 'GsocIamRole', readonly isAuthorized: boolean, readonly name: string, readonly roleArn: string, readonly awsTemporaryCredentials?: { readonly __typename?: 'GsocAwsTemporaryCredentials', readonly accessKeyId: string, readonly expiration: Date, readonly secretAccessKey: string, readonly sessionToken: string } | null };

export type GsocAwsTemporaryCredentialsFragment = { readonly __typename?: 'GsocAwsTemporaryCredentials', readonly accessKeyId: string, readonly expiration: Date, readonly secretAccessKey: string, readonly sessionToken: string };

export type IntrospectionQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type IntrospectionQueryQuery = { readonly __typename?: 'Query', readonly __schema: { readonly __typename?: '__Schema', readonly types: ReadonlyArray<{ readonly __typename?: '__Type', readonly name?: string | null }> } };

export type ObtainContactsOnGroundstationDuringIntervalQueryVariables = Exact<{
  where: GsocContactV2FilterInput;
  cursor?: InputMaybe<ReadonlyArray<CursorPartInput> | CursorPartInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ObtainContactsOnGroundstationDuringIntervalQuery = { readonly __typename?: 'Query', readonly listContacts?: { readonly __typename?: 'ListGsocContactV2Output', readonly results: ReadonlyArray<{ readonly __typename?: 'GsocContactV2', readonly contactId: string, readonly contactStatus: ContactStatus, readonly timeRange: { readonly __typename?: 'TimeRange', readonly endTime: Date, readonly startTime: Date }, readonly groundStations?: ReadonlyArray<{ readonly __typename?: 'GsocGroundStation', readonly groundStationName: string, readonly antennaName?: string | null }> | null, readonly satellite?: { readonly __typename?: 'GsocSatellite', readonly satelliteCatalogNumber?: number | null } | null, readonly customer: { readonly __typename?: 'GsocCustomer', readonly external: boolean } }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null } } | null };

export type ContactTimelineDataFragment = { readonly __typename?: 'GsocContactV2', readonly contactId: string, readonly contactStatus: ContactStatus, readonly timeRange: { readonly __typename?: 'TimeRange', readonly endTime: Date, readonly startTime: Date }, readonly groundStations?: ReadonlyArray<{ readonly __typename?: 'GsocGroundStation', readonly groundStationName: string, readonly antennaName?: string | null }> | null, readonly satellite?: { readonly __typename?: 'GsocSatellite', readonly satelliteCatalogNumber?: number | null } | null, readonly customer: { readonly __typename?: 'GsocCustomer', readonly external: boolean } };

export type GetUserPermissionClaimsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPermissionClaimsQuery = { readonly __typename?: 'Query', readonly getUserPermissionClaims: ReadonlyArray<string> };

export const SecurityDetailsFragmentDoc = gql`
    fragment SecurityDetails on GsocSecurityDetails {
  roleArn
  securityGroupIds
  subnetIds
}
    `;
export const DataDefenderDetailsFragmentDoc = gql`
    fragment DataDefenderDetails on GsocNodeDataplaneDataDefenderDetails {
  securityDetails {
    ...SecurityDetails
  }
  dataDeliveryServiceDestinationArn
  dataDeliveryServiceSourceArn
  vita49StreamId
}
    ${SecurityDetailsFragmentDoc}`;
export const RangedConnectionDetailsFragmentDoc = gql`
    fragment RangedConnectionDetails on GsocRangedConnectionDetails {
  name
  portRange {
    maximum
    minimum
  }
}
    `;
export const LaminarFlowDetailsFragmentDoc = gql`
    fragment LaminarFlowDetails on GsocNodeDataplaneLaminarFlowDetails {
  egressAddress {
    ...RangedConnectionDetails
  }
  ingressAddress {
    ...RangedConnectionDetails
  }
}
    ${RangedConnectionDetailsFragmentDoc}`;
export const RfCharacteristicsFragmentDoc = gql`
    fragment RfCharacteristics on GsocRfCharacteristics {
  bandwidth {
    unit
    value
  }
  centerFrequency {
    unit
    value
  }
  polarization
}
    `;
export const AntennaDownlinkDetailsFragmentDoc = gql`
    fragment AntennaDownlinkDetails on GsocAntennaDownlinkDetails {
  rfCharacteristics {
    ...RfCharacteristics
  }
}
    ${RfCharacteristicsFragmentDoc}`;
export const S3RecordingDetailsFragmentDoc = gql`
    fragment S3RecordingDetails on GsocS3RecordingDetails {
  bucketArn
  bucketRegion
  keyTemplate
  roleArn
}
    `;
export const AntennaDemodDecodeDetailsFragmentDoc = gql`
    fragment AntennaDemodDecodeDetails on GsocAntennaDemodDecodeDetails {
  decodeConfigData {
    unvalidatedJson
  }
  demodulationConfigData {
    unvalidatedJson
  }
  rfCharacteristics {
    ...RfCharacteristics
  }
}
    ${RfCharacteristicsFragmentDoc}`;
export const S3PlaybackDetailsFragmentDoc = gql`
    fragment S3PlaybackDetails on GsocS3PlaybackDetails {
  bucketArn
  bucketRegion
  roleArn
}
    `;
export const UplinkDetailsFragmentDoc = gql`
    fragment UplinkDetails on GsocUplinkDetails {
  rfCharacteristics {
    ...RfCharacteristics
  }
  targetEirp {
    value
    unit
  }
  transmitDisabled
}
    ${RfCharacteristicsFragmentDoc}`;
export const UplinkEchoDetailsFragmentDoc = gql`
    fragment UplinkEchoDetails on GsocUplinkEchoDetails {
  rfCharacteristics {
    ...RfCharacteristics
  }
  enabled
}
    ${RfCharacteristicsFragmentDoc}`;
export const TranslationDetailFragmentDoc = gql`
    fragment TranslationDetail on TranslationDetail {
  deliveryMechanism
  translationConfiguration {
    type
    laminarFlowConfig
    vpcAttachmentDetails {
      customerRoleArn
      subnetIdList
      securityGroupIdList
      dataflowEndpointGroupArn
    }
  }
}
    `;
export const ConnectionProxyDetailsFragmentDoc = gql`
    fragment ConnectionProxyDetails on GsocConnectionProxyDetails {
  configArn
  dataflowTranslation {
    ingress {
      ...TranslationDetail
    }
    egress {
      ...TranslationDetail
    }
  }
}
    ${TranslationDetailFragmentDoc}`;
export const ManagedAntennaDemodDecodeDetailsFragmentDoc = gql`
    fragment ManagedAntennaDemodDecodeDetails on GsocManagedAntennaDemodDecodeDetails {
  rfCharacteristics {
    ...RfCharacteristics
  }
  managedRadioConfigId
}
    ${RfCharacteristicsFragmentDoc}`;
export const S3ObjectFragmentDoc = gql`
    fragment S3Object on S3Object {
  s3Uri
  presignedUrl
}
    `;
export const NamedImageV2FragmentDoc = gql`
    fragment NamedImageV2 on NamedImageV2 {
  image {
    ...S3Object
  }
  name
}
    ${S3ObjectFragmentDoc}`;
export const CapabilityFragmentDoc = gql`
    fragment Capability on GsocCapabilityV2 {
  id
  type
  arn
  plots {
    ...NamedImageV2
  }
}
    ${NamedImageV2FragmentDoc}`;
export const NodeFragmentDoc = gql`
    fragment Node on GsocNodeV2 {
  config {
    type
    id
  }
  region
  telemetryInfo {
    telemetryScopeId
    telemetrySourceArn
  }
  nodeDetails {
    dataplane {
      dataflowType
      dataDefender {
        ...DataDefenderDetails
      }
      laminarFlow {
        ...LaminarFlowDetails
      }
    }
    orchestration {
      antennaDownlinkDetails {
        ...AntennaDownlinkDetails
      }
      s3RecordingDetails {
        ...S3RecordingDetails
      }
      antennaDemodDecodeDetails {
        ...AntennaDemodDecodeDetails
      }
      s3PlaybackDetails {
        ...S3PlaybackDetails
      }
      uplinkDetails {
        ...UplinkDetails
      }
      uplinkEchoDetails {
        ...UplinkEchoDetails
      }
      connectionProxyDetails {
        ...ConnectionProxyDetails
      }
      managedAntennaDemodDecodeDetails {
        ...ManagedAntennaDemodDecodeDetails
      }
    }
  }
  capability {
    ...Capability
  }
}
    ${DataDefenderDetailsFragmentDoc}
${LaminarFlowDetailsFragmentDoc}
${AntennaDownlinkDetailsFragmentDoc}
${S3RecordingDetailsFragmentDoc}
${AntennaDemodDecodeDetailsFragmentDoc}
${S3PlaybackDetailsFragmentDoc}
${UplinkDetailsFragmentDoc}
${UplinkEchoDetailsFragmentDoc}
${ConnectionProxyDetailsFragmentDoc}
${ManagedAntennaDemodDecodeDetailsFragmentDoc}
${CapabilityFragmentDoc}`;
export const DataflowFragmentDoc = gql`
    fragment Dataflow on GsocDataflowV2 {
  dataflowId
  destination {
    ...Node
  }
  source {
    ...Node
  }
}
    ${NodeFragmentDoc}`;
export const DataflowImagesFragmentDoc = gql`
    fragment DataflowImages on GsocDataflowV2 {
  destination {
    ...Node
    capability {
      ...Capability
      plots {
        ...NamedImageV2
      }
    }
  }
  source {
    ...Node
    capability {
      ...Capability
      plots {
        ...NamedImageV2
      }
    }
  }
}
    ${NodeFragmentDoc}
${CapabilityFragmentDoc}
${NamedImageV2FragmentDoc}`;
export const ContactImagesFragmentDoc = gql`
    fragment ContactImages on GsocContactV2 {
  dataflows {
    ...Dataflow
    ...DataflowImages
  }
  acuPlots {
    ...S3Object
  }
}
    ${DataflowFragmentDoc}
${DataflowImagesFragmentDoc}
${S3ObjectFragmentDoc}`;
export const MinimalContactFragmentDoc = gql`
    fragment MinimalContact on GsocContactV2 {
  contactId
  contactStatus
  customer {
    awsAccountId
    awsGsaasAwsAccountNamePart
    external
  }
  failedToScheduleReasons
  groundStations {
    groundStationName
    antennaName
  }
  missionProfile {
    missionProfileArn
    missionProfileId
  }
  telemetryRouteList
  satellite {
    satelliteCatalogNumber
    satelliteName
    satelliteArn
  }
  timeRange {
    startTime
    endTime
  }
  schedulingRegion
  destinationRegions
}
    `;
export const ContactFragmentDoc = gql`
    fragment Contact on GsocContactV2 {
  contactId
  contactStatus
  customer {
    awsAccountId
    awsGsaasAwsAccountNamePart
    external
  }
  dataflows {
    ...Dataflow
  }
  failedToScheduleReasons
  groundStations {
    groundStationName
    antennaName
  }
  missionProfile {
    missionProfileArn
    missionProfileId
  }
  satellite {
    satelliteCatalogNumber
    satelliteName
    satelliteArn
  }
  telemetryRouteList
  timeRange {
    startTime
    endTime
  }
  schedulingRegion
  destinationRegions
}
    ${DataflowFragmentDoc}`;
export const PageInfoFragmentDoc = gql`
    fragment PageInfo on PageInfo {
  lastCursor {
    key
    value
  }
  hasNextPage
  total {
    value
    relation
  }
}
    `;
export const DdxMetricsResultFragmentDoc = gql`
    fragment DDXMetricsResult on DataPlaneDDXMetric {
  endTime
  contactId
  region
  startTime
  jobId
  streamMetrics {
    dataLatency {
      avg
      p99
      p95
      p50
    }
    wanLatency {
      avg
      p99
      p95
      p50
    }
    wanRtt {
      avg
      p99
      p95
      p50
    }
    wanPacketsLost
    wanPacketsReordered
    wanPacketsRepaired
  }
}
    `;
export const LfMetricsResultFragmentDoc = gql`
    fragment LFMetricsResult on DataPlaneLFMetric {
  id
  contact_id
  timeStampStart
  timeStampEnd
  sourceRegion
  destinationRegion
  lfEgressStageMetricsV2 {
    metric__packets_lost_sequence_count {
      max
      total
    }
    metric__last_input_sequence_count {
      max
      total
    }
    metric__timestamp_delta_sec_min {
      avg
    }
    metric__timestamp_delta_sec_max {
      avg
    }
  }
}
    `;
export const GsocAwsTemporaryCredentialsFragmentDoc = gql`
    fragment GsocAwsTemporaryCredentials on GsocAwsTemporaryCredentials {
  accessKeyId
  expiration
  secretAccessKey
  sessionToken
}
    `;
export const GsocIamRoleFragmentDoc = gql`
    fragment GsocIamRole on GsocIamRole {
  isAuthorized
  name
  roleArn
  awsTemporaryCredentials {
    ...GsocAwsTemporaryCredentials
  }
}
    ${GsocAwsTemporaryCredentialsFragmentDoc}`;
export const GsocListIamRolesOutputFragmentDoc = gql`
    fragment GsocListIamRolesOutput on GsocListIamRolesOutput {
  roles {
    ...GsocIamRole
  }
}
    ${GsocIamRoleFragmentDoc}`;
export const ContactTimelineDataFragmentDoc = gql`
    fragment ContactTimelineData on GsocContactV2 {
  contactId
  contactStatus
  timeRange {
    endTime
    startTime
  }
  groundStations {
    groundStationName
    antennaName
  }
  satellite {
    satelliteCatalogNumber
  }
  customer {
    external
  }
}
    `;
export const ListContactsDocument = gql`
    query listContacts($input: ListGsocContactV2Input!) @api(name: CURATED_API) {
  listContacts: listGsocContactV2(input: $input) {
    results {
      ...MinimalContact
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${MinimalContactFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useListContactsQuery__
 *
 * To run a query within a React component, call `useListContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListContactsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListContactsQuery(baseOptions: Apollo.QueryHookOptions<ListContactsQuery, ListContactsQueryVariables> & ({ variables: ListContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListContactsQuery, ListContactsQueryVariables>(ListContactsDocument, options);
      }
export function useListContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListContactsQuery, ListContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListContactsQuery, ListContactsQueryVariables>(ListContactsDocument, options);
        }
export function useListContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListContactsQuery, ListContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListContactsQuery, ListContactsQueryVariables>(ListContactsDocument, options);
        }
export type ListContactsQueryHookResult = ReturnType<typeof useListContactsQuery>;
export type ListContactsLazyQueryHookResult = ReturnType<typeof useListContactsLazyQuery>;
export type ListContactsSuspenseQueryHookResult = ReturnType<typeof useListContactsSuspenseQuery>;
export type ListContactsQueryResult = Apollo.QueryResult<ListContactsQuery, ListContactsQueryVariables>;
export const GetStatisticInformationForContactDocument = gql`
    query getStatisticInformationForContact($awsAccountId: String!, $satelliteId: String, $missionProfileArn: String!, $groundStationName: String!, $startTime: AWSDateTime!, $endTime: AWSDateTime!) @api(name: CURATED_API) {
  missionProfileCompleted: listGsocContactV2(
    input: {where: {contactStatus: {_eq: COMPLETED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, missionProfile: {missionProfileArn: {_eq: $missionProfileArn}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  missionProfileFailed: listGsocContactV2(
    input: {where: {contactStatus: {_eq: FAILED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, missionProfile: {missionProfileArn: {_eq: $missionProfileArn}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  missionProfileAwsFailed: listGsocContactV2(
    input: {where: {contactStatus: {_eq: AWS_FAILED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, missionProfile: {missionProfileArn: {_eq: $missionProfileArn}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  missionProfileCancelled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: CANCELLED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, missionProfile: {missionProfileArn: {_eq: $missionProfileArn}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  missionProfileAwsCancelled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: AWS_CANCELLED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, missionProfile: {missionProfileArn: {_eq: $missionProfileArn}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  missionProfileScheduled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: SCHEDULED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, missionProfile: {missionProfileArn: {_eq: $missionProfileArn}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  missionProfileFailedToSchedule: listGsocContactV2(
    input: {where: {contactStatus: {_eq: FAILED_TO_SCHEDULE}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, missionProfile: {missionProfileArn: {_eq: $missionProfileArn}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  satelliteCompleted: listGsocContactV2(
    input: {where: {contactStatus: {_eq: COMPLETED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, satellite: {satelliteArn: {_eq: $satelliteId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  satelliteFailed: listGsocContactV2(
    input: {where: {contactStatus: {_eq: FAILED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, satellite: {satelliteArn: {_eq: $satelliteId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  satelliteAwsFailed: listGsocContactV2(
    input: {where: {contactStatus: {_eq: AWS_FAILED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, satellite: {satelliteArn: {_eq: $satelliteId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  satelliteCancelled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: CANCELLED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, satellite: {satelliteArn: {_eq: $satelliteId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  satelliteAwsCancelled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: AWS_CANCELLED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, satellite: {satelliteArn: {_eq: $satelliteId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  satelliteScheduled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: SCHEDULED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, satellite: {satelliteArn: {_eq: $satelliteId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  satelliteFailedToSchedule: listGsocContactV2(
    input: {where: {contactStatus: {_eq: FAILED_TO_SCHEDULE}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, satellite: {satelliteArn: {_eq: $satelliteId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  accountCompleted: listGsocContactV2(
    input: {where: {contactStatus: {_eq: COMPLETED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  accountFailed: listGsocContactV2(
    input: {where: {contactStatus: {_eq: FAILED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  accountAwsFailed: listGsocContactV2(
    input: {where: {contactStatus: {_eq: AWS_FAILED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  accountCancelled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: CANCELLED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  accountAwsCancelled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: AWS_CANCELLED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  accountScheduled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: SCHEDULED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  accountFailedToSchedule: listGsocContactV2(
    input: {where: {contactStatus: {_eq: FAILED_TO_SCHEDULE}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  groundStationCompleted: listGsocContactV2(
    input: {where: {contactStatus: {_eq: COMPLETED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, groundStations: {groundStationName: {_eq: $groundStationName}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  groundStationFailed: listGsocContactV2(
    input: {where: {contactStatus: {_eq: FAILED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, groundStations: {groundStationName: {_eq: $groundStationName}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  groundStationAwsFailed: listGsocContactV2(
    input: {where: {contactStatus: {_eq: AWS_FAILED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, groundStations: {groundStationName: {_eq: $groundStationName}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  groundStationCancelled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: CANCELLED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, groundStations: {groundStationName: {_eq: $groundStationName}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  groundStationAwsCancelled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: AWS_CANCELLED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, groundStations: {groundStationName: {_eq: $groundStationName}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  groundStationScheduled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: SCHEDULED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, groundStations: {groundStationName: {_eq: $groundStationName}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  groundStationFailedToSchedule: listGsocContactV2(
    input: {where: {contactStatus: {_eq: FAILED_TO_SCHEDULE}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, groundStations: {groundStationName: {_eq: $groundStationName}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useGetStatisticInformationForContactQuery__
 *
 * To run a query within a React component, call `useGetStatisticInformationForContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatisticInformationForContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatisticInformationForContactQuery({
 *   variables: {
 *      awsAccountId: // value for 'awsAccountId'
 *      satelliteId: // value for 'satelliteId'
 *      missionProfileArn: // value for 'missionProfileArn'
 *      groundStationName: // value for 'groundStationName'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useGetStatisticInformationForContactQuery(baseOptions: Apollo.QueryHookOptions<GetStatisticInformationForContactQuery, GetStatisticInformationForContactQueryVariables> & ({ variables: GetStatisticInformationForContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatisticInformationForContactQuery, GetStatisticInformationForContactQueryVariables>(GetStatisticInformationForContactDocument, options);
      }
export function useGetStatisticInformationForContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatisticInformationForContactQuery, GetStatisticInformationForContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatisticInformationForContactQuery, GetStatisticInformationForContactQueryVariables>(GetStatisticInformationForContactDocument, options);
        }
export function useGetStatisticInformationForContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStatisticInformationForContactQuery, GetStatisticInformationForContactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStatisticInformationForContactQuery, GetStatisticInformationForContactQueryVariables>(GetStatisticInformationForContactDocument, options);
        }
export type GetStatisticInformationForContactQueryHookResult = ReturnType<typeof useGetStatisticInformationForContactQuery>;
export type GetStatisticInformationForContactLazyQueryHookResult = ReturnType<typeof useGetStatisticInformationForContactLazyQuery>;
export type GetStatisticInformationForContactSuspenseQueryHookResult = ReturnType<typeof useGetStatisticInformationForContactSuspenseQuery>;
export type GetStatisticInformationForContactQueryResult = Apollo.QueryResult<GetStatisticInformationForContactQuery, GetStatisticInformationForContactQueryVariables>;
export const GetContactDocument = gql`
    query getContact($input: GetGsocContactV2Input!) @api(name: CURATED_API) {
  getContact: getGsocContactV2(input: $input) {
    ...Contact
    ...ContactImages
  }
}
    ${ContactFragmentDoc}
${ContactImagesFragmentDoc}`;

/**
 * __useGetContactQuery__
 *
 * To run a query within a React component, call `useGetContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetContactQuery(baseOptions: Apollo.QueryHookOptions<GetContactQuery, GetContactQueryVariables> & ({ variables: GetContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
      }
export function useGetContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
        }
export function useGetContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
        }
export type GetContactQueryHookResult = ReturnType<typeof useGetContactQuery>;
export type GetContactLazyQueryHookResult = ReturnType<typeof useGetContactLazyQuery>;
export type GetContactSuspenseQueryHookResult = ReturnType<typeof useGetContactSuspenseQuery>;
export type GetContactQueryResult = Apollo.QueryResult<GetContactQuery, GetContactQueryVariables>;
export const GetEphemerisInfoListDocument = gql`
    query getEphemerisInfoList($contactId: String!) @api(name: CURATED_API) {
  getGsocContactV2(input: {contactId: $contactId}) {
    contactId
    ephemerisInfoList {
      ephemerisSourceType
      ephemerisId
      updateTime
      usageType
    }
  }
}
    `;

/**
 * __useGetEphemerisInfoListQuery__
 *
 * To run a query within a React component, call `useGetEphemerisInfoListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEphemerisInfoListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEphemerisInfoListQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetEphemerisInfoListQuery(baseOptions: Apollo.QueryHookOptions<GetEphemerisInfoListQuery, GetEphemerisInfoListQueryVariables> & ({ variables: GetEphemerisInfoListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEphemerisInfoListQuery, GetEphemerisInfoListQueryVariables>(GetEphemerisInfoListDocument, options);
      }
export function useGetEphemerisInfoListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEphemerisInfoListQuery, GetEphemerisInfoListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEphemerisInfoListQuery, GetEphemerisInfoListQueryVariables>(GetEphemerisInfoListDocument, options);
        }
export function useGetEphemerisInfoListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEphemerisInfoListQuery, GetEphemerisInfoListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEphemerisInfoListQuery, GetEphemerisInfoListQueryVariables>(GetEphemerisInfoListDocument, options);
        }
export type GetEphemerisInfoListQueryHookResult = ReturnType<typeof useGetEphemerisInfoListQuery>;
export type GetEphemerisInfoListLazyQueryHookResult = ReturnType<typeof useGetEphemerisInfoListLazyQuery>;
export type GetEphemerisInfoListSuspenseQueryHookResult = ReturnType<typeof useGetEphemerisInfoListSuspenseQuery>;
export type GetEphemerisInfoListQueryResult = Apollo.QueryResult<GetEphemerisInfoListQuery, GetEphemerisInfoListQueryVariables>;
export const GetSignatureMapDocument = gql`
    query getSignatureMap($contactId: String!) @api(name: CURATED_API) {
  getGsocContactV2(input: {contactId: $contactId}) {
    contactId
    signatureMap {
      key
      value
    }
  }
}
    `;

/**
 * __useGetSignatureMapQuery__
 *
 * To run a query within a React component, call `useGetSignatureMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignatureMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignatureMapQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetSignatureMapQuery(baseOptions: Apollo.QueryHookOptions<GetSignatureMapQuery, GetSignatureMapQueryVariables> & ({ variables: GetSignatureMapQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignatureMapQuery, GetSignatureMapQueryVariables>(GetSignatureMapDocument, options);
      }
export function useGetSignatureMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignatureMapQuery, GetSignatureMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignatureMapQuery, GetSignatureMapQueryVariables>(GetSignatureMapDocument, options);
        }
export function useGetSignatureMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSignatureMapQuery, GetSignatureMapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSignatureMapQuery, GetSignatureMapQueryVariables>(GetSignatureMapDocument, options);
        }
export type GetSignatureMapQueryHookResult = ReturnType<typeof useGetSignatureMapQuery>;
export type GetSignatureMapLazyQueryHookResult = ReturnType<typeof useGetSignatureMapLazyQuery>;
export type GetSignatureMapSuspenseQueryHookResult = ReturnType<typeof useGetSignatureMapSuspenseQuery>;
export type GetSignatureMapQueryResult = Apollo.QueryResult<GetSignatureMapQuery, GetSignatureMapQueryVariables>;
export const AgentDataProductContactReportsDocument = gql`
    query agentDataProductContactReports($input: ContactByIdInput!) @api(name: DATA_PLANE_API) {
  getContactById(input: $input) {
    id
    agentPostPassReports {
      agentId
      taskDocumentId
      s3Key
      markdownText
    }
    dataplaneReport {
      htmlText
    }
  }
}
    `;

/**
 * __useAgentDataProductContactReportsQuery__
 *
 * To run a query within a React component, call `useAgentDataProductContactReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentDataProductContactReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentDataProductContactReportsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAgentDataProductContactReportsQuery(baseOptions: Apollo.QueryHookOptions<AgentDataProductContactReportsQuery, AgentDataProductContactReportsQueryVariables> & ({ variables: AgentDataProductContactReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentDataProductContactReportsQuery, AgentDataProductContactReportsQueryVariables>(AgentDataProductContactReportsDocument, options);
      }
export function useAgentDataProductContactReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentDataProductContactReportsQuery, AgentDataProductContactReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentDataProductContactReportsQuery, AgentDataProductContactReportsQueryVariables>(AgentDataProductContactReportsDocument, options);
        }
export function useAgentDataProductContactReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentDataProductContactReportsQuery, AgentDataProductContactReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentDataProductContactReportsQuery, AgentDataProductContactReportsQueryVariables>(AgentDataProductContactReportsDocument, options);
        }
export type AgentDataProductContactReportsQueryHookResult = ReturnType<typeof useAgentDataProductContactReportsQuery>;
export type AgentDataProductContactReportsLazyQueryHookResult = ReturnType<typeof useAgentDataProductContactReportsLazyQuery>;
export type AgentDataProductContactReportsSuspenseQueryHookResult = ReturnType<typeof useAgentDataProductContactReportsSuspenseQuery>;
export type AgentDataProductContactReportsQueryResult = Apollo.QueryResult<AgentDataProductContactReportsQuery, AgentDataProductContactReportsQueryVariables>;
export const CpsImagesDocument = gql`
    query cpsImages($input: ContactByIdInput!) @api(name: DATA_PLANE_API) {
  getContactById(input: $input) {
    id
    images {
      dataflowId
      s3Key
      jobId
      presignedGetUrl
    }
    laminarFlowPlots {
      agentId
      dataflowId
      presignedGetUrl
      plotName
      s3Key
    }
  }
}
    `;

/**
 * __useCpsImagesQuery__
 *
 * To run a query within a React component, call `useCpsImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCpsImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCpsImagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCpsImagesQuery(baseOptions: Apollo.QueryHookOptions<CpsImagesQuery, CpsImagesQueryVariables> & ({ variables: CpsImagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CpsImagesQuery, CpsImagesQueryVariables>(CpsImagesDocument, options);
      }
export function useCpsImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CpsImagesQuery, CpsImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CpsImagesQuery, CpsImagesQueryVariables>(CpsImagesDocument, options);
        }
export function useCpsImagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CpsImagesQuery, CpsImagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CpsImagesQuery, CpsImagesQueryVariables>(CpsImagesDocument, options);
        }
export type CpsImagesQueryHookResult = ReturnType<typeof useCpsImagesQuery>;
export type CpsImagesLazyQueryHookResult = ReturnType<typeof useCpsImagesLazyQuery>;
export type CpsImagesSuspenseQueryHookResult = ReturnType<typeof useCpsImagesSuspenseQuery>;
export type CpsImagesQueryResult = Apollo.QueryResult<CpsImagesQuery, CpsImagesQueryVariables>;
export const DataplaneVisualizationDocument = gql`
    query dataplaneVisualization($input: ContactByIdInput!) @api(name: DATA_PLANE_API) {
  getContactById(input: $input) {
    id
    visualization {
      dataplaneSvgUrlDark
      dataplaneSvgUrlLight
      s3Key
    }
  }
}
    `;

/**
 * __useDataplaneVisualizationQuery__
 *
 * To run a query within a React component, call `useDataplaneVisualizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataplaneVisualizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataplaneVisualizationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDataplaneVisualizationQuery(baseOptions: Apollo.QueryHookOptions<DataplaneVisualizationQuery, DataplaneVisualizationQueryVariables> & ({ variables: DataplaneVisualizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataplaneVisualizationQuery, DataplaneVisualizationQueryVariables>(DataplaneVisualizationDocument, options);
      }
export function useDataplaneVisualizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataplaneVisualizationQuery, DataplaneVisualizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataplaneVisualizationQuery, DataplaneVisualizationQueryVariables>(DataplaneVisualizationDocument, options);
        }
export function useDataplaneVisualizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataplaneVisualizationQuery, DataplaneVisualizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataplaneVisualizationQuery, DataplaneVisualizationQueryVariables>(DataplaneVisualizationDocument, options);
        }
export type DataplaneVisualizationQueryHookResult = ReturnType<typeof useDataplaneVisualizationQuery>;
export type DataplaneVisualizationLazyQueryHookResult = ReturnType<typeof useDataplaneVisualizationLazyQuery>;
export type DataplaneVisualizationSuspenseQueryHookResult = ReturnType<typeof useDataplaneVisualizationSuspenseQuery>;
export type DataplaneVisualizationQueryResult = Apollo.QueryResult<DataplaneVisualizationQuery, DataplaneVisualizationQueryVariables>;
export const ListDdxMetricsDocument = gql`
    query listDDXMetrics($where: DataPlaneDDXMetricFilterInput!, $cursor: [CursorPartInput!], $sort: [DataPlaneDDXMetricSortInput!], $limit: Int) @api(name: DATA_PLANE_API) {
  listDataPlaneDDXMetric(
    input: {limit: $limit, where: $where, sort: $sort, cursor: $cursor}
  ) {
    results {
      ...DDXMetricsResult
    }
    pageInfo {
      hasNextPage
      lastCursor {
        key
        value
      }
      total {
        relation
        value
      }
    }
  }
}
    ${DdxMetricsResultFragmentDoc}`;

/**
 * __useListDdxMetricsQuery__
 *
 * To run a query within a React component, call `useListDdxMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDdxMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDdxMetricsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListDdxMetricsQuery(baseOptions: Apollo.QueryHookOptions<ListDdxMetricsQuery, ListDdxMetricsQueryVariables> & ({ variables: ListDdxMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDdxMetricsQuery, ListDdxMetricsQueryVariables>(ListDdxMetricsDocument, options);
      }
export function useListDdxMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDdxMetricsQuery, ListDdxMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDdxMetricsQuery, ListDdxMetricsQueryVariables>(ListDdxMetricsDocument, options);
        }
export function useListDdxMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDdxMetricsQuery, ListDdxMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDdxMetricsQuery, ListDdxMetricsQueryVariables>(ListDdxMetricsDocument, options);
        }
export type ListDdxMetricsQueryHookResult = ReturnType<typeof useListDdxMetricsQuery>;
export type ListDdxMetricsLazyQueryHookResult = ReturnType<typeof useListDdxMetricsLazyQuery>;
export type ListDdxMetricsSuspenseQueryHookResult = ReturnType<typeof useListDdxMetricsSuspenseQuery>;
export type ListDdxMetricsQueryResult = Apollo.QueryResult<ListDdxMetricsQuery, ListDdxMetricsQueryVariables>;
export const ListLfMetricsDocument = gql`
    query listLFMetrics($where: DataPlaneLFMetricFilterInput!, $cursor: [CursorPartInput!], $sort: [DataPlaneLFMetricSortInput!], $limit: Int) @api(name: DATA_PLANE_API) {
  listDataPlaneLFMetric(
    input: {limit: $limit, where: $where, sort: $sort, cursor: $cursor}
  ) {
    results {
      ...LFMetricsResult
    }
    pageInfo {
      hasNextPage
      lastCursor {
        key
        value
      }
      total {
        relation
        value
      }
    }
  }
}
    ${LfMetricsResultFragmentDoc}`;

/**
 * __useListLfMetricsQuery__
 *
 * To run a query within a React component, call `useListLfMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLfMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLfMetricsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListLfMetricsQuery(baseOptions: Apollo.QueryHookOptions<ListLfMetricsQuery, ListLfMetricsQueryVariables> & ({ variables: ListLfMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLfMetricsQuery, ListLfMetricsQueryVariables>(ListLfMetricsDocument, options);
      }
export function useListLfMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLfMetricsQuery, ListLfMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLfMetricsQuery, ListLfMetricsQueryVariables>(ListLfMetricsDocument, options);
        }
export function useListLfMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLfMetricsQuery, ListLfMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListLfMetricsQuery, ListLfMetricsQueryVariables>(ListLfMetricsDocument, options);
        }
export type ListLfMetricsQueryHookResult = ReturnType<typeof useListLfMetricsQuery>;
export type ListLfMetricsLazyQueryHookResult = ReturnType<typeof useListLfMetricsLazyQuery>;
export type ListLfMetricsSuspenseQueryHookResult = ReturnType<typeof useListLfMetricsSuspenseQuery>;
export type ListLfMetricsQueryResult = Apollo.QueryResult<ListLfMetricsQuery, ListLfMetricsQueryVariables>;
export const GsocListIamRolesDocument = gql`
    query gsocListIamRoles($cazJustification: String) @api(name: CURATED_API) {
  gsocListIamRoles(cazJustification: $cazJustification) {
    ...GsocListIamRolesOutput
  }
}
    ${GsocListIamRolesOutputFragmentDoc}`;

/**
 * __useGsocListIamRolesQuery__
 *
 * To run a query within a React component, call `useGsocListIamRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGsocListIamRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGsocListIamRolesQuery({
 *   variables: {
 *      cazJustification: // value for 'cazJustification'
 *   },
 * });
 */
export function useGsocListIamRolesQuery(baseOptions?: Apollo.QueryHookOptions<GsocListIamRolesQuery, GsocListIamRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GsocListIamRolesQuery, GsocListIamRolesQueryVariables>(GsocListIamRolesDocument, options);
      }
export function useGsocListIamRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GsocListIamRolesQuery, GsocListIamRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GsocListIamRolesQuery, GsocListIamRolesQueryVariables>(GsocListIamRolesDocument, options);
        }
export function useGsocListIamRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GsocListIamRolesQuery, GsocListIamRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GsocListIamRolesQuery, GsocListIamRolesQueryVariables>(GsocListIamRolesDocument, options);
        }
export type GsocListIamRolesQueryHookResult = ReturnType<typeof useGsocListIamRolesQuery>;
export type GsocListIamRolesLazyQueryHookResult = ReturnType<typeof useGsocListIamRolesLazyQuery>;
export type GsocListIamRolesSuspenseQueryHookResult = ReturnType<typeof useGsocListIamRolesSuspenseQuery>;
export type GsocListIamRolesQueryResult = Apollo.QueryResult<GsocListIamRolesQuery, GsocListIamRolesQueryVariables>;
export const IntrospectionQueryDocument = gql`
    query IntrospectionQuery {
  __schema {
    types {
      name
    }
  }
}
    `;

/**
 * __useIntrospectionQueryQuery__
 *
 * To run a query within a React component, call `useIntrospectionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntrospectionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntrospectionQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntrospectionQueryQuery(baseOptions?: Apollo.QueryHookOptions<IntrospectionQueryQuery, IntrospectionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntrospectionQueryQuery, IntrospectionQueryQueryVariables>(IntrospectionQueryDocument, options);
      }
export function useIntrospectionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntrospectionQueryQuery, IntrospectionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntrospectionQueryQuery, IntrospectionQueryQueryVariables>(IntrospectionQueryDocument, options);
        }
export function useIntrospectionQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntrospectionQueryQuery, IntrospectionQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntrospectionQueryQuery, IntrospectionQueryQueryVariables>(IntrospectionQueryDocument, options);
        }
export type IntrospectionQueryQueryHookResult = ReturnType<typeof useIntrospectionQueryQuery>;
export type IntrospectionQueryLazyQueryHookResult = ReturnType<typeof useIntrospectionQueryLazyQuery>;
export type IntrospectionQuerySuspenseQueryHookResult = ReturnType<typeof useIntrospectionQuerySuspenseQuery>;
export type IntrospectionQueryQueryResult = Apollo.QueryResult<IntrospectionQueryQuery, IntrospectionQueryQueryVariables>;
export const ObtainContactsOnGroundstationDuringIntervalDocument = gql`
    query ObtainContactsOnGroundstationDuringInterval($where: GsocContactV2FilterInput!, $cursor: [CursorPartInput!], $limit: Int) @api(name: CURATED_API) {
  listContacts: listGsocContactV2(
    input: {limit: $limit, where: $where, sort: {timeRange: {startTime: asc}}, cursor: $cursor}
  ) {
    results {
      ...ContactTimelineData
    }
    pageInfo {
      hasNextPage
      lastCursor {
        key
        value
      }
    }
  }
}
    ${ContactTimelineDataFragmentDoc}`;

/**
 * __useObtainContactsOnGroundstationDuringIntervalQuery__
 *
 * To run a query within a React component, call `useObtainContactsOnGroundstationDuringIntervalQuery` and pass it any options that fit your needs.
 * When your component renders, `useObtainContactsOnGroundstationDuringIntervalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObtainContactsOnGroundstationDuringIntervalQuery({
 *   variables: {
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useObtainContactsOnGroundstationDuringIntervalQuery(baseOptions: Apollo.QueryHookOptions<ObtainContactsOnGroundstationDuringIntervalQuery, ObtainContactsOnGroundstationDuringIntervalQueryVariables> & ({ variables: ObtainContactsOnGroundstationDuringIntervalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ObtainContactsOnGroundstationDuringIntervalQuery, ObtainContactsOnGroundstationDuringIntervalQueryVariables>(ObtainContactsOnGroundstationDuringIntervalDocument, options);
      }
export function useObtainContactsOnGroundstationDuringIntervalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ObtainContactsOnGroundstationDuringIntervalQuery, ObtainContactsOnGroundstationDuringIntervalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ObtainContactsOnGroundstationDuringIntervalQuery, ObtainContactsOnGroundstationDuringIntervalQueryVariables>(ObtainContactsOnGroundstationDuringIntervalDocument, options);
        }
export function useObtainContactsOnGroundstationDuringIntervalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ObtainContactsOnGroundstationDuringIntervalQuery, ObtainContactsOnGroundstationDuringIntervalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ObtainContactsOnGroundstationDuringIntervalQuery, ObtainContactsOnGroundstationDuringIntervalQueryVariables>(ObtainContactsOnGroundstationDuringIntervalDocument, options);
        }
export type ObtainContactsOnGroundstationDuringIntervalQueryHookResult = ReturnType<typeof useObtainContactsOnGroundstationDuringIntervalQuery>;
export type ObtainContactsOnGroundstationDuringIntervalLazyQueryHookResult = ReturnType<typeof useObtainContactsOnGroundstationDuringIntervalLazyQuery>;
export type ObtainContactsOnGroundstationDuringIntervalSuspenseQueryHookResult = ReturnType<typeof useObtainContactsOnGroundstationDuringIntervalSuspenseQuery>;
export type ObtainContactsOnGroundstationDuringIntervalQueryResult = Apollo.QueryResult<ObtainContactsOnGroundstationDuringIntervalQuery, ObtainContactsOnGroundstationDuringIntervalQueryVariables>;
export const GetUserPermissionClaimsDocument = gql`
    query getUserPermissionClaims @api(name: CURATED_API) {
  getUserPermissionClaims
}
    `;

/**
 * __useGetUserPermissionClaimsQuery__
 *
 * To run a query within a React component, call `useGetUserPermissionClaimsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPermissionClaimsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPermissionClaimsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPermissionClaimsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserPermissionClaimsQuery, GetUserPermissionClaimsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPermissionClaimsQuery, GetUserPermissionClaimsQueryVariables>(GetUserPermissionClaimsDocument, options);
      }
export function useGetUserPermissionClaimsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPermissionClaimsQuery, GetUserPermissionClaimsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPermissionClaimsQuery, GetUserPermissionClaimsQueryVariables>(GetUserPermissionClaimsDocument, options);
        }
export function useGetUserPermissionClaimsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPermissionClaimsQuery, GetUserPermissionClaimsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPermissionClaimsQuery, GetUserPermissionClaimsQueryVariables>(GetUserPermissionClaimsDocument, options);
        }
export type GetUserPermissionClaimsQueryHookResult = ReturnType<typeof useGetUserPermissionClaimsQuery>;
export type GetUserPermissionClaimsLazyQueryHookResult = ReturnType<typeof useGetUserPermissionClaimsLazyQuery>;
export type GetUserPermissionClaimsSuspenseQueryHookResult = ReturnType<typeof useGetUserPermissionClaimsSuspenseQuery>;
export type GetUserPermissionClaimsQueryResult = Apollo.QueryResult<GetUserPermissionClaimsQuery, GetUserPermissionClaimsQueryVariables>;